import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  Component
} from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";


import { IntlProvider } from "react-intl";

import { CssCounter } from '../uikit2';
import PAh2 from "../PAh2";
import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Dropdown,
  ContentBlock,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import "./css/normalize.css";
// import './css/publisher-sb.webflow.css';
import "./css/webflow.css";

export function Sb0({product, logo}) {
  const [shown, setShown] = useState();
  const [prod, setProd] = useState(product);

  return (
    <div data-scroll-time="0.2" className="xbdy">
      <div className="sb0">
        <div className="w-embed">
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n.xui_menu_li .xui_menu_icon {\n  display: none;\n}\n.xui_menu_li.w--current .xui_menu_icon {\n  display: flex;\n}\n.xsb_sett_toggle_b .xsb_sett_toggle_t {\n  background-color: currentColor;\n}\n.xsb_sett_toggle_b.inactive .xsb_sett_toggle_t {\n  background-color: currentColor;\n}\n\n.a {\ncolor: currentColor;\n}\n"
            }}
          />
        </div>
        <div className="x0">


        </div>
        <div className="xc">
          <div className="xccm">
            <div className="xcc">
              <div className="xccl">
                <div>


                  {/* BB */}
                  {!prod || prod === 'game_store' && <SBbb/>}

                  {/* PS */}
                  {!prod || prod === 'pay_station' && <SBps/>}


                  {/* LOGIN */}
                  {!prod || prod === 'login' && <SBlogin/>}


                  {/* LAUNCHER */}
                  {!prod || prod === 'launcher' && <SBlnch/>}

                  {/* USER ACC */}
                  {!prod || prod === 'store' && <SBua/>}

                </div>
              </div>
            </div>
          </div>
          {/* <div className="xbg" /> */}
        </div>
      </div>
    </div>
  );
}



export const SbTopBar = ({logo})=> {
  return (

    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      }}
    >



    <ContentBlock appearance="flatten"
    >

    <div
    // style={{padding: '0 24px'}}
    className="x00">
      <div className="x0_selector" style={{}}>
        <div className="x0_selector_inner">
          <div className="x0_groups">
            <div className="x0_li">
              <div className="x_sectionhover">
                <div className="x0_d0 x0_d0--site">
                  <div className="x0_d0_bg">
                    <div className="x_contentimage">
                      <div className="x_contentimage_tint">
                        <div className="x_temp_tint_1" />
                      </div>
                      <div className="x_contentimage_static">
                        <div className="x_temp_pic1" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="x0_li_name">
                <div>
                  my_awesome_game_1...
                  <br />
                  Unpublished Changes
                </div>
              </div>
            </div>
            <div className="x0_li">
              <div className="x_sectionhover">
                <div className="x0_d0 x0_d0--site">
                  <div className="x0_d0_bg">
                    <div className="x_contentimage">
                      <div className="x_contentimage_tint">
                        <div className="x_temp_tint_2" />
                      </div>
                      <div className="x_contentimage_static">
                        <div className="x_temp_pic1" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="x0_li_name">
                <div>
                  my_awesome_game_1...
                  <br />
                  Unpublished Changes
                </div>
              </div>
            </div>
            <div className="x0_li">
              <div className="x_sectionhover">
                <div className="x0_d0 x0_d0--site">
                  <div className="x0_d0_add">
                    <div>add_circle</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="x0_groups">
            <div className="x0_li">
              <div className="x_sectionhover">
                <div className="x0_d0 x0_d0--widget">
                  <div className="x0_d0_bg">
                    <div className="x_contentimage">
                      <div className="x_contentimage_tint">
                        <div className="x_temp_tint_1" />
                      </div>
                      <div className="x_contentimage_static">
                        <div className="x_temp_pic1" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="x0_li_name">
                <div>
                  my_awesome_game_1...
                  <br />
                  Unpublished Changes
                </div>
              </div>
            </div>
            <div className="x0_li">
              <div className="x_sectionhover">
                <div className="x0_d0 x0_d0--widget">
                  <div className="x0_d0_add">
                    <div>add_circle</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="x0_idle">


        {logo && <div className="x0_current">
          <a
            href="#store0"
            className="p_x_builder_logo w-inline-block w--current"
          >
            <div className="p_x_builder_logo_ic p_x_builder_logo_ic--store" />
            <div className="p_x_builder_logo_txt">Store</div>
            <div className="p_x_builder_logo_txt p_x_builder_logo_txt--2">
              Builder
            </div>
          </a>
          <a href="#ps0" className="p_x_builder_logo w-inline-block">
            <div className="p_x_builder_logo_ic p_x_builder_logo_ic--payst" />
            <div className="p_x_builder_logo_txt">Pay Station</div>
            <div className="p_x_builder_logo_txt p_x_builder_logo_txt--2">
              editor
            </div>
          </a>
          <a href="#login0" className="p_x_builder_logo w-inline-block">
            <div className="p_x_builder_logo_ic p_x_builder_logo_ic--login" />
            <div className="p_x_builder_logo_txt">Login</div>
            <div className="p_x_builder_logo_txt p_x_builder_logo_txt--2">
              Editor
            </div>
          </a>
        </div>}


        <div className="x0_center">
          <div className="x0_top_screens0">
            <div className="x0_top_lang0">
              <div className="xsb_top_lang">
                <div className="xsb_top_lang_label">
                  Preview language:
                </div>
                <div className="xsb_but_link_input xsb_but_link_input--inline">
                  <div className="xsb_but_seturl_placeholder xsb_but_seturl_placeholder--inline">
                    <div>English</div>
                  </div>
                  <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                    <div>expand_more</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="x0_top_screens">
              <div className="p_x_sol_all">
                <div className="p_button p_button--appearance-flatten">
                  <div>desktop</div>
                </div>
                <div className="p_x_card_filter_div" />
                <div className="p_button p_button--appearance-flatten inactive">
                  <div>tablet</div>
                </div>
                <div className="p_x_card_filter_div" />
                <div className="p_button p_button--appearance-flatten inactive">
                  <div>mobile</div>
                </div>
              </div>
            </div>

        <div className="x0_right">
          <div className="xsb_saving_login">
            <div className="xsb_saved_icon">
              <div>check</div>
            </div>
            <div className="xsb_saving_label">
              <div>Saved</div>
            </div>
          </div>


          {/* <div className="x0_right_pub">
            <div
              data-xsb-settings-media="clear"
              className="p_button p_button--appearance-secondary"
            >
              <div>Publish</div>
            </div>
          </div> */}

          {/* <div className="x0_close">
            <div>close</div>
          </div> */}
        </div>
      </div>
    </div>

    </ContentBlock>
    </div>
  )
}



export const SBbb =({}) => {
  return (
    <div className="p_x_module0">

    {/* <h1 className="p_x_h1_graphic">Game stores</h1> */}
<PAh2 title="Game stores"/>


<SbTopBar/>

    <div id="store0" className="p_x_module_grid">
      <div className="l_sb0">
        <div id="store_widget1" className="p_x_anchor" />
        <div className="x_left0">
          <div className="x_left0_sticky">
            <div className="xx_set_head xx_set_head--main">
              <div>
                <div data-xsb-settings-module-onoff="w_pack1">
                  <div className="t_h2 t_bold">
                    Button widget
                  </div>
                </div>
              </div>
            </div>
            <div className="xsb_sett_block0">
              <div
                data-xsb-settings-module="onoff"
                data-xsb-settings-module-onoff-activetarget="w_buy"
                className="xx_set_sect xx_set_sect--bg"
              >
                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                  <div className="l_width100">
                    <div className="xsb_sett_toggle0">
                      <div className="xsb_sett_toggle_b inactive">
                        <div className="xsb_sett_toggle_t" />
                      </div>
                      <div
                        data-xsb-settings-module-onoff="hero_w_logo"
                        className="xsb_sett_toggle_label"
                      >
                        <div>Button image</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-xsb-settings-module="onoff"
                data-xsb-settings-module-onoff-activetarget="w_buy"
                className="xx_set_sect xx_set_sect--nohover"
              >
                <div className="l_flex">
                  <div
                    data-xsb-settings-media="clear"
                    className="p_button p_button--appearance-secondary"
                  >
                    <div>Copy widget COde</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="x_right0">
          <div className="x_flex x_flex--center">
            <div
              data-xsb-template-type="ps_card"
              className="xsb_c"
            >
              <div className="p_formgroup_xlg p_formgroup_xlg--top">
                <div className="xsbps_b xsbps_b--rel">
                  <div className="xsb_c_width">
                    <div className="xsb_c_paddings">
                      <div className="l_flex l_flex--center l_flex--middle">
                        <div className="button_primary x_radius">
                          <div>Buy Now $9.99</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="temp_settings-2" />
            </div>
          </div>
          <div className="xccz xccz--rel">
            <div className="x_contentimage">
              <div className="x_contentimage_tint">
                <section
                  id="xsbm_login_w1"
                  className="x_temp_tint_1 x_temp_tint_1--dark"
                />
              </div>
              <div className="x_contentimage_static">
                <div className="x_temp_pic1" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="l_sb0">
        <div className="l_sb0">
          <div id="store_widget2" className="p_x_anchor" />
          <div className="x_left0">
            <div className="x_left0_sticky">
              <div className="xx_set_head xx_set_head--main">
                <div>
                  <div data-xsb-settings-module-onoff="w_pack1">
                    <div className="t_h2 t_bold">
                      Responsive widget
                    </div>
                  </div>
                </div>
              </div>
              <div className="xsb_sett_block0">
                <div
                  data-xsb-settings-module="onoff"
                  data-xsb-settings-module-onoff-activetarget="w_buy"
                  className="xx_set_sect xx_set_sect--bg"
                >
                  <div className="xsb_set_line xsb_set_line--fullsub">
                    <div className="l_width100">
                      <div className="xsb_sett_toggle0">
                        <div className="xsb_sett_toggle_b">
                          <div className="xsb_sett_toggle_t" />
                        </div>
                        <div
                          data-xsb-settings-module-onoff="hero_w_logo"
                          className="xsb_sett_toggle_label"
                        >
                          <div>Background image</div>
                        </div>
                      </div>
                      <div className="xsb_module_but">
                        <div className="xsb_global_settings_bg xsb_global_settings_bg--2">
                          <div
                            xsb_template_media_control="bg"
                            className="xsb_media"
                          >
                            <div className="xsb_but_upload">
                              <div className="w-embed">
                                <svg
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.5 19C4.46243 19 2 16.5376 2 13.5C2 10.4624 4.46243 8 7.5 8C7.60002 8 7.69941 8.00267 7.79811 8.00794C8.8344 6.21016 10.7759 5 13 5C16.0561 5 18.5785 7.28485 18.9523 10.2395C20.7249 10.8436 22 12.5229 22 14.5C22 16.9853 19.9853 19 17.5 19H14V17.3852H17.9237C19.4108 17.3852 20.6163 16.1797 20.6163 14.6926C20.6163 13.5312 19.874 12.5112 18.793 12.1428C18.0138 11.8773 17.4541 11.1909 17.3508 10.3742C17.0806 8.23775 15.2526 6.61481 13.077 6.61481C11.5177 6.61481 10.106 7.44842 9.34063 8.77615C8.93545 9.47906 8.16968 9.89468 7.35951 9.85141C7.29113 9.84776 7.22239 9.84592 7.15332 9.84592C5.07141 9.84592 3.38369 11.5336 3.38369 13.6156C3.38369 15.6975 5.07141 17.3852 7.15332 17.3852H10V19H7.5ZM8 14L12 10L16 14H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V14H8Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </div>
                            </div>
                            <div className="xccz">
                              <div className="x_contentimage">
                                <div className="x_temp_pic1 x_temp_pic--2" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-xsb-settings-module="onoff"
                  data-xsb-settings-module-onoff-activetarget="w_buy"
                  className="xx_set_sect xx_set_sect--bg"
                >
                  <div className="xsb_set_line xsb_set_line--fullsub">
                    <div className="l_width100">
                      <div className="xsb_sett_toggle0">
                        <div className="xsb_sett_toggle_b inactive">
                          <div className="xsb_sett_toggle_t" />
                        </div>
                        <div
                          data-xsb-settings-module-onoff="hero_w_logo"
                          className="xsb_sett_toggle_label"
                        >
                          <div>Button image</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-xsb-settings-module="onoff"
                  data-xsb-settings-module-onoff-activetarget="w_buy"
                  className="xx_set_sect xx_set_sect--bg"
                >
                  <div className="xsb_set_line xsb_set_line--fullsub">
                    <div className="l_width100">
                      <div className="xsb_sett_toggle0">
                        <div className="xsb_sett_toggle_b">
                          <div className="xsb_sett_toggle_t" />
                        </div>
                        <div
                          data-xsb-settings-module-onoff="hero_w_logo"
                          className="xsb_sett_toggle_label"
                        >
                          <div>Desctiption</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                    <div className="l_width100">
                      <div className="xsb_sett_toggle0">
                        <div className="xsb_sett_toggle_b">
                          <div className="xsb_sett_toggle_t" />
                        </div>
                        <div
                          data-xsb-settings-module-onoff="hero_w_logo"
                          className="xsb_sett_toggle_label"
                        >
                          <div>Platform icons</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                    <div className="l_width100">
                      <div className="xsb_sett_toggle0">
                        <div className="xsb_sett_toggle_b inactive">
                          <div className="xsb_sett_toggle_t" />
                        </div>
                        <div
                          data-xsb-settings-module-onoff="hero_w_logo"
                          className="xsb_sett_toggle_label"
                        >
                          <div>Tips</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-xsb-settings-module="onoff"
                  data-xsb-settings-module-onoff-activetarget="w_buy"
                  className="xx_set_sect xx_set_sect--nohover"
                >
                  <div className="l_flex">
                    <div
                      data-xsb-settings-media="clear"
                      className="p_button p_button--appearance-secondary"
                    >
                      <div>Copy widget COde</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="x_right0">
            <div className="x_flex x_flex--center">
              <div
                data-xsb-template-type="ps_card"
                className="xsb_c"
              >
                <div className="p_formgroup_xlg p_formgroup_xlg--top">
                  <div className="xsbps_b xsbps_b--rel">
                    <div className="xsb_c_width">
                      <div className="xsb_c_paddings">
                        <div className="xsbw_c1-2">
                          <div
                            data-xsb-template-media="bg"
                            className="xsb_bgz-4"
                          >
                            <div className="x_contentimage">
                              <div className="x_contentimage_static">
                                <div className="x_temp_pic1 x_temp_pic--2" />
                              </div>
                            </div>
                          </div>
                          <div className="xsbw_i_0-2">
                            <div className="xsbw_i_name">
                              <div>
                                <strong>
                                  {"{"}$project_name{"}"}
                                </strong>
                              </div>
                            </div>
                            <div className="xsbw_i_txt-2">
                              <p>
                                Powerful river, water and
                                cascade toolset for Unreal
                                Engine 4.
                              </p>
                            </div>
                            <div className="xsbw_i_but_0-2">
                              <div className="xsbm_p xsbm_p--left">
                                <div className="button_primary x_radius">
                                  <div>Buy Now $9.99</div>
                                </div>
                              </div>
                              <div className="xsbw_i_but">
                                <div className="xsbw_icon w-embed">
                                  <svg
                                    width={24}
                                    height={25}
                                    viewBox="0 0 24 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0)">
                                      <path
                                        d="M4.2145 17.7245L10.5964 18.6041V12.5123H4.2145V17.7245Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M4.2145 11.7268H10.5964V5.56018L4.2145 6.43974V11.7268Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M11.2982 18.6978L19.7854 19.8674V12.5124V12.5123H11.2982V18.6978Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M11.2982 5.46619V11.7264H19.7853V4.29651L11.2982 5.46619Z"
                                        fill="currentColor"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0">
                                        <rect
                                          width={24}
                                          height={24}
                                          fill="currentColor"
                                          transform="translate(0 0.0820312)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </div>
                                <div className="xsbw_icon w-embed">
                                  <svg
                                    width={25}
                                    height={25}
                                    viewBox="0 0 25 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0)">
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M18.8978 18.6594L18.8976 18.6595L18.8976 18.6595C18.2062 19.0344 17.3036 19.5237 16.9237 19.9268C16.4644 20.4117 15.7476 20.3871 15.4147 20.205C15.0818 20.0263 14.9034 19.617 14.9034 19.617C14.9034 19.617 13.9838 19.3873 13.0122 19.4146C12.0416 19.4383 11.1184 19.6452 11.1184 19.6452C11.1184 19.6452 10.8646 20.3087 10.0442 20.205C9.64335 20.1561 9.20419 19.9954 8.75821 19.8321C8.29618 19.663 7.82683 19.4912 7.38522 19.4384C6.51388 19.3354 5.62144 19.1568 5.79973 18.5689C5.83266 18.4603 5.86479 18.363 5.8943 18.2736C6.0246 17.8788 6.10405 17.6381 5.97807 17.2628C5.82433 16.8017 5.82433 16.3897 6.46206 16.2586C7.10417 16.1345 7.4608 15.9523 7.63915 15.5713C7.82094 15.1858 8.0511 15.1065 8.0511 15.1065C8.0511 15.1065 7.82099 14.5706 8.15035 13.9827C8.29711 13.7247 8.44322 13.3064 8.59944 12.8591C8.80134 12.2811 9.02014 11.6547 9.27912 11.2632C9.50127 10.9297 9.77765 10.5651 10.0153 10.2516L10.0153 10.2515C10.2701 9.91546 10.4803 9.63806 10.5317 9.5206C10.6309 9.29706 10.6591 8.67485 10.6072 7.80529C10.6006 7.693 10.5893 7.56473 10.5771 7.42487L10.5771 7.42485L10.5771 7.42483C10.4939 6.47611 10.364 4.9939 11.3003 4.34651C12.3746 3.60376 14.3677 3.50076 15.1363 5.24334C15.5088 6.08669 15.5324 6.84113 15.5539 7.529C15.5768 8.26032 15.5973 8.9164 16.0322 9.5241C16.8764 10.6999 17.9744 12.2638 18.3073 13.2363C18.6402 14.2132 18.2827 15.3925 18.2827 15.3925C18.2827 15.3925 18.6911 15.7498 18.6674 16.2858C18.6402 16.8262 18.9968 17.1078 19.4325 17.2865C19.8682 17.4652 19.9955 18.0531 19.3016 18.4386C19.1811 18.5058 19.0442 18.58 18.8978 18.6594ZM9.10412 16.1832C8.91877 15.8946 8.46905 15.3824 8.22573 15.5267C8.1081 15.5938 8.03257 15.75 7.95267 15.9152C7.86486 16.0968 7.77177 16.2893 7.61172 16.3866C7.48692 16.4624 7.28044 16.5072 7.07558 16.5517C6.77863 16.6163 6.48508 16.68 6.44873 16.8363C6.41891 16.9629 6.44491 17.0847 6.47383 17.2202C6.50541 17.3682 6.54048 17.5326 6.51022 17.7375C6.48827 17.8686 6.4459 18.002 6.40575 18.1285C6.32701 18.3765 6.25683 18.5976 6.36619 18.7206C6.45067 18.8163 6.83579 18.8788 7.25348 18.9465C7.63052 19.0076 8.03409 19.0731 8.26705 19.1712L8.33512 19.1998C8.85175 19.417 9.85551 19.8391 10.2258 19.7248C10.2258 19.7248 10.6589 19.4563 10.737 19.0885C10.8196 18.7206 10.5552 18.3113 10.2671 18.0024C10.0593 17.7787 9.63173 17.0617 9.34539 16.5816C9.23964 16.4042 9.15316 16.2592 9.10412 16.1832ZM13.0264 7.23039C13.0264 7.34041 13.0536 7.45043 13.0984 7.53668C12.9614 7.48125 12.8376 7.43373 12.7383 7.39584C12.6865 7.26473 12.6557 7.11687 12.6557 6.95933C12.6557 6.42249 13.0089 5.98598 13.4481 5.98598C13.8872 5.98598 14.2413 6.42249 14.2413 6.95933C14.2413 7.34046 14.0629 7.67046 13.802 7.82889C13.7675 7.81458 13.7323 7.79931 13.6957 7.78346L13.6957 7.78345C13.6624 7.76906 13.628 7.75417 13.5921 7.73908C13.7502 7.66078 13.86 7.461 13.86 7.23039C13.86 6.9285 13.6746 6.68036 13.4419 6.68036C13.2152 6.68036 13.0264 6.92855 13.0264 7.23039ZM11.1738 8.43719C11.0702 8.61582 11.4821 8.95294 11.7017 9.09724C11.7411 9.12264 11.7771 9.14722 11.811 9.1703C11.9661 9.27597 12.075 9.35023 12.2437 9.32785C12.4358 9.30246 13.0077 8.95531 13.324 8.76331L13.324 8.76331L13.324 8.76329L13.324 8.76329L13.3901 8.72322C13.4828 8.66663 13.5577 8.62762 13.6177 8.59637C13.7508 8.52702 13.8105 8.49593 13.8292 8.39584C13.8529 8.255 13.6097 8.1142 13.3901 8.03852C13.325 8.01505 13.227 7.97588 13.1158 7.9314C12.8516 7.8258 12.5126 7.69024 12.3605 7.66362C12.1409 7.62311 11.7773 7.93201 11.6368 8.06317C11.4962 8.18989 11.1738 8.43719 11.1738 8.43719ZM11.4821 7.71914C11.3934 7.8054 11.3108 7.88108 11.2247 7.94268C10.9744 7.8256 10.7891 7.47535 10.7891 7.0626C10.7891 6.55041 11.0667 6.14117 11.4136 6.14117C11.7597 6.14117 12.0417 6.55392 12.0417 7.0626C12.0417 7.15498 12.0311 7.24123 12.0145 7.32749C11.9284 7.35481 11.8423 7.39966 11.7597 7.47184L11.7388 7.48955C11.7062 7.51704 11.6755 7.54295 11.6473 7.57128C11.7017 7.46833 11.7228 7.32047 11.6982 7.16555C11.6508 6.89098 11.4654 6.68769 11.2836 6.71496C11.1009 6.74579 10.992 6.99749 11.0359 7.27562C11.0842 7.5572 11.266 7.76049 11.4513 7.72971L11.4821 7.71914ZM15.9258 15.3137C15.9258 15.3137 16.1832 14.4916 16.0286 13.4162C15.874 12.3398 14.3404 8.96028 14.162 8.80541C14.0616 8.71871 13.6362 8.96491 13.188 9.22435C12.8398 9.42586 12.4778 9.63535 12.2436 9.70308C11.7086 9.85444 10.94 8.93301 10.94 8.93301C11.0665 9.3176 10.789 10.188 10.4288 10.5963C10.2382 10.8151 10.0837 11.2686 9.92675 11.7295L9.92675 11.7295C9.79003 12.1309 9.65143 12.5379 9.48541 12.8001C9.12439 13.3642 8.89512 14.4916 9.17621 15.1587C9.31466 15.4873 9.76382 15.8342 10.193 16.1658C10.6353 16.5074 11.0563 16.8326 11.0947 17.1046C11.1702 17.6441 10.6344 17.7233 10.6344 17.7233L11.3239 18.5145C11.3239 18.5145 11.9388 18.6448 13.1669 18.4661C14.3948 18.284 15.1881 17.1839 15.1881 17.1839C15.1881 17.1839 15.1881 15.8769 15.2636 15.5161C15.339 15.1588 15.9258 15.3137 15.9258 15.3137ZM18.2352 16.3996C18.2141 16.72 18.3722 17.1768 18.6708 17.3352C18.6864 17.3434 18.7023 17.3517 18.7186 17.3603C19.015 17.5156 19.4131 17.7242 19.189 17.9328C19.0924 18.0212 18.8199 18.1606 18.5026 18.3229C18.0296 18.5649 17.457 18.8579 17.2188 19.1086C16.8244 19.525 16.3062 19.8655 15.9908 19.7652C15.672 19.6657 15.3936 19.2292 15.5306 18.5903C15.672 17.954 15.7915 17.256 15.7712 16.8574C15.766 16.759 15.7574 16.6523 15.7488 16.5461C15.7224 16.2217 15.6965 15.9023 15.7712 15.8426C15.8705 15.7643 16.0286 15.8021 16.0286 15.8021C16.0286 15.8021 15.9496 16.5581 16.4064 16.757C16.8623 16.9568 17.5175 16.6786 17.7169 16.4789C17.9155 16.28 18.056 15.9843 18.056 15.9843C18.056 15.9843 18.2553 16.0837 18.2352 16.3996Z"
                                        fill="currentColor"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0">
                                        <rect
                                          width={24}
                                          height={24}
                                          fill="currentColor"
                                          transform="translate(0.646339 0.0820312)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </div>
                                <div className="xsbw_icon w-embed">
                                  <svg
                                    width={25}
                                    height={25}
                                    viewBox="0 0 25 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0)">
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M13.6293 7.98712C13.9965 7.50511 14.2748 6.82383 14.1742 6.12842C13.574 6.17083 12.8725 6.56129 12.4632 7.07022C12.09 7.53137 11.7834 8.21736 11.9031 8.88315C12.5592 8.90402 13.2364 8.50414 13.6293 7.98712ZM16.8724 14.5287C16.6098 15.1238 16.4835 15.3897 16.1452 15.9168C15.6734 16.6526 15.0081 17.5688 14.1828 17.5756C13.4504 17.5836 13.2615 17.0875 12.2672 17.0935C11.2728 17.0989 11.0655 17.585 10.3318 17.5776C9.5072 17.5702 8.87677 16.7435 8.40493 16.0077C7.08483 13.9517 6.94598 11.5383 7.76001 10.2545C8.33912 9.343 9.25253 8.80983 10.1107 8.80983C10.9839 8.80983 11.5334 9.29992 12.2566 9.29992C12.9582 9.29992 13.3852 8.80848 14.3954 8.80848C15.1601 8.80848 15.9702 9.23462 16.5466 9.96975C14.6566 11.0294 14.9626 13.7902 16.8724 14.5287Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.9564 3.83855H8.62891C6.09961 3.83855 4.04921 5.88895 4.04921 8.41825V16.2037C4.04921 18.733 6.09962 20.7835 8.62892 20.7835H15.9564C18.4857 20.7835 20.5361 18.7331 20.5361 16.2037V8.41825C20.5361 5.88895 18.4857 3.83855 15.9564 3.83855ZM8.62891 2.92261C5.59375 2.92261 3.13327 5.38309 3.13327 8.41825V16.2037C3.13327 19.2389 5.59376 21.6994 8.62892 21.6994H15.9564C18.9916 21.6994 21.4521 19.2389 21.4521 16.2037V8.41825C21.4521 5.38309 18.9916 2.92261 15.9564 2.92261H8.62891Z"
                                        fill="currentColor"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0">
                                        <rect
                                          width={24}
                                          height={24}
                                          fill="currentColor"
                                          transform="translate(0.292679 0.0820312)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div className="xbm_accentbg xbm_accentbg--text" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="temp_settings-2" />
              </div>
            </div>
            <div className="xccz xccz--rel">
              <div className="x_contentimage">
                <div className="x_contentimage_tint">
                  <section
                    id="xsbm_login_w1"
                    className="x_temp_tint_1 x_temp_tint_1--dark"
                  />
                </div>
                <div className="x_contentimage_static">
                  <div className="x_temp_pic1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="l_sb0 l_sb0--flatten">
        <div className="l_sb0">
          <div id="store_mail0" className="p_x_anchor" />
          <div className="x_left0">
            <div className="x_left0_sticky">
              <div
                data-xsb-settings-module="onoff"
                data-xsb-settings-module-onoff-activetarget="w_buy"
                className="xx_set_sect"
              >
                <div className="xsb_set_line xsb_set_line--fullsub">
                  <div className="l_width100">
                    <div className="xsb_sett_toggle0">
                      <div className="xsb_sett_toggle_b">
                        <div className="xsb_sett_toggle_t" />
                      </div>
                      <div
                        data-xsb-settings-module-onoff="hero_w_logo"
                        className="xsb_sett_toggle_label"
                      >
                        <div>Logo image</div>
                      </div>
                    </div>
                    <div className="xsb_module_but">
                      <div className="xsb_global_settings_bg xsb_global_settings_bg--2">
                        <div
                          xsb_template_media_control="bg"
                          className="xsb_media"
                        >
                          <div className="xsb_but_upload">
                            <div className="w-embed">
                              <svg
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7.5 19C4.46243 19 2 16.5376 2 13.5C2 10.4624 4.46243 8 7.5 8C7.60002 8 7.69941 8.00267 7.79811 8.00794C8.8344 6.21016 10.7759 5 13 5C16.0561 5 18.5785 7.28485 18.9523 10.2395C20.7249 10.8436 22 12.5229 22 14.5C22 16.9853 19.9853 19 17.5 19H14V17.3852H17.9237C19.4108 17.3852 20.6163 16.1797 20.6163 14.6926C20.6163 13.5312 19.874 12.5112 18.793 12.1428C18.0138 11.8773 17.4541 11.1909 17.3508 10.3742C17.0806 8.23775 15.2526 6.61481 13.077 6.61481C11.5177 6.61481 10.106 7.44842 9.34063 8.77615C8.93545 9.47906 8.16968 9.89468 7.35951 9.85141C7.29113 9.84776 7.22239 9.84592 7.15332 9.84592C5.07141 9.84592 3.38369 11.5336 3.38369 13.6156C3.38369 15.6975 5.07141 17.3852 7.15332 17.3852H10V19H7.5ZM8 14L12 10L16 14H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V14H8Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="xccz">
                            <div className="x_contentimage">
                              <div className="x_temp_pic1 x_temp_pic--2" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-xsb-settings-module="onoff"
                data-xsb-settings-module-onoff-activetarget="w_buy"
                className="xx_set_sect"
              >
                <div className="xx_set_head">
                  <div className="xx_img_menu_left">
                    <div data-xsb-settings-module-onoff="w_pack1">
                      <div className="xsb_sett_head">
                        Footer social
                      </div>
                    </div>
                  </div>
                  <div className="xx_img_menu_right">
                    <div className="xx_img_menu_li">
                      <div className="xx_but_menu_icon xx_but_menu_icon--secondary">
                        <div>delete</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                  <div className="xx_set_line">
                    <div className="x_flex x_flex--vcenter">
                      <div className="xsb_sett_drag" />
                      <div className="xsb_but_link_input">
                        <div className="social_icon social_icon--sett w-embed">
                          <svg
                            width={39}
                            height={36}
                            viewBox="0 0 39 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M19.8 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.8 31.2004C26.7588 31.2004 32.4001 25.4249 32.4001 18.3004C32.4001 11.1759 26.7588 5.40039 19.8 5.40039ZM20.6293 18.2155V25.0514H17.8358V18.2158H16.4401V15.8601H17.8358V14.4458C17.8358 12.524 18.6238 11.3812 20.8629 11.3812H22.7269V13.7372H21.5618C20.6902 13.7372 20.6325 14.0664 20.6325 14.6808L20.6293 15.8598H22.7401L22.4931 18.2155H20.6293Z"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                        <div className="xsb_but_seturl_placeholder">
                          <div>Facebook</div>
                        </div>
                        <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                          <div>expand_more</div>
                        </div>
                        <div className="xsb_select_drop0 xsb_select_drop0--top">
                          <div className="xsb_select_drop">
                            <div className="xsb_select_drop_li">
                              <div>Twitter</div>
                            </div>
                            <div className="xsb_select_drop_li active">
                              <div>Reddit</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="xx_but_menu_icon xx_but_menu_icon--link">
                        <div>insert_link</div>
                      </div>
                    </div>
                  </div>
                  <div className="xx_set_line">
                    <div className="x_flex x_flex--vcenter">
                      <div className="xsb_sett_drag" />
                      <div className="xsb_but_link_input">
                        <div className="social_icon social_icon--sett w-embed">
                          <svg
                            width={39}
                            height={36}
                            viewBox="0 0 39 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M19.2002 5.40039C12.2413 5.40039 6.6001 11.1759 6.6001 18.3004C6.6001 25.4249 12.2413 31.2004 19.2002 31.2004C26.159 31.2004 31.8002 25.4249 31.8002 18.3004C31.8002 11.1759 26.159 5.40039 19.2002 5.40039ZM16.4299 11.4615C17.1467 11.4281 17.3758 11.4199 19.2008 11.4199H19.1987C21.0244 11.4199 21.2526 11.4281 21.9694 11.4615C22.6848 11.495 23.1734 11.611 23.6018 11.7811C24.0442 11.9567 24.418 12.1918 24.7918 12.5745C25.1656 12.9569 25.3952 13.3408 25.5674 13.7933C25.7326 14.2307 25.846 14.7307 25.8796 15.4631C25.9118 16.197 25.9202 16.4315 25.9202 18.3C25.9202 20.1685 25.9118 20.4024 25.8796 21.1363C25.846 21.8685 25.7326 22.3685 25.5674 22.8061C25.3952 23.2585 25.1656 23.6424 24.7918 24.0248C24.4184 24.4075 24.0441 24.6431 23.6022 24.8189C23.1747 24.989 22.6858 25.1049 21.9704 25.1385C21.2535 25.1719 21.0252 25.1801 19.2 25.1801C17.3751 25.1801 17.1462 25.1719 16.4294 25.1385C15.7141 25.1049 15.2256 24.989 14.7981 24.8189C14.3563 24.6431 13.9814 24.4075 13.608 24.0248C13.2344 23.6424 13.0048 23.2585 12.833 22.806C12.6669 22.3685 12.5537 21.8686 12.5208 21.1362C12.4883 20.4023 12.4802 20.1685 12.4802 18.3C12.4802 16.4315 12.4886 16.1968 12.5206 15.463C12.5528 14.7308 12.6662 14.2307 12.8328 13.7931C13.005 13.3408 13.2346 12.9569 13.6085 12.5745C13.982 12.1919 14.3569 11.9569 14.7989 11.7811C15.2262 11.611 15.7145 11.495 16.4299 11.4615Z"
                              fill="currentColor"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M18.5979 12.613C18.7149 12.6129 18.8409 12.6129 18.9768 12.613L19.2007 12.613C20.995 12.613 21.2077 12.6196 21.9162 12.6523C22.5714 12.6828 22.927 12.7942 23.1639 12.8877C23.4775 13.0116 23.7011 13.1597 23.9362 13.3989C24.1714 13.6382 24.317 13.866 24.4391 14.185C24.531 14.4256 24.6407 14.7873 24.6705 15.4538C24.7027 16.1743 24.7097 16.3907 24.7097 18.2149C24.7097 20.039 24.7027 20.2554 24.6705 20.976C24.6405 21.6424 24.531 22.0041 24.4391 22.2448C24.3172 22.5637 24.1714 22.7909 23.9362 23.0299C23.701 23.2692 23.4777 23.4173 23.1639 23.5412C22.9273 23.6351 22.5714 23.7462 21.9162 23.7767C21.2078 23.8094 20.995 23.8166 19.2007 23.8166C17.4063 23.8166 17.1937 23.8094 16.4853 23.7767C15.83 23.7459 15.4744 23.6346 15.2374 23.541C14.9238 23.4171 14.6998 23.269 14.4646 23.0298C14.2294 22.7906 14.0838 22.5633 13.9617 22.2442C13.8697 22.0035 13.7601 21.6418 13.7303 20.9754C13.6981 20.2549 13.6917 20.0384 13.6917 18.2132C13.6917 16.3879 13.6981 16.1726 13.7303 15.452C13.7603 14.7856 13.8697 14.4239 13.9617 14.183C14.0835 13.864 14.2294 13.6362 14.4646 13.3969C14.6998 13.1577 14.9238 13.0096 15.2374 12.8854C15.4743 12.7915 15.83 12.6804 16.4853 12.6498C17.1052 12.6213 17.3454 12.6128 18.5979 12.6113V12.613ZM22.7879 13.7487C22.3427 13.7487 21.9814 14.1157 21.9814 14.5687C21.9814 15.0215 22.3427 15.3889 22.7879 15.3889C23.2331 15.3889 23.5943 15.0215 23.5943 14.5687C23.5943 14.1158 23.2331 13.7484 22.7879 13.7484V13.7487ZM15.7499 18.2172C15.7499 16.2787 17.295 14.7071 19.2008 14.707C21.1066 14.707 22.6514 16.2787 22.6514 18.2172C22.6514 20.1556 21.1068 21.7266 19.2009 21.7266C17.2951 21.7266 15.7499 20.1556 15.7499 18.2172Z"
                              fill="currentColor"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M19.2007 15.9375C20.4378 15.9375 21.4408 16.9575 21.4408 18.2159C21.4408 19.4741 20.4378 20.4943 19.2007 20.4943C17.9635 20.4943 16.9607 19.4741 16.9607 18.2159C16.9607 16.9575 17.9635 15.9375 19.2007 15.9375V15.9375Z"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                        <div className="xsb_but_seturl_placeholder">
                          <div className="text-block-19">
                            Instagram
                          </div>
                        </div>
                        <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                          <div>expand_more</div>
                        </div>
                      </div>
                      <div className="xx_but_menu_icon xx_but_menu_icon--link">
                        <div>insert_link</div>
                      </div>
                    </div>
                  </div>
                  <div className="xx_set_line">
                    <div className="x_flex x_flex--vcenter">
                      <div className="xsb_sett_drag" />
                      <div className="xsb_but_link_input">
                        <div className="social_icon social_icon--sett w-embed">
                          <svg
                            width={39}
                            height={36}
                            viewBox="0 0 39 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.19995 18.3004C7.19995 11.1759 12.8412 5.40039 19.8 5.40039C26.7588 5.40039 32.4001 11.1759 32.4001 18.3004C32.4001 25.4249 26.7588 31.2004 19.8 31.2004C12.8412 31.2004 7.19995 25.4249 7.19995 18.3004ZM26.4133 19.1647L24.0196 21.6062H20.2596L18.2083 23.6983V21.6062H15.1316V11.4931H26.4133V19.1647ZM13.7636 10.0983L13.08 12.8882V25.4419H16.1571V27.1859H17.8659L19.5758 25.4419H22.3103L27.78 19.8631V10.0983H13.7636ZM20.2595 18.4684H18.892V14.283H20.2595V18.4684ZM24.0197 18.4684H22.6523V14.283H24.0197V18.4684Z"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                        <div className="xsb_but_seturl_placeholder">
                          <div className="text-block-19">
                            Twitch
                          </div>
                        </div>
                        <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                          <div>expand_more</div>
                        </div>
                      </div>
                      <div className="xx_but_menu_icon xx_but_menu_icon--link">
                        <div>insert_link</div>
                      </div>
                    </div>
                  </div>
                  <div className="xx_set_line">
                    <div className="x_flex x_flex--vcenter">
                      <div className="xsb_sett_drag" />
                      <div className="xsb_but_link_input">
                        <div className="social_icon social_icon--sett w-embed">
                          <svg
                            width={39}
                            height={36}
                            viewBox="0 0 39 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M19.7999 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.7999 31.2004C26.7587 31.2004 32.3999 25.4249 32.3999 18.3004C32.3999 11.1759 26.7587 5.40039 19.7999 5.40039ZM25.9923 14.0666C26.6201 13.9895 27.2186 13.817 27.7745 13.5618C27.3598 14.2052 26.8332 14.7697 26.2267 15.2222C26.2321 15.359 26.2347 15.4985 26.2347 15.638C26.2347 19.8777 23.1135 24.7653 17.4038 24.7653C15.6518 24.7653 14.0197 24.2339 12.646 23.3252C12.8884 23.3546 13.1362 23.3693 13.3866 23.3693C14.8402 23.3693 16.1793 22.8562 17.2413 21.9952C15.8827 21.9704 14.7372 21.0425 14.342 19.7685C14.5312 19.8061 14.7265 19.8254 14.9263 19.8254C15.2096 19.8254 15.484 19.7877 15.7442 19.7125C14.3234 19.4187 13.2534 18.1218 13.2534 16.5669V16.5275C13.6725 16.7661 14.152 16.912 14.6599 16.9276C13.827 16.3521 13.2791 15.37 13.2791 14.2576C13.2791 13.6701 13.4319 13.1185 13.6991 12.643C15.2309 14.5862 17.5174 15.862 20.097 15.996C20.0437 15.761 20.0171 15.5169 20.0171 15.2654C20.0171 13.4939 21.4068 12.0574 23.1197 12.0574C24.013 12.0574 24.8202 12.4466 25.3849 13.0698C26.0935 12.9266 26.7569 12.6595 27.3571 12.2924C27.1254 13.0414 26.6334 13.6701 25.9923 14.0666Z"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                        <div className="xsb_but_seturl_placeholder">
                          <div className="text-block-19">
                            Twitter
                          </div>
                        </div>
                        <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                          <div>expand_more</div>
                        </div>
                      </div>
                      <div className="xx_but_menu_icon xx_but_menu_icon--link">
                        <div>insert_link</div>
                      </div>
                    </div>
                  </div>
                  <div className="xx_set_line" />
                </div>
              </div>
              <div
                data-xsb-settings-module="onoff"
                data-xsb-settings-module-onoff-activetarget="w_buy"
                className="xx_set_sect_info0"
              >
                <div>You can use the following variables:</div>
                <ul className="xx_set_sect_info_ul w-list-unstyled">
                  <li className="xx_set_sect_info_li">
                    <div>
                      {"{"}$project_name{"}"}
                    </div>
                  </li>
                  <li className="xx_set_sect_info_li">
                    <div>
                      {"{"}$charge_amount_invoice{"}"}{" "}
                    </div>
                  </li>
                  <li className="xx_set_sect_info_li">
                    <div>
                      {"{"}$currency_invoice{"}"}{" "}
                    </div>
                  </li>
                  <li className="xx_set_sect_info_li">
                    <div>
                      {"{"}$date_charge{"}"}
                    </div>
                  </li>
                  <li className="xx_set_sect_info_li">
                    <div>
                      {"{"}$company_name{"}"}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="x_right0">
            <div className="l_width100">
              <section
                id="xsbm_login_new"
                data-xsb-template-type="mail_subs_verif"
                className="xsb_c"
              >
                <div className="xsb_cont_tabs">
                  <div>
                    <div className="x_flex x_flex--center x_flex--vcenter">
                      <div className="p_button p_button--appearance-flatten">
                        <div>Check</div>
                      </div>
                      <div className="p_x_card_filter_div" />
                      <div className="p_button p_button--appearance-flatten inactive">
                        <div>refund</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="xsbm_mailbg0">
                  <div className="xsbm_mailbg_lr" />
                  <div>
                    <div className="x_paddings">
                      <div className="xsbm_mail">
                        <div className="xsbm_mail_w">
                          <div className="xsbm_mail">
                            <div className="xsbm_mailbody">
                              <div className="xsbm_top xsbm_top">
                                <div className="xccz">
                                  <div className="x_contentimage">
                                    <div className="x_contentimage_static">
                                      <div className="x_temp_pic1 x_temp_pic--2" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="xsbm_content">
                                <div className="xbm_accentbg xbm_accentbg--text" />
                                <div className="xsbm_cont xsbm_cont--left">
                                  <div className="p_formgroup_md">
                                    <div className="t_h2 t_bold">
                                      <div>Thank you!</div>
                                    </div>
                                  </div>
                                  <p
                                    data-xsb-template-content="mail_trans_1"
                                    className="xsbm_p-2"
                                  >
                                    <strong>
                                      You have successfully
                                      subscribed to a recurring{" "}
                                      {"{"}$project_name{"}"}.
                                    </strong>
                                    <br />
                                  </p>
                                  <p
                                    data-xsb-template-content="mail_trans_1"
                                    className="xsbm_p-2"
                                  >
                                    You have been charged for
                                    the amount of {"{"}
                                    $charge_amount_invoice{"}"}{" "}
                                    {"{"}$currency_invoice{"}"}{" "}
                                    and your subscription will
                                    automatically renew again on{" "}
                                    {"{"}$date_charge{"}"}.
                                    <br />
                                  </p>
                                </div>
                              </div>
                              <div className="xsbm_content">
                                <div className="xsbm_check">
                                  <div className="xsbm_cont-3 xsbm_cont--purchase">
                                    <div className="xsbm_purchase">
                                      <div className="xsbm_ps_status">
                                        <div>◉ Purchased</div>
                                      </div>
                                      <div className="xsbm_purchase_icon">
                                        <div className="w-embed">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={48}
                                            height={48}
                                            viewBox="0 0 48 47"
                                          >
                                            <path
                                              fill="currentColor"
                                              fillRule="nonzero"
                                              d="M45 3h3v14h-2V5h-1v14h-1v24h-1v4h-5v-4h-1V19h-1V0h9v3zm-3 38V20h-3v21h3zM27 3V0h2v3h3a1 1 0 0 1 1 1v42a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2V0h2v3h4V0h2v3h4V0h2v3h4V0h2v3h4zm0 2h-4v4h-2V5h-4v4h-2V5h-4v4H9V5H5v4H3V5H2v40h29V5h-2v4h-2V5zm-9.743 34.066a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19zm0-2a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zM38 2v15h5V2h-5zM17 24h2v6.414l-3.293 3.293-1.414-1.414L17 29.586V24z"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                      <div className="xsbm_purchase_name">
                                        <div>
                                          Monthly Subscription
                                        </div>
                                      </div>
                                      <div className="xsbm_purchase_note">
                                        <div>
                                          From: Nov, 12 2018
                                          <br />
                                          Expires: Nov, 12 2018
                                        </div>
                                      </div>
                                      <div className="xsbm_purchase_note">
                                        <div>
                                          <a
                                            href="#"
                                            className="xsbm_purchase_note"
                                          >
                                            Manage your
                                            subscriptions
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="xsbm_cont-3 xsbm_cont--opacity">
                                    <div className="xsbm_check_h">
                                      <div>
                                        Transaction Details
                                      </div>
                                    </div>
                                    <div className="xsbm_check_line-2">
                                      <div className="xsbm_check_2col">
                                        <div className="xsbm_check_col">
                                          <div>
                                            Monthly Subscription
                                          </div>
                                        </div>
                                        <div className="xsbm_check_col_dots" />
                                        <div className="xsbm_check_col xsbm_check_col--right">
                                          <div className="text-block-20">
                                            $4
                                          </div>
                                        </div>
                                      </div>
                                      <div className="xsbm_check_2col">
                                        <div className="xsbm_check_col">
                                          <div>
                                            Transaction ID
                                          </div>
                                        </div>
                                        <div className="xsbm_check_col_dots" />
                                        <div className="xsbm_check_col xsbm_check_col--right">
                                          <div>
                                            1721-9932-1319
                                          </div>
                                        </div>
                                      </div>
                                      <div className="xsbm_check_2col">
                                        <div className="xsbm_check_col">
                                          <div>
                                            Transaction Date
                                          </div>
                                        </div>
                                        <div className="xsbm_check_col_dots" />
                                        <div className="xsbm_check_col xsbm_check_col--right">
                                          <div>
                                            May, 26 2018
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="xsbm_check_line-2 xsbm_check_line--div xsbm_check_line--divsmall">
                                      <div className="xsbm_check_2col">
                                        <div className="xsbm_check_col">
                                          <div>Subtotal</div>
                                        </div>
                                        <div className="xsbm_check_col_dots" />
                                        <div className="xsbm_check_col xsbm_check_col--right">
                                          <div>$15.99</div>
                                        </div>
                                      </div>
                                      <div className="xsbm_check_2col">
                                        <div className="xsbm_check_col">
                                          <div>
                                            Payment System Fee
                                          </div>
                                        </div>
                                        <div className="xsbm_check_col_dots" />
                                        <div className="xsbm_check_col xsbm_check_col--right">
                                          <div>$4</div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="xsbm_check_line-2 xsbm_check_line--div">
                                      <div className="xsbm_check_total">
                                        <div className="xsbm_check_col">
                                          <div>Total</div>
                                        </div>
                                        <div className="xsbm_check_col_dots" />
                                        <div className="xsbm_check_col xsbm_check_col--right">
                                          <div>$19.99</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="xsbm_cont-3 xsbm_cont_protected xsbm_cont--opacity">
                                    <div className="xsbm_cont_xsolla">
                                      <p className="xsbm_p-2">
                                        Xsolla is an authorized
                                        video game software
                                        distributor providing
                                        clients with advanced
                                        technical tools for
                                        their games.
                                      </p>
                                      <p className="xsbm_p-2">
                                        If you have any
                                        questions please contact{" "}
                                        <a href="#">
                                          Xsolla Customer
                                          Support
                                        </a>
                                        . Hotline: +1 (877) 797
                                        65 52
                                      </p>
                                    </div>
                                  </div>
                                  <div className="xbm_bg_safe0">
                                    <div className="xbm_accentbg xbm_accentbg--op" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="xsbm_footer">
                              <div className="xsbm_footer_comp-2">
                                <p>
                                  Copyright © 2018 {"{"}
                                  $company_name{"}"}, All rights
                                  reserved.
                                  <br />
                                  Thanks for signing up for{" "}
                                  {"{"}$project_name{"}"}{" "}
                                  exclusive updates and
                                  information.
                                </p>
                                <div
                                  data-xsb-template-media="companyLogo"
                                  className="xsbm_footer_companylogo-2"
                                />
                                <div className="xsbm_footer_social">
                                  <div className="x_sos_h_soc">
                                    <div
                                      data-xsb-template-onoff="social_facebook"
                                      className="xsb_foooter_soc xsbm_soc_ico"
                                    >
                                      <div className="w-embed">
                                        <svg
                                          width={39}
                                          height={36}
                                          viewBox="0 0 39 36"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M19.8 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.8 31.2004C26.7588 31.2004 32.4001 25.4249 32.4001 18.3004C32.4001 11.1759 26.7588 5.40039 19.8 5.40039ZM20.6293 18.2155V25.0514H17.8358V18.2158H16.4401V15.8601H17.8358V14.4458C17.8358 12.524 18.6238 11.3812 20.8629 11.3812H22.7269V13.7372H21.5618C20.6902 13.7372 20.6325 14.0664 20.6325 14.6808L20.6293 15.8598H22.7401L22.4931 18.2155H20.6293Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                    <div
                                      data-xsb-template-onoff="social_facebook"
                                      className="xsb_foooter_soc xsbm_soc_ico"
                                    >
                                      <div className="w-embed">
                                        <svg
                                          width={39}
                                          height={36}
                                          viewBox="0 0 39 36"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M19.2002 5.40039C12.2413 5.40039 6.6001 11.1759 6.6001 18.3004C6.6001 25.4249 12.2413 31.2004 19.2002 31.2004C26.159 31.2004 31.8002 25.4249 31.8002 18.3004C31.8002 11.1759 26.159 5.40039 19.2002 5.40039ZM16.4299 11.4615C17.1467 11.4281 17.3758 11.4199 19.2008 11.4199H19.1987C21.0244 11.4199 21.2526 11.4281 21.9694 11.4615C22.6848 11.495 23.1734 11.611 23.6018 11.7811C24.0442 11.9567 24.418 12.1918 24.7918 12.5745C25.1656 12.9569 25.3952 13.3408 25.5674 13.7933C25.7326 14.2307 25.846 14.7307 25.8796 15.4631C25.9118 16.197 25.9202 16.4315 25.9202 18.3C25.9202 20.1685 25.9118 20.4024 25.8796 21.1363C25.846 21.8685 25.7326 22.3685 25.5674 22.8061C25.3952 23.2585 25.1656 23.6424 24.7918 24.0248C24.4184 24.4075 24.0441 24.6431 23.6022 24.8189C23.1747 24.989 22.6858 25.1049 21.9704 25.1385C21.2535 25.1719 21.0252 25.1801 19.2 25.1801C17.3751 25.1801 17.1462 25.1719 16.4294 25.1385C15.7141 25.1049 15.2256 24.989 14.7981 24.8189C14.3563 24.6431 13.9814 24.4075 13.608 24.0248C13.2344 23.6424 13.0048 23.2585 12.833 22.806C12.6669 22.3685 12.5537 21.8686 12.5208 21.1362C12.4883 20.4023 12.4802 20.1685 12.4802 18.3C12.4802 16.4315 12.4886 16.1968 12.5206 15.463C12.5528 14.7308 12.6662 14.2307 12.8328 13.7931C13.005 13.3408 13.2346 12.9569 13.6085 12.5745C13.982 12.1919 14.3569 11.9569 14.7989 11.7811C15.2262 11.611 15.7145 11.495 16.4299 11.4615Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M18.5979 12.613C18.7149 12.6129 18.8409 12.6129 18.9768 12.613L19.2007 12.613C20.995 12.613 21.2077 12.6196 21.9162 12.6523C22.5714 12.6828 22.927 12.7942 23.1639 12.8877C23.4775 13.0116 23.7011 13.1597 23.9362 13.3989C24.1714 13.6382 24.317 13.866 24.4391 14.185C24.531 14.4256 24.6407 14.7873 24.6705 15.4538C24.7027 16.1743 24.7097 16.3907 24.7097 18.2149C24.7097 20.039 24.7027 20.2554 24.6705 20.976C24.6405 21.6424 24.531 22.0041 24.4391 22.2448C24.3172 22.5637 24.1714 22.7909 23.9362 23.0299C23.701 23.2692 23.4777 23.4173 23.1639 23.5412C22.9273 23.6351 22.5714 23.7462 21.9162 23.7767C21.2078 23.8094 20.995 23.8166 19.2007 23.8166C17.4063 23.8166 17.1937 23.8094 16.4853 23.7767C15.83 23.7459 15.4744 23.6346 15.2374 23.541C14.9238 23.4171 14.6998 23.269 14.4646 23.0298C14.2294 22.7906 14.0838 22.5633 13.9617 22.2442C13.8697 22.0035 13.7601 21.6418 13.7303 20.9754C13.6981 20.2549 13.6917 20.0384 13.6917 18.2132C13.6917 16.3879 13.6981 16.1726 13.7303 15.452C13.7603 14.7856 13.8697 14.4239 13.9617 14.183C14.0835 13.864 14.2294 13.6362 14.4646 13.3969C14.6998 13.1577 14.9238 13.0096 15.2374 12.8854C15.4743 12.7915 15.83 12.6804 16.4853 12.6498C17.1052 12.6213 17.3454 12.6128 18.5979 12.6113V12.613ZM22.7879 13.7487C22.3427 13.7487 21.9814 14.1157 21.9814 14.5687C21.9814 15.0215 22.3427 15.3889 22.7879 15.3889C23.2331 15.3889 23.5943 15.0215 23.5943 14.5687C23.5943 14.1158 23.2331 13.7484 22.7879 13.7484V13.7487ZM15.7499 18.2172C15.7499 16.2787 17.295 14.7071 19.2008 14.707C21.1066 14.707 22.6514 16.2787 22.6514 18.2172C22.6514 20.1556 21.1068 21.7266 19.2009 21.7266C17.2951 21.7266 15.7499 20.1556 15.7499 18.2172Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M19.2007 15.9375C20.4378 15.9375 21.4408 16.9575 21.4408 18.2159C21.4408 19.4741 20.4378 20.4943 19.2007 20.4943C17.9635 20.4943 16.9607 19.4741 16.9607 18.2159C16.9607 16.9575 17.9635 15.9375 19.2007 15.9375V15.9375Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                    <div
                                      data-xsb-template-onoff="social_facebook"
                                      className="xsb_foooter_soc xsbm_soc_ico"
                                    >
                                      <div className="w-embed">
                                        <svg
                                          width={39}
                                          height={36}
                                          viewBox="0 0 39 36"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M7.19995 18.3004C7.19995 11.1759 12.8412 5.40039 19.8 5.40039C26.7588 5.40039 32.4001 11.1759 32.4001 18.3004C32.4001 25.4249 26.7588 31.2004 19.8 31.2004C12.8412 31.2004 7.19995 25.4249 7.19995 18.3004ZM26.4133 19.1647L24.0196 21.6062H20.2596L18.2083 23.6983V21.6062H15.1316V11.4931H26.4133V19.1647ZM13.7636 10.0983L13.08 12.8882V25.4419H16.1571V27.1859H17.8659L19.5758 25.4419H22.3103L27.78 19.8631V10.0983H13.7636ZM20.2595 18.4684H18.892V14.283H20.2595V18.4684ZM24.0197 18.4684H22.6523V14.283H24.0197V18.4684Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                    <div
                                      data-xsb-template-onoff="social_facebook"
                                      className="xsb_foooter_soc xsbm_soc_ico"
                                    >
                                      <div className="w-embed">
                                        <svg
                                          width={39}
                                          height={36}
                                          viewBox="0 0 39 36"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M19.7999 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.7999 31.2004C26.7587 31.2004 32.3999 25.4249 32.3999 18.3004C32.3999 11.1759 26.7587 5.40039 19.7999 5.40039ZM25.9923 14.0666C26.6201 13.9895 27.2186 13.817 27.7745 13.5618C27.3598 14.2052 26.8332 14.7697 26.2267 15.2222C26.2321 15.359 26.2347 15.4985 26.2347 15.638C26.2347 19.8777 23.1135 24.7653 17.4038 24.7653C15.6518 24.7653 14.0197 24.2339 12.646 23.3252C12.8884 23.3546 13.1362 23.3693 13.3866 23.3693C14.8402 23.3693 16.1793 22.8562 17.2413 21.9952C15.8827 21.9704 14.7372 21.0425 14.342 19.7685C14.5312 19.8061 14.7265 19.8254 14.9263 19.8254C15.2096 19.8254 15.484 19.7877 15.7442 19.7125C14.3234 19.4187 13.2534 18.1218 13.2534 16.5669V16.5275C13.6725 16.7661 14.152 16.912 14.6599 16.9276C13.827 16.3521 13.2791 15.37 13.2791 14.2576C13.2791 13.6701 13.4319 13.1185 13.6991 12.643C15.2309 14.5862 17.5174 15.862 20.097 15.996C20.0437 15.761 20.0171 15.5169 20.0171 15.2654C20.0171 13.4939 21.4068 12.0574 23.1197 12.0574C24.013 12.0574 24.8202 12.4466 25.3849 13.0698C26.0935 12.9266 26.7569 12.6595 27.3571 12.2924C27.1254 13.0414 26.6334 13.6701 25.9923 14.0666Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="xbm_accentbg xbm_accentbg--top">
                                <div
                                  data-xsb-template-onoff="w_social"
                                  className="c_block"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="xsbm_mail_xsolla">
                            <div>
                              Xsolla is an authorized global
                              distributor of Rune Ragnarock.{" "}
                              <br />© Xsolla 2018, All rights
                              reserved.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="xsb_bgz xsb_bgz--black" />
                  </div>
                  <div className="xsbm_mailbg_lr" />
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  )
}

export const SBps =({}) => {
  return (
    <div className="p_x_module0">
                    <h1 className="p_x_h1_graphic">Pay Station</h1>
                    <div id="ps0" className="p_x_module_grid">
                      <div className="l_sb0">
                        <div id="ps_methods" className="p_x_anchor" />
                        <div className="x_left0">
                          <div className="x_left0_sticky">
                            <div className="xsb_sett_block">
                              <div className="xx_set_head xx_set_head--main">
                                <div>
                                  <div data-xsb-settings-module-onoff="w_pack1">
                                    <div className="t_h2 t_bold">
                                      Platforms / email
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                data-xsb-settings-module="onoff"
                                data-xsb-settings-module-onoff-activetarget="w_buy"
                                className="xx_set_sect xx_set_sect--bg"
                              >
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Only one can be selected</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b inactive">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Send to friend</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="x_right0">
                          <div className="x_flex x_flex--center">
                            <div
                              data-xsb-template-type="ps_card"
                              className="xsb_c"
                            >
                              <div className="p_formgroup_xlg p_formgroup_xlg--top">
                                <div className="xsbps_b xsbps_b--rel">
                                  <div className="xsbps_bd">
                                    <div className="xccz">
                                      <div className="x_contentimage">
                                        <div className="x_contentimage_tint">
                                          <div className="x_temp_tint_1" />
                                        </div>
                                        <div
                                          data-xsb-bg="pic"
                                          className="xsb_bg_static xsb_bg_static--xsolla3"
                                        />
                                      </div>
                                    </div>
                                    <div className="xsbps_topmenu">
                                      <div className="xsbps_block" />
                                      <div className="xsbps_topmenu_x0">
                                        <div className="xsbps_topmenu_balance">
                                          <div className="xsbps_topmenu_balance_add">
                                            <div>+</div>
                                          </div>
                                          <div className="xsbps_topmenu_balance_text">
                                            120
                                          </div>
                                        </div>
                                        <div className="xsbps_topmenu_close" />
                                      </div>
                                    </div>
                                    <div className="xsbps_inner">
                                      <div className="xsbps_inner1">
                                        <div className="xsbps_column left">
                                          <div className="p_formgroup_lg">
                                            <div className="p_formgroup_lg">
                                              <div className="t_h2 t_bold">
                                                <div>Select platform</div>
                                              </div>
                                            </div>
                                            <div className="xsbps_block">
                                              <div className="xsbps_block_grid">
                                                <div
                                                  data-xsb-template-onoff="platforms_steam"
                                                  className="x_platform_icons x_radius x_platforms_icons_a"
                                                >
                                                  <div className="x_platform_inner">
                                                    <div className="p_x_head p_x_head--active">
                                                      <div className="l_flex l_flex--center">
                                                        <div className="x_platform_icons_svg w-embed">
                                                          <svg
                                                            width={56}
                                                            height={56}
                                                            viewBox="0 0 56 56"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                          >
                                                            <path
                                                              fillRule="evenodd"
                                                              clipRule="evenodd"
                                                              d="M11.2798 31.0211C12.288 31.0211 13.2767 30.5326 13.8739 29.6331C14.8278 28.2024 14.44 26.2639 13.0092 25.3101L10.5586 23.6739C10.9773 23.5615 11.4194 23.4994 11.8769 23.4994C14.6378 23.4994 16.8751 25.7366 16.8751 28.4971C16.8751 31.2576 14.6378 33.4947 11.8769 33.4947C9.1898 33.4947 6.99898 31.3739 6.88265 28.7181L9.55429 30.4977C10.0816 30.8505 10.6827 31.0211 11.2798 31.0211ZM31.668 0C35.15 0 38 2.84971 38 6.33527V31.6647C38 35.1503 35.15 38 31.668 38H6.33592C2.85 37.9961 0 35.1503 0 31.6609V24.1314L4.50184 27.1323C4.07143 29.478 4.75776 31.9865 6.57245 33.801C9.5 36.7283 14.25 36.7283 17.1776 33.801C18.9767 32.002 19.6708 29.5168 19.2598 27.1905L28.5 18.9128C30.2178 18.6646 31.8696 17.8814 33.1918 16.5632C36.4373 13.318 36.4373 8.05285 33.1918 4.80767C29.9463 1.56249 24.6806 1.56249 21.4351 4.80767C20.1129 6.12978 19.3335 7.78145 19.0853 9.49903L11.4892 21.0103C10.3065 21.0723 9.13551 21.4097 8.08469 22.0261L0 16.6369V6.33527C0 2.84971 2.85 0 6.33592 0H31.668ZM33.25 10.6854C33.25 7.40537 30.59 4.74952 27.3135 4.74952C24.0369 4.74952 21.3769 7.40924 21.3769 10.6854C21.3769 13.9616 24.0369 16.6214 27.3135 16.6214C30.59 16.6214 33.25 13.9655 33.25 10.6854ZM23.75 10.6854C23.75 8.71972 25.3437 7.12233 27.3135 7.12233C29.2833 7.12233 30.8769 8.71585 30.8769 10.6854C30.8769 12.655 29.2833 14.2485 27.3135 14.2485C25.3437 14.2485 23.75 12.655 23.75 10.6854Z"
                                                              transform="translate(9 9)"
                                                              fill="currentColor"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="ps_platf">
                                                      <div className="l_flex l_flex--center">
                                                        <div>
                                                          <div className="x_platform_icons_svg w-embed">
                                                            <svg
                                                              width={36}
                                                              height={36}
                                                              viewBox="0 0 36 36"
                                                              fill="none"
                                                              xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                              <path
                                                                d="M7.07143 25.9203L16.0297 27.1549V18.6039H7.07143V25.9203Z"
                                                                fill="currentColor"
                                                              />
                                                              <path
                                                                d="M7.07143 17.5013H16.0297V8.84521L7.07143 10.0799V17.5013Z"
                                                                fill="currentColor"
                                                              />
                                                              <path
                                                                d="M17.0148 27.2865L28.9285 28.9282V18.604V18.6039H17.0148V27.2865Z"
                                                                fill="currentColor"
                                                              />
                                                              <path
                                                                d="M17.0148 8.71331V17.5008H28.9283V7.07141L17.0148 8.71331Z"
                                                                fill="currentColor"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </div>
                                                        <div>
                                                          <div>Windows</div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div
                                                  data-xsb-template-onoff="platforms_steam"
                                                  className="x_platform_icons"
                                                >
                                                  <div className="x_platform_inner x_radius">
                                                    <div className="p_x_head">
                                                      <div className="l_flex l_flex--center">
                                                        <div className="x_platform_icons_svg w-embed">
                                                          <svg
                                                            width={56}
                                                            height={56}
                                                            viewBox="0 0 56 56"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                          >
                                                            <path
                                                              fillRule="evenodd"
                                                              clipRule="evenodd"
                                                              d="M11.2798 31.0211C12.288 31.0211 13.2767 30.5326 13.8739 29.6331C14.8278 28.2024 14.44 26.2639 13.0092 25.3101L10.5586 23.6739C10.9773 23.5615 11.4194 23.4994 11.8769 23.4994C14.6378 23.4994 16.8751 25.7366 16.8751 28.4971C16.8751 31.2576 14.6378 33.4947 11.8769 33.4947C9.1898 33.4947 6.99898 31.3739 6.88265 28.7181L9.55429 30.4977C10.0816 30.8505 10.6827 31.0211 11.2798 31.0211ZM31.668 0C35.15 0 38 2.84971 38 6.33527V31.6647C38 35.1503 35.15 38 31.668 38H6.33592C2.85 37.9961 0 35.1503 0 31.6609V24.1314L4.50184 27.1323C4.07143 29.478 4.75776 31.9865 6.57245 33.801C9.5 36.7283 14.25 36.7283 17.1776 33.801C18.9767 32.002 19.6708 29.5168 19.2598 27.1905L28.5 18.9128C30.2178 18.6646 31.8696 17.8814 33.1918 16.5632C36.4373 13.318 36.4373 8.05285 33.1918 4.80767C29.9463 1.56249 24.6806 1.56249 21.4351 4.80767C20.1129 6.12978 19.3335 7.78145 19.0853 9.49903L11.4892 21.0103C10.3065 21.0723 9.13551 21.4097 8.08469 22.0261L0 16.6369V6.33527C0 2.84971 2.85 0 6.33592 0H31.668ZM33.25 10.6854C33.25 7.40537 30.59 4.74952 27.3135 4.74952C24.0369 4.74952 21.3769 7.40924 21.3769 10.6854C21.3769 13.9616 24.0369 16.6214 27.3135 16.6214C30.59 16.6214 33.25 13.9655 33.25 10.6854ZM23.75 10.6854C23.75 8.71972 25.3437 7.12233 27.3135 7.12233C29.2833 7.12233 30.8769 8.71585 30.8769 10.6854C30.8769 12.655 29.2833 14.2485 27.3135 14.2485C25.3437 14.2485 23.75 12.655 23.75 10.6854Z"
                                                              transform="translate(9 9)"
                                                              fill="currentColor"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="ps_platf">
                                                      <div className="l_flex l_flex--center">
                                                        <div>
                                                          <div className="x_platform_icons_svg w-embed">
                                                            <svg
                                                              width={36}
                                                              height={36}
                                                              viewBox="0 0 36 36"
                                                              fill="none"
                                                              xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                              <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M19.8762 12.2519C20.3916 11.5753 20.7824 10.619 20.6411 9.64282C19.7986 9.70236 18.8139 10.2504 18.2393 10.9648C17.7156 11.6122 17.2851 12.5751 17.4532 13.5097C18.3742 13.539 19.3247 12.9776 19.8762 12.2519V12.2519ZM24.4286 21.4343C24.06 22.2697 23.8826 22.6429 23.4078 23.3829C22.7455 24.4157 21.8116 25.7018 20.6532 25.7113C19.6251 25.7226 19.36 25.0262 17.9642 25.0347C16.5684 25.0422 16.2774 25.7245 15.2475 25.7141C14.09 25.7037 13.2051 24.5433 12.5427 23.5104C10.6897 20.6245 10.4948 17.2367 11.6375 15.4347C12.4504 14.1552 13.7325 13.4067 14.9371 13.4067C16.1629 13.4067 16.9342 14.0947 17.9494 14.0947C18.9341 14.0947 19.5336 13.4049 20.9516 13.4049C22.025 13.4049 23.1621 14.003 23.9713 15.0349C21.3183 16.5223 21.7479 20.3977 24.4286 21.4343V21.4343Z"
                                                                fill="currentColor"
                                                              />
                                                              <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M24.4286 6.42854H11.5714C8.7311 6.42854 6.42857 8.73107 6.42857 11.5714V25.0714C6.42857 27.9117 8.7311 30.2143 11.5714 30.2143H24.4286C27.2689 30.2143 29.5714 27.9117 29.5714 25.0714V11.5714C29.5714 8.73107 27.2689 6.42854 24.4286 6.42854ZM11.5714 5.14282C8.02102 5.14282 5.14285 8.02099 5.14285 11.5714V25.0714C5.14285 28.6218 8.02102 31.5 11.5714 31.5H24.4286C27.979 31.5 30.8571 28.6218 30.8571 25.0714V11.5714C30.8571 8.02099 27.979 5.14282 24.4286 5.14282H11.5714Z"
                                                                fill="currentColor"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </div>
                                                        <div>
                                                          <div>Mac OS X</div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div
                                                  data-xsb-template-onoff="platforms_steam"
                                                  className="x_platform_icons x_radius"
                                                >
                                                  <div className="x_platform_inner">
                                                    <div className="p_x_head">
                                                      <div className="l_flex l_flex--center">
                                                        <div className="x_platform_icons_svg w-embed">
                                                          <svg
                                                            width={56}
                                                            height={56}
                                                            viewBox="0 0 56 56"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                          >
                                                            <path
                                                              fillRule="evenodd"
                                                              clipRule="evenodd"
                                                              d="M18.8736 22.3269C19.3162 22.3269 19.6728 22.6993 19.6728 23.1614V23.1674V27.3613C19.6728 27.8207 19.3162 28.1981 18.8736 28.1981L18.8643 28.1931V28.1981H14.8247V28.1931L14.8159 28.1981C14.3716 28.1981 14.0149 27.8207 14.0149 27.3613V23.1674V23.1614C14.0149 22.6993 14.3715 22.3269 14.8159 22.3269H14.8247H18.8643H18.8736ZM21.0599 2.83705C21.513 2.83705 21.8657 3.21628 21.8657 3.68342V3.69023V7.9428V7.94827C21.8657 8.41629 21.513 8.79646 21.0599 8.79646H21.0511H16.949H16.9433C16.4915 8.79646 16.1296 8.41629 16.1296 7.94827V7.9428V3.69023V3.68342C16.1296 3.21632 16.4915 2.83705 16.9433 2.83705H16.949H21.0511H21.0599V2.83705ZM38 14.5393C38 15.758 37.049 16.7401 35.8812 16.7401H26.7905V13.9033H34.4487H34.4544C34.9071 13.9033 35.2699 13.5222 35.2699 13.056V13.0501V3.69011V3.68375C35.2699 3.21664 34.9071 2.83694 34.4544 2.83694H34.4487H30.3434H30.3355C29.8898 2.83694 29.5257 3.21664 29.5257 3.68375V3.69011V7.9427V7.94816C29.5257 8.41617 29.8898 8.79635 30.3355 8.79635H30.3434H33.6238V11.6322H28.9104C27.7382 11.6322 26.7903 10.6488 26.7903 9.43324V2.2003C26.7903 0.986077 27.7382 8.00278e-07 28.9104 8.00278e-07H35.8807C37.0484 8.00278e-07 37.9995 0.986113 37.9995 2.2003V14.5392L38 14.5393ZM37.9921 30.9923H35.2982V22.3273H33.415H33.4058C32.9601 22.3273 32.6048 22.6997 32.6048 23.1618V23.1677V30.9925H29.9114V22.3275H28.0237H28.0176C27.5719 22.3275 27.2157 22.6999 27.2157 23.162V23.1679V31H24.5227V21.6947C24.5227 20.5033 25.4558 19.5326 26.6116 19.5326H37.9922V30.9926L37.9921 30.9923ZM22.4859 11.6325H15.5132C14.3432 11.6325 13.3957 10.6491 13.3957 9.43353V2.20059C13.3957 0.986366 14.3432 0.000289789 15.5132 0.000289789H22.4859C23.6537 0.000289789 24.6039 0.986402 24.6039 2.20059V9.43353C24.6039 10.6491 23.6537 11.6325 22.4859 11.6325V11.6325ZM22.3658 28.8256C22.3658 30.0221 21.4305 30.9923 20.2781 30.9923H13.4106C12.2539 30.9923 11.3212 30.0221 11.3212 28.8256V21.6943C11.3212 20.5029 12.2538 19.5323 13.4106 19.5323H20.2781C21.4305 19.5323 22.3658 20.5029 22.3658 21.6943V28.8256ZM11.2095 14.5393C11.2095 15.758 10.2593 16.7401 9.08893 16.7401H-1.02814e-06V13.9033H7.65534H7.66324C8.11462 13.9033 8.47608 13.5222 8.47608 13.056V13.0501V3.69011V3.68375C8.47608 3.21664 8.11462 2.83694 7.66324 2.83694H7.65534H3.55429H3.54464C3.09456 2.83694 2.73265 3.21664 2.73265 3.68375V3.69011V7.9427V7.94816C2.73265 8.41617 3.09453 8.79635 3.54464 8.79635H3.55429H6.83513V11.6322H2.11889C0.947182 11.6322 0.000106069 10.6488 0.000106069 9.43324V2.2003C0.000106069 0.986077 0.947217 8.00278e-07 2.11889 8.00278e-07H9.08885C10.2592 8.00278e-07 11.2094 0.986113 11.2094 2.2003V14.5392L11.2095 14.5393ZM9.16483 22.3269H3.51053H3.50217C3.05736 22.3269 2.70071 22.6993 2.70071 23.1614L2.70247 23.1674H2.70071V27.3613H2.70247L2.70071 27.3635C2.70071 27.8233 3.05733 28.2012 3.50217 28.2012H3.51053H4.09617H9.1651V30.9993H2.09759V30.992C0.942129 30.992 0.00687463 30.0218 0.00687463 28.8253V21.694C0.00687463 20.5026 0.942129 19.5319 2.09759 19.5319H9.1651V22.3269L9.16483 22.3269Z"
                                                              transform="translate(9 12)"
                                                              fill="currentColor"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="ps_platf">
                                                      <div className="l_flex l_flex--center">
                                                        <div>
                                                          <div className="x_platform_icons_svg w-embed">
                                                            <svg
                                                              width={36}
                                                              height={36}
                                                              viewBox="0 0 36 36"
                                                              fill="none"
                                                              xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                              <path
                                                                d="M7.07143 25.9203L16.0297 27.1549V18.6039H7.07143V25.9203Z"
                                                                fill="currentColor"
                                                              />
                                                              <path
                                                                d="M7.07143 17.5013H16.0297V8.84521L7.07143 10.0799V17.5013Z"
                                                                fill="currentColor"
                                                              />
                                                              <path
                                                                d="M17.0148 27.2865L28.9285 28.9282V18.604V18.6039H17.0148V27.2865Z"
                                                                fill="currentColor"
                                                              />
                                                              <path
                                                                d="M17.0148 8.71331V17.5008H28.9283V7.07141L17.0148 8.71331Z"
                                                                fill="currentColor"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </div>
                                                        <div>
                                                          <div>Windows</div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="x_platform_icons_bg" />
                                                </div>
                                                <div
                                                  data-xsb-template-onoff="platforms_steam"
                                                  className="x_platform_icons"
                                                >
                                                  <div className="x_platform_inner x_radius">
                                                    <div className="p_x_head">
                                                      <div className="l_flex l_flex--center">
                                                        <div className="x_platform_icons_svg w-embed">
                                                          <svg
                                                            width={56}
                                                            height={56}
                                                            viewBox="0 0 56 56"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                          >
                                                            <path
                                                              fillRule="evenodd"
                                                              clipRule="evenodd"
                                                              d="M18.8736 22.3269C19.3162 22.3269 19.6728 22.6993 19.6728 23.1614V23.1674V27.3613C19.6728 27.8207 19.3162 28.1981 18.8736 28.1981L18.8643 28.1931V28.1981H14.8247V28.1931L14.8159 28.1981C14.3716 28.1981 14.0149 27.8207 14.0149 27.3613V23.1674V23.1614C14.0149 22.6993 14.3715 22.3269 14.8159 22.3269H14.8247H18.8643H18.8736ZM21.0599 2.83705C21.513 2.83705 21.8657 3.21628 21.8657 3.68342V3.69023V7.9428V7.94827C21.8657 8.41629 21.513 8.79646 21.0599 8.79646H21.0511H16.949H16.9433C16.4915 8.79646 16.1296 8.41629 16.1296 7.94827V7.9428V3.69023V3.68342C16.1296 3.21632 16.4915 2.83705 16.9433 2.83705H16.949H21.0511H21.0599V2.83705ZM38 14.5393C38 15.758 37.049 16.7401 35.8812 16.7401H26.7905V13.9033H34.4487H34.4544C34.9071 13.9033 35.2699 13.5222 35.2699 13.056V13.0501V3.69011V3.68375C35.2699 3.21664 34.9071 2.83694 34.4544 2.83694H34.4487H30.3434H30.3355C29.8898 2.83694 29.5257 3.21664 29.5257 3.68375V3.69011V7.9427V7.94816C29.5257 8.41617 29.8898 8.79635 30.3355 8.79635H30.3434H33.6238V11.6322H28.9104C27.7382 11.6322 26.7903 10.6488 26.7903 9.43324V2.2003C26.7903 0.986077 27.7382 8.00278e-07 28.9104 8.00278e-07H35.8807C37.0484 8.00278e-07 37.9995 0.986113 37.9995 2.2003V14.5392L38 14.5393ZM37.9921 30.9923H35.2982V22.3273H33.415H33.4058C32.9601 22.3273 32.6048 22.6997 32.6048 23.1618V23.1677V30.9925H29.9114V22.3275H28.0237H28.0176C27.5719 22.3275 27.2157 22.6999 27.2157 23.162V23.1679V31H24.5227V21.6947C24.5227 20.5033 25.4558 19.5326 26.6116 19.5326H37.9922V30.9926L37.9921 30.9923ZM22.4859 11.6325H15.5132C14.3432 11.6325 13.3957 10.6491 13.3957 9.43353V2.20059C13.3957 0.986366 14.3432 0.000289789 15.5132 0.000289789H22.4859C23.6537 0.000289789 24.6039 0.986402 24.6039 2.20059V9.43353C24.6039 10.6491 23.6537 11.6325 22.4859 11.6325V11.6325ZM22.3658 28.8256C22.3658 30.0221 21.4305 30.9923 20.2781 30.9923H13.4106C12.2539 30.9923 11.3212 30.0221 11.3212 28.8256V21.6943C11.3212 20.5029 12.2538 19.5323 13.4106 19.5323H20.2781C21.4305 19.5323 22.3658 20.5029 22.3658 21.6943V28.8256ZM11.2095 14.5393C11.2095 15.758 10.2593 16.7401 9.08893 16.7401H-1.02814e-06V13.9033H7.65534H7.66324C8.11462 13.9033 8.47608 13.5222 8.47608 13.056V13.0501V3.69011V3.68375C8.47608 3.21664 8.11462 2.83694 7.66324 2.83694H7.65534H3.55429H3.54464C3.09456 2.83694 2.73265 3.21664 2.73265 3.68375V3.69011V7.9427V7.94816C2.73265 8.41617 3.09453 8.79635 3.54464 8.79635H3.55429H6.83513V11.6322H2.11889C0.947182 11.6322 0.000106069 10.6488 0.000106069 9.43324V2.2003C0.000106069 0.986077 0.947217 8.00278e-07 2.11889 8.00278e-07H9.08885C10.2592 8.00278e-07 11.2094 0.986113 11.2094 2.2003V14.5392L11.2095 14.5393ZM9.16483 22.3269H3.51053H3.50217C3.05736 22.3269 2.70071 22.6993 2.70071 23.1614L2.70247 23.1674H2.70071V27.3613H2.70247L2.70071 27.3635C2.70071 27.8233 3.05733 28.2012 3.50217 28.2012H3.51053H4.09617H9.1651V30.9993H2.09759V30.992C0.942129 30.992 0.00687463 30.0218 0.00687463 28.8253V21.694C0.00687463 20.5026 0.942129 19.5319 2.09759 19.5319H9.1651V22.3269L9.16483 22.3269Z"
                                                              transform="translate(9 12)"
                                                              fill="currentColor"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="ps_platf">
                                                      <div className="l_flex l_flex--center">
                                                        <div>
                                                          <div className="x_platform_icons_svg w-embed">
                                                            <svg
                                                              width={36}
                                                              height={36}
                                                              viewBox="0 0 36 36"
                                                              fill="none"
                                                              xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                              <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M19.8762 12.2519C20.3916 11.5753 20.7824 10.619 20.6411 9.64282C19.7986 9.70236 18.8139 10.2504 18.2393 10.9648C17.7156 11.6122 17.2851 12.5751 17.4532 13.5097C18.3742 13.539 19.3247 12.9776 19.8762 12.2519V12.2519ZM24.4286 21.4343C24.06 22.2697 23.8826 22.6429 23.4078 23.3829C22.7455 24.4157 21.8116 25.7018 20.6532 25.7113C19.6251 25.7226 19.36 25.0262 17.9642 25.0347C16.5684 25.0422 16.2774 25.7245 15.2475 25.7141C14.09 25.7037 13.2051 24.5433 12.5427 23.5104C10.6897 20.6245 10.4948 17.2367 11.6375 15.4347C12.4504 14.1552 13.7325 13.4067 14.9371 13.4067C16.1629 13.4067 16.9342 14.0947 17.9494 14.0947C18.9341 14.0947 19.5336 13.4049 20.9516 13.4049C22.025 13.4049 23.1621 14.003 23.9713 15.0349C21.3183 16.5223 21.7479 20.3977 24.4286 21.4343V21.4343Z"
                                                                fill="currentColor"
                                                              />
                                                              <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M24.4286 6.42854H11.5714C8.7311 6.42854 6.42857 8.73107 6.42857 11.5714V25.0714C6.42857 27.9117 8.7311 30.2143 11.5714 30.2143H24.4286C27.2689 30.2143 29.5714 27.9117 29.5714 25.0714V11.5714C29.5714 8.73107 27.2689 6.42854 24.4286 6.42854ZM11.5714 5.14282C8.02102 5.14282 5.14285 8.02099 5.14285 11.5714V25.0714C5.14285 28.6218 8.02102 31.5 11.5714 31.5H24.4286C27.979 31.5 30.8571 28.6218 30.8571 25.0714V11.5714C30.8571 8.02099 27.979 5.14282 24.4286 5.14282H11.5714Z"
                                                                fill="currentColor"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </div>
                                                        <div>
                                                          <div>Mac OS X</div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="x_platform_icons_bg" />
                                                </div>
                                                <div
                                                  data-xsb-template-onoff="platforms_steam"
                                                  className="x_platform_icons"
                                                >
                                                  <div className="x_platform_inner x_radius">
                                                    <div className="p_x_head">
                                                      <div className="l_flex l_flex--center">
                                                        <div className="x_platform_icons_svg w-embed">
                                                          {/*Nintendo Switch*/}
                                                          <svg
                                                            width={56}
                                                            height={56}
                                                            viewBox="0 0 56 56"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                          >
                                                            <path
                                                              d="M16.1639 21.9092C16.1639 20.1965 17.5389 18.8202 19.25 18.8202C20.9611 18.8202 22.3361 20.1965 22.3361 21.9092C22.3361 23.6219 20.9611 24.9981 19.25 24.9981C17.5389 24.9981 16.1639 23.6219 16.1639 21.9092ZM24.2611 14.6608H19.4639C17.9361 14.6608 16.4389 15.2725 15.3694 16.3735C14.2694 17.4439 13.6583 18.9425 13.6583 20.4717V36.5589C13.6583 38.1186 14.2694 39.5561 15.3694 40.6571C16.4389 41.7581 17.9361 42.3698 19.4639 42.3698H24.2611C24.2611 42.3392 24.2611 14.6608 24.2611 14.6608ZM26.675 45H19.4639C14.7889 45 11 41.2076 11 36.5283V20.4717C11 15.7924 14.7889 12 19.4639 12H26.675C26.7972 12 26.9194 12.1223 26.9194 12.2447V44.7553C26.9194 44.9082 26.7972 45 26.675 45ZM36.7583 26.8332C34.925 26.8332 33.4278 28.3318 33.4278 30.1668C33.4278 32.0019 34.925 33.5005 36.7583 33.5005C38.5917 33.5005 40.0889 32.0019 40.0889 30.1668C40.0889 28.3318 38.5917 26.8332 36.7583 26.8332ZM35.5361 45H30.4639C30.3417 45 30.2194 44.8777 30.2194 44.7553V12.2141C30.2194 12.0918 30.3111 12 30.4333 12H35.5361C40.2111 12 44 15.7924 44 20.4717V36.5589C44 41.2382 40.2111 45 35.5361 45Z"
                                                              fill="currentColor"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="ps_platf">
                                                      <div className="l_flex l_flex--center">
                                                        <div>
                                                          <div>
                                                            Nintendo Switch
                                                            Store
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="x_platform_icons_bg" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="p_formgroup_lg">
                                            <div className="p_formgroup_lg">
                                              <div className="t_h2 t_bold">
                                                <div>Send the keys to</div>
                                              </div>
                                            </div>
                                            <div className="xsbps_block">
                                              <div className="input_block">
                                                <div className="input focused">
                                                  <div className="x_login_placeholder">
                                                    Email
                                                  </div>
                                                </div>
                                                <div className="error_message hide">
                                                  This is some text inside of a
                                                  div block.
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="p_formgroup_lg">
                                            <div className="xsbps_block">
                                              <div className="l_flex l_flex--right">
                                                <div className="button_primary x_radius button_primary--disabled">
                                                  <div>Next</div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="xccz">
                                        <div className="x_contentimage">
                                          <div className="x_contentimage_tint">
                                            <div className="x_temp_tint_ps">
                                              <div className="xbm_accentbg xbm_accentbg--top" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="xsbps_foo0">
                                      <div className="xsbps_footer">
                                        <div className="xsbps_footer_block links">
                                          <div>
                                            Xsolla is an authorized video game
                                            software distributor providing
                                            clients with advanced technical
                                            tools for their games.
                                          </div>
                                          <div className="xsbps_footer_linkblock">
                                            <a
                                              href="#"
                                              className="xsbps_footer_link_block first w-inline-block"
                                            >
                                              <div>Contact Us</div>
                                            </a>
                                            <a
                                              href="#"
                                              className="xsbps_footer_link_block w-inline-block"
                                            >
                                              <div>Privacy Policy</div>
                                            </a>
                                            <a
                                              href="#"
                                              className="xsbps_footer_link_block w-inline-block"
                                            >
                                              <div>User Agreement</div>
                                            </a>
                                          </div>
                                        </div>
                                        <div className="xsbps_footer_block lock">
                                          <div>
                                            Xsolla, 2018
                                            <br />
                                            Secure connection
                                          </div>
                                        </div>
                                        <div className="xccz">
                                          <div className="x_contentimage">
                                            <div className="x_contentimage_tint">
                                              <div className="x_temp_foo">
                                                <div className="xbm_accentbg xbm_accentbg--top" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="temp_settings-2" />
                            </div>
                          </div>
                          <div className="xccz xccz--rel">
                            <div className="x_contentimage">
                              <div className="x_contentimage_tint">
                                <section
                                  id="xsbm_login_w1"
                                  className="x_temp_tint_1 x_temp_tint_1--dark"
                                />
                              </div>
                              <div className="x_contentimage_static">
                                <div className="x_temp_pic1" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="l_sb0">
                        <div id="ps_card" className="p_x_anchor" />
                        <div className="x_left0">
                          <div className="x_left0_sticky">
                            <div className="xsb_sett_block">
                              <div className="xx_set_head xx_set_head--main">
                                <div>
                                  <div data-xsb-settings-module-onoff="w_pack1">
                                    <div className="t_h2 t_bold">
                                      Credit card payment
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                data-xsb-settings-module="onoff"
                                data-xsb-settings-module-onoff-activetarget="w_buy"
                                className="xx_set_sect xx_set_sect--bg"
                              >
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Logo</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Card logos</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Save card</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="x_right0">
                          <div className="x_flex x_flex--center">
                            <div
                              data-xsb-template-type="ps_card"
                              className="xsb_c"
                            >
                              <div className="p_formgroup_xlg p_formgroup_xlg--top">
                                <div className="xsbps_b xsbps_b--rel">
                                  <div className="xsbps_bd">
                                    <div className="xccz">
                                      <div className="x_contentimage">
                                        <div className="x_contentimage_tint">
                                          <div className="x_temp_tint_1" />
                                        </div>
                                        <div
                                          data-xsb-bg="pic"
                                          className="xsb_bg_static xsb_bg_static--xsolla3"
                                        />
                                      </div>
                                    </div>
                                    <div className="xsbps_topmenu">
                                      <div>
                                        <a
                                          href="#"
                                          className="xsbps_link-back w-inline-block"
                                        >
                                          <div className="t_white">
                                            <div className="l_flex">
                                              <div className="xx_ps_but_ico">
                                                <div>keyboard_arrow_right</div>
                                              </div>
                                              <div className="t_white">
                                                Back to payment methods
                                              </div>
                                            </div>
                                          </div>
                                        </a>
                                      </div>
                                      <div className="xsbps_topmenu_x0">
                                        <div className="xsbps_topmenu_balance">
                                          <div className="xsbps_topmenu_balance_add">
                                            <div>+</div>
                                          </div>
                                          <div className="xsbps_topmenu_balance_text">
                                            120
                                          </div>
                                        </div>
                                        <div className="xsbps_topmenu_close" />
                                      </div>
                                    </div>
                                    <div className="xsbps_inner">
                                      <div className="xsbps_inner1">
                                        <div className="xsbps_2cols">
                                          <div className="xsbps_column left">
                                            <div className="p_formgroup_lg">
                                              <div className="t_h2 t_bold">
                                                <div>
                                                  Pay via credit/debit card
                                                </div>
                                              </div>
                                            </div>
                                            <div className="xsbps_block">
                                              <div className="xsbps_cardblock">
                                                <div className="xsbps_form w-form">
                                                  <form
                                                    id="wf-form-xsbps_form"
                                                    name="wf-form-xsbps_form"
                                                    data-name="xsbps_form"
                                                  >
                                                    <label
                                                      htmlFor="name"
                                                      className="xsbps_input-title"
                                                    >
                                                      Card number
                                                    </label>
                                                    <input
                                                      type="text"
                                                      className="xsbps_input long focused w-input"
                                                      maxLength={256}
                                                      name="name-2"
                                                      data-name="Name 2"
                                                      placeholder="Enter card number"
                                                      id="name-2"
                                                      required
                                                    />
                                                    <div className="xsbps_input-block">
                                                      <div className="xsbps_input-title">
                                                        <label
                                                          htmlFor="Expiration-date"
                                                          className="xsbps_input-title"
                                                        >
                                                          Expiration date
                                                        </label>
                                                        <div className="xsbps_input-block">
                                                          <input
                                                            type="text"
                                                            className="xsbps_input short w-input"
                                                            maxLength={256}
                                                            name="Expiration-date-5"
                                                            data-name="Expiration Date 5"
                                                            placeholder={12}
                                                            id="Expiration-date-5"
                                                            required
                                                          />
                                                          <input
                                                            type="text"
                                                            className="xsbps_input short w-input"
                                                            maxLength={256}
                                                            name="Expiration-date-2"
                                                            data-name="Expiration date 2"
                                                            placeholder={12}
                                                            id="Expiration-date-4"
                                                            required
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="xsbps_input-title">
                                                        <label
                                                          htmlFor="Zip"
                                                          className="xsbps_input-title"
                                                        >
                                                          ZIp-Code
                                                        </label>
                                                        <input
                                                          type="text"
                                                          className="xsbps_input middle w-input"
                                                          maxLength={256}
                                                          name="Zip-2"
                                                          data-name="Zip 2"
                                                          placeholder={90210}
                                                          id="Zip-2"
                                                          required
                                                        />
                                                      </div>
                                                      <div className="xsbps_input-cvv">
                                                        <label
                                                          htmlFor="Cvv"
                                                          className="xsbps_input-title"
                                                        >
                                                          CVV2/CVC2
                                                        </label>
                                                        <input
                                                          type="password"
                                                          className="xsbps_input middle cvv w-input"
                                                          maxLength={256}
                                                          name="Cvv-2"
                                                          data-name="Cvv 2"
                                                          placeholder={123}
                                                          id="Cvv-2"
                                                          required
                                                        />
                                                      </div>
                                                    </div>

                                                  </form>
                                                  <div className="w-form-done">
                                                    <div>
                                                      Thank you! Your submission
                                                      has been received!
                                                    </div>
                                                  </div>
                                                  <div className="w-form-fail">
                                                    <div>
                                                      Oops! Something went wrong
                                                      while submitting the form.
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="xsbps_cardblock_bg">
                                                  <div className="xsbps_cardblock_card">
                                                    <div className="xsbps_card_bg" />
                                                  </div>
                                                  <div className="xsbps_cardblock_card xsbps_cardblock_card_cvv">
                                                    <div className="xsbps_card_bg">
                                                      <div className="xbm_accentbg xbm_accentbg--top" />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="xsbps_block">
                                              <div className="xsbps_psblock">
                                                <div className="xsbps_radio-ps" />
                                                <div className="xsbps_radio-ps _2" />
                                                <div className="xsbps_radio-ps _3" />
                                                <div className="xsbps_radio-ps _4" />
                                              </div>
                                            </div>
                                            <div className="xsbps_block">
                                              <div className="xsbps_block">
                                                <a
                                                  href="#"
                                                  className="xsbps_checkbox w-inline-block"
                                                >
                                                  <div className="xsbps_checkbox_icon" />
                                                  <div className="t_white">
                                                    Save this card for future
                                                    payments
                                                  </div>
                                                </a>
                                              </div>
                                            </div>
                                            <div className="xsbps_block">
                                              <div className="xsbps_textblock xsbps_textblock--disc">
                                                <div>
                                                  By submitting payment
                                                  information you acknowledge
                                                  that you have read and agree
                                                  to be bound by Xsolla’s
                                                  End-User License Agreement and
                                                  Privacy Policy. Please note
                                                  that the merchant name on your
                                                  payment method statement will
                                                  read as: Xsolla USA Inc.
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="xsbps_column right">
                                            <div className="xsbps_titleblock right">
                                              <div>Order Summary</div>
                                            </div>
                                            <div className="p_formgroup_md">
                                              <ul className="xsbps_ul w-list-unstyled">
                                                <li className="xsbps_li-block">
                                                  <div className="xsbps_li-text">
                                                    <div className="xsbps_li-icon" />
                                                    <div>100 coins</div>
                                                  </div>
                                                  <div className="xsbps_li-price">
                                                    $59,99
                                                  </div>
                                                </li>
                                                <li className="xsbps_li-block">
                                                  <div className="xsbps_li-text">
                                                    <div className="xsbps_li-icon hide" />
                                                    <div>Subtotal</div>
                                                  </div>
                                                  <div className="xsbps_li-price">
                                                    $59,99
                                                  </div>
                                                </li>
                                                <li className="xsbps_li-block">
                                                  <div className="xsbps_li-text">
                                                    <div className="xsbps_li-icon hide" />
                                                    <div>
                                                      Payment System Fee
                                                    </div>
                                                  </div>
                                                  <div className="xsbps_li-price">
                                                    $0,00
                                                  </div>
                                                </li>
                                                <li className="xsbps_li-block total">
                                                  <div className="xsbps_li-text total">
                                                    <div className="xsbps_li-icon hide" />
                                                    <div>Total</div>
                                                  </div>
                                                  <div className="xsbps_li-price total">
                                                    $59,99
                                                  </div>
                                                </li>
                                              </ul>
                                            </div>
                                            <div className="button_primary x_radius button_primary--disabled">
                                              <div>Pay now</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="xccz">
                                        <div className="x_contentimage">
                                          <div className="x_contentimage_tint">
                                            <div className="x_temp_tint_ps">
                                              <div className="xbm_accentbg xbm_accentbg--top" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="xsbps_footer">
                                      <div className="xsbps_footer_block links">
                                        <div>
                                          Xsolla is an authorized video game
                                          software distributor providing clients
                                          with advanced technical tools for
                                          their games.
                                        </div>
                                        <div className="xsbps_footer_linkblock">
                                          <a
                                            href="#"
                                            className="xsbps_footer_link_block first w-inline-block"
                                          >
                                            <div>Contact Us</div>
                                          </a>
                                          <a
                                            href="#"
                                            className="xsbps_footer_link_block w-inline-block"
                                          >
                                            <div>Privacy Policy</div>
                                          </a>
                                          <a
                                            href="#"
                                            className="xsbps_footer_link_block w-inline-block"
                                          >
                                            <div>User Agreement</div>
                                          </a>
                                        </div>
                                      </div>
                                      <div className="xsbps_footer_block lock">
                                        <div>
                                          Xsolla, 2018
                                          <br />
                                          Secure connection
                                        </div>
                                      </div>
                                      <div className="xccz">
                                        <div className="x_contentimage">
                                          <div className="x_contentimage_tint">
                                            <div className="x_temp_foo">
                                              <div className="xbm_accentbg xbm_accentbg--top" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="temp_settings-2" />
                            </div>
                          </div>
                          <div className="xccz xccz--rel">
                            <div className="x_contentimage">
                              <div className="x_contentimage_tint">
                                <section
                                  id="xsbm_login_w1"
                                  className="x_temp_tint_1 x_temp_tint_1--dark"
                                />
                              </div>
                              <div className="x_contentimage_static">
                                <div className="x_temp_pic1" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="l_sb0">
                        <div id="ps_card" className="p_x_anchor" />
                        <div className="x_left0">
                          <div className="x_left0_sticky">
                            <div className="xsb_sett_block">
                              <div className="xx_set_head xx_set_head--main">
                                <div>
                                  <div data-xsb-settings-module-onoff="w_pack1">
                                    <div className="t_h2 t_bold">
                                      Credit card payment
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                data-xsb-settings-module="onoff"
                                data-xsb-settings-module-onoff-activetarget="w_buy"
                                className="xx_set_sect xx_set_sect--bg"
                              >
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Logo</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Card logos</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Save card</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="x_right0 x_right0--deftheme">
                          <div className="x_flex x_flex--center">
                            <div
                              data-xsb-template-type="ps_card"
                              className="xsb_c"
                            >
                              <div className="p_formgroup_xlg p_formgroup_xlg--top">
                                <div className="xsbps_b xsbps_b--rel">
                                  <div className="xsbps_bd xsbps_bd--deftheme">
                                    <div className="xsbps_topmenu">
                                      <div>
                                        <div
                                          href="#"
                                          className="xsbps_link-back"
                                        >
                                          <div>
                                            <div className="l_flex">
                                              <div className="xx_ps_but_ico">
                                                <div>keyboard_arrow_right</div>
                                              </div>
                                              <div>Back to payment methods</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="xsbps_topmenu_x0">
                                        <div className="xsbps_topmenu_balance xsbps_topmenu_balance--default">
                                          <div className="xsbps_topmenu_balance_add xsbps_topmenu_balance_add--default">
                                            <div>+</div>
                                          </div>
                                          <div className="xsbps_topmenu_balance_text">
                                            120
                                          </div>
                                        </div>
                                        <div className="xsbps_topmenu_close" />
                                      </div>
                                    </div>
                                    <div className="xsbps_inner">
                                      <div className="xsbps_inner1">
                                        <div className="xsbps_2cols">
                                          <div className="xsbps_column left">
                                            <div className="p_formgroup_lg">
                                              <div className="t_h2 t_bold">
                                                <div>
                                                  Pay via credit/debit card
                                                </div>
                                              </div>
                                            </div>
                                            <div className="xsbps_block">
                                              <div className="xsbps_cardblock">
                                                <div className="xsbps_form w-form">
                                                  <form
                                                    id="wf-form-xsbps_form"
                                                    name="wf-form-xsbps_form"
                                                    data-name="xsbps_form"
                                                  >
                                                    <label
                                                      htmlFor="name-3"
                                                      className="xsbps_input-title"
                                                    >
                                                      Card number
                                                    </label>
                                                    <input
                                                      type="text"
                                                      className="xsbps_input long focused xsbps_input--default w-input"
                                                      autofocus="true"
                                                      maxLength={256}
                                                      name="name-2"
                                                      data-name="Name 2"
                                                      placeholder="Enter card number"
                                                      id="name-2"
                                                      required
                                                    />
                                                    <div className="xsbps_input-block">
                                                      <div className="xsbps_input-title">
                                                        <label
                                                          htmlFor="Expiration-date-6"
                                                          className="xsbps_input-title"
                                                        >
                                                          Expiration date
                                                        </label>
                                                        <div className="xsbps_input-block">
                                                          <input
                                                            type="text"
                                                            className="xsbps_input short w-input"
                                                            maxLength={256}
                                                            name="Expiration-date-5"
                                                            data-name="Expiration Date 5"
                                                            placeholder={12}
                                                            id="Expiration-date-5"
                                                            required
                                                          />
                                                          <input
                                                            type="text"
                                                            className="xsbps_input short w-input"
                                                            maxLength={256}
                                                            name="Expiration-date-2"
                                                            data-name="Expiration date 2"
                                                            placeholder={12}
                                                            id="Expiration-date-4"
                                                            required
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="xsbps_input-title">
                                                        <label
                                                          htmlFor="Zip-3"
                                                          className="xsbps_input-title"
                                                        >
                                                          ZIp-Code
                                                        </label>
                                                        <input
                                                          type="text"
                                                          className="xsbps_input middle w-input"
                                                          maxLength={256}
                                                          name="Zip-2"
                                                          data-name="Zip 2"
                                                          placeholder={90210}
                                                          id="Zip-2"
                                                          required
                                                        />
                                                      </div>
                                                      <div className="xsbps_input-cvv">
                                                        <label
                                                          htmlFor="Cvv-3"
                                                          className="xsbps_input-title"
                                                        >
                                                          CVV2/CVC2
                                                        </label>
                                                        <input
                                                          type="password"
                                                          className="xsbps_input middle cvv w-input"
                                                          maxLength={256}
                                                          name="Cvv-2"
                                                          data-name="Cvv 2"
                                                          placeholder={123}
                                                          id="Cvv-2"
                                                          required
                                                        />
                                                      </div>
                                                    </div>

                                                  </form>
                                                  <div className="w-form-done">
                                                    <div>
                                                      Thank you! Your submission
                                                      has been received!
                                                    </div>
                                                  </div>
                                                  <div className="w-form-fail">
                                                    <div>
                                                      Oops! Something went wrong
                                                      while submitting the form.
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="xsbps_cardblock_bg">
                                                  <div className="xsbps_cardblock_card">
                                                    <div className="xsbps_card_bg" />
                                                  </div>
                                                  <div className="xsbps_cardblock_card xsbps_cardblock_card_cvv">
                                                    <div className="xsbps_card_bg">
                                                      <div className="xbm_accentbg xbm_accentbg--default" />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="xsbps_block">
                                              <div
                                                href="#"
                                                className="xsbps_checkbox"
                                              >
                                                <div className="xsbps_checkbox_icon" />
                                                <div>
                                                  Save this card for future
                                                  payments
                                                </div>
                                              </div>
                                            </div>
                                            <div className="xsbps_block">
                                              <div className="xsbps_ref0">
                                                <div className="xsbps_ref">
                                                  <div className="xsbps_ref_icon">
                                                    <div className="xsbps_ref_icon w-embed">
                                                      <svg
                                                        className="xsbps_ref_icon1"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={48}
                                                        height={48}
                                                      >
                                                        <g
                                                          fill="none"
                                                          fillRule="evenodd"
                                                          stroke="currentColor"
                                                          strokeWidth={2}
                                                        >
                                                          <path d="M13.1 11.45v11.5-11.4c0-1.1-.8-2.1-2-2.1s-2.1.8-2.1 2v11.4-11.4c0-1.1-.9-2-2-2s-2 .9-2 2v16.3-5.8c0-1.7-1.3-3-3-3H1v8.9c0 2 .7 3.9 1.9 5.5l2.8 3.7c.3.3.5.7.5 1.2v9.7m10.8-25l.1-9.3m1.8 34.3v-10.2c1.3-3.4 2-7.1 2-10.8v-10" />
                                                          <path d="M13 30.95c0-2.2-1.8-4-4-4H3.9m19-23.6l-.7-.7c-2.2-2.2-5.8-2.2-8 0s-2.2 5.8 0 8l8.7 8.7 8.7-8.7c2.2-2.2 2.2-5.8 0-8s-5.8-2.2-8 0l-.7.7zm9.9 8.1v11.5-11.4c0-1.1.8-2.1 2-2.1 1.1 0 2.1.8 2.1 2v11.6-11.6c0-1.1.9-2 2-2s2 .9 2 2v16.3-5.8c0-1.7 1.3-3 3-3h1v8.9c0 2-.7 3.9-1.9 5.5l-2.8 3.7c-.3.3-.5.7-.5 1.2v9.7m-10.8-25l-.1-9.3" />
                                                          <path d="M27 47.95v-10.2c-1.3-3.4-2-7.1-2-10.8v-10m7.9 14c0-2.2 1.8-4 4-4h4" />
                                                        </g>
                                                      </svg>
                                                    </div>
                                                  </div>
                                                  <div className="xsbps_right">
                                                    <p className="xsbps_ref_h2">
                                                      Loyal refund policy
                                                    </p>
                                                    <p className="xsbps_ref_noti">
                                                      A refund guarantee for a
                                                      pre-order until any
                                                      playable content has been
                                                      delivered.{" "}
                                                      <a href="#" className="a">
                                                        Read more
                                                      </a>{" "}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="xsbps_column right">
                                            <div className="xbps_tower">
                                              <div className="xsbps_titleblock right">
                                                <div>Order Summary</div>
                                              </div>
                                              <div className="p_formgroup_md">
                                                <ul className="xsbps_ul w-list-unstyled">
                                                  <li className="xsbps_li-block">
                                                    <div className="xsbps_li-text">
                                                      <div>
                                                        Red dead Redemption 2:
                                                        Definitive Edition
                                                      </div>
                                                    </div>
                                                    <div className="xsbps_li-price">
                                                      $59,99
                                                    </div>
                                                  </li>
                                                  <li className="xsbps_li-block">
                                                    <div className="xsbps_li-text">
                                                      <div className="xsbps_li-icon hide" />
                                                      <div>Subtotal</div>
                                                    </div>
                                                    <div className="xsbps_li-price">
                                                      $59,99
                                                    </div>
                                                  </li>
                                                  <li className="xsbps_li-block">
                                                    <div className="xsbps_li-text">
                                                      <div className="xsbps_li-icon hide" />
                                                      <div>
                                                        Payment System Fee
                                                      </div>
                                                    </div>
                                                    <div className="xsbps_li-price">
                                                      $0,00
                                                    </div>
                                                  </li>
                                                  <li className="xsbps_li-block total">
                                                    <div className="xsbps_li-text total">
                                                      <div className="xsbps_li-icon hide" />
                                                      <div>Total</div>
                                                    </div>
                                                    <div className="xsbps_li-price total">
                                                      $59,99
                                                    </div>
                                                  </li>
                                                </ul>
                                              </div>
                                              <div className="button_primary button_primary--default">
                                                <div>Pay now</div>
                                              </div>
                                            </div>
                                            <div className="xsbps_block">
                                              <div className="xsbps_textblock xsbps_textblock--disc">
                                                <div>
                                                  By submitting payment
                                                  information you acknowledge
                                                  that you have read and agree
                                                  to be bound by{" "}
                                                  <a href="#">
                                                    Xsolla’s End-User License
                                                    Agreement
                                                  </a>{" "}
                                                  and{" "}
                                                  <a href="#">Privacy Policy</a>
                                                  . Please note that the
                                                  merchant name on your payment
                                                  method statement will read as:
                                                  Xsolla USA Inc.
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="xccz">
                                          <div className="x_contentimage">
                                            <div className="x_contentimage_tint">
                                              <div>
                                                <div className="xbm_accentbg xbm_accentbg--body2" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="xsbps_footer">
                                      <div className="xsbps_footer_block links">
                                        <div>
                                          Xsolla is an authorized video game
                                          software distributor providing clients
                                          with advanced technical tools for
                                          their games.
                                        </div>
                                        <div className="xsbps_footer_linkblock">
                                          <div
                                            href="#"
                                            className="xsbps_footer_link_block first"
                                          >
                                            <div>Contact Us</div>
                                          </div>
                                          <div
                                            href="#"
                                            className="xsbps_footer_link_block"
                                          >
                                            <div>Privacy Policy</div>
                                          </div>
                                          <div
                                            href="#"
                                            className="xsbps_footer_link_block"
                                          >
                                            <div>User Agreement</div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="xsbps_footer_block lock">
                                        <div>
                                          Xsolla, 2018
                                          <br />
                                          Secure connection
                                        </div>
                                      </div>
                                      <div className="xccz" />
                                    </div>
                                    <div className="xccz">
                                      <div className="x_contentimage">
                                        <div className="x_contentimage_tint">
                                          <div>
                                            <div className="xbm_accentbg xbm_accentbg--body" />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="temp_settings-2" />
                            </div>
                          </div>
                          <div className="xccz xccz--rel" />
                        </div>
                      </div>
                      <div className="l_sb0">
                        <div id="ps_mail" className="p_x_anchor" />
                        <div className="x_left0">
                          <div className="x_left0_sticky">
                            <div className="xx_set_head xx_set_head--main">
                              <div>
                                <div data-xsb-settings-module-onoff="w_pack1">
                                  <div className="t_h2 t_bold">
                                    Email:{" "}
                                    <span className="x_login_set_sel">
                                      check
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-xsb-settings-module="onoff"
                              data-xsb-settings-module-onoff-activetarget="w_buy"
                              className="xx_set_sect xx_set_sect--bg"
                            >
                              <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                <div className="l_width100">
                                  <div className="xsb_sett_toggle0">
                                    <div className="xsb_sett_toggle_b">
                                      <div className="xsb_sett_toggle_t" />
                                    </div>
                                    <div
                                      data-xsb-settings-module-onoff="hero_w_logo"
                                      className="xsb_sett_toggle_label"
                                    >
                                      <div>Logo image</div>
                                    </div>
                                  </div>
                                  <div className="xsb_module_but">
                                    <div className="xsb_global_settings_bg xsb_global_settings_bg--2">
                                      <div
                                        xsb_template_media_control="bg"
                                        className="xsb_media"
                                      >
                                        <div className="xsb_but_upload">
                                          <div className="w-embed">
                                            <svg
                                              width={24}
                                              height={24}
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M7.5 19C4.46243 19 2 16.5376 2 13.5C2 10.4624 4.46243 8 7.5 8C7.60002 8 7.69941 8.00267 7.79811 8.00794C8.8344 6.21016 10.7759 5 13 5C16.0561 5 18.5785 7.28485 18.9523 10.2395C20.7249 10.8436 22 12.5229 22 14.5C22 16.9853 19.9853 19 17.5 19H14V17.3852H17.9237C19.4108 17.3852 20.6163 16.1797 20.6163 14.6926C20.6163 13.5312 19.874 12.5112 18.793 12.1428C18.0138 11.8773 17.4541 11.1909 17.3508 10.3742C17.0806 8.23775 15.2526 6.61481 13.077 6.61481C11.5177 6.61481 10.106 7.44842 9.34063 8.77615C8.93545 9.47906 8.16968 9.89468 7.35951 9.85141C7.29113 9.84776 7.22239 9.84592 7.15332 9.84592C5.07141 9.84592 3.38369 11.5336 3.38369 13.6156C3.38369 15.6975 5.07141 17.3852 7.15332 17.3852H10V19H7.5ZM8 14L12 10L16 14H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V14H8Z"
                                                fill="currentColor"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                        <div className="xccz">
                                          <div className="x_contentimage">
                                            <div className="x_temp_pic1 x_temp_pic--2" />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-xsb-settings-module="onoff"
                              data-xsb-settings-module-onoff-activetarget="w_buy"
                              className="xx_set_sect"
                            >
                              <div className="xx_set_head">
                                <div className="xx_img_menu_left">
                                  <div data-xsb-settings-module-onoff="w_pack1">
                                    <div className="xsb_sett_head">
                                      Footer social
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_img_menu_right">
                                  <div className="xx_img_menu_li">
                                    <div className="xx_but_menu_icon xx_but_menu_icon--secondary">
                                      <div>delete</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="xx_set_menu xx_set_menu--noborder" />
                              <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                <div className="xx_set_line">
                                  <div className="x_flex x_flex--vcenter">
                                    <div className="xsb_sett_drag" />
                                    <div className="xsb_but_link_input">
                                      <div className="social_icon social_icon--sett w-embed">
                                        <svg
                                          width={39}
                                          height={36}
                                          viewBox="0 0 39 36"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M19.8 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.8 31.2004C26.7588 31.2004 32.4001 25.4249 32.4001 18.3004C32.4001 11.1759 26.7588 5.40039 19.8 5.40039ZM20.6293 18.2155V25.0514H17.8358V18.2158H16.4401V15.8601H17.8358V14.4458C17.8358 12.524 18.6238 11.3812 20.8629 11.3812H22.7269V13.7372H21.5618C20.6902 13.7372 20.6325 14.0664 20.6325 14.6808L20.6293 15.8598H22.7401L22.4931 18.2155H20.6293Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                      <div className="xsb_but_seturl_placeholder">
                                        <div>Facebook</div>
                                      </div>
                                      <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                        <div>expand_more</div>
                                      </div>
                                    </div>
                                    <div className="xx_but_menu_icon xx_but_menu_icon--link">
                                      <div>insert_link</div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_set_line">
                                  <div className="x_flex x_flex--vcenter">
                                    <div className="xsb_sett_drag" />
                                    <div className="xsb_but_link_input">
                                      <div className="social_icon social_icon--sett w-embed">
                                        <svg
                                          width={39}
                                          height={36}
                                          viewBox="0 0 39 36"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M19.2002 5.40039C12.2413 5.40039 6.6001 11.1759 6.6001 18.3004C6.6001 25.4249 12.2413 31.2004 19.2002 31.2004C26.159 31.2004 31.8002 25.4249 31.8002 18.3004C31.8002 11.1759 26.159 5.40039 19.2002 5.40039ZM16.4299 11.4615C17.1467 11.4281 17.3758 11.4199 19.2008 11.4199H19.1987C21.0244 11.4199 21.2526 11.4281 21.9694 11.4615C22.6848 11.495 23.1734 11.611 23.6018 11.7811C24.0442 11.9567 24.418 12.1918 24.7918 12.5745C25.1656 12.9569 25.3952 13.3408 25.5674 13.7933C25.7326 14.2307 25.846 14.7307 25.8796 15.4631C25.9118 16.197 25.9202 16.4315 25.9202 18.3C25.9202 20.1685 25.9118 20.4024 25.8796 21.1363C25.846 21.8685 25.7326 22.3685 25.5674 22.8061C25.3952 23.2585 25.1656 23.6424 24.7918 24.0248C24.4184 24.4075 24.0441 24.6431 23.6022 24.8189C23.1747 24.989 22.6858 25.1049 21.9704 25.1385C21.2535 25.1719 21.0252 25.1801 19.2 25.1801C17.3751 25.1801 17.1462 25.1719 16.4294 25.1385C15.7141 25.1049 15.2256 24.989 14.7981 24.8189C14.3563 24.6431 13.9814 24.4075 13.608 24.0248C13.2344 23.6424 13.0048 23.2585 12.833 22.806C12.6669 22.3685 12.5537 21.8686 12.5208 21.1362C12.4883 20.4023 12.4802 20.1685 12.4802 18.3C12.4802 16.4315 12.4886 16.1968 12.5206 15.463C12.5528 14.7308 12.6662 14.2307 12.8328 13.7931C13.005 13.3408 13.2346 12.9569 13.6085 12.5745C13.982 12.1919 14.3569 11.9569 14.7989 11.7811C15.2262 11.611 15.7145 11.495 16.4299 11.4615Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M18.5979 12.613C18.7149 12.6129 18.8409 12.6129 18.9768 12.613L19.2007 12.613C20.995 12.613 21.2077 12.6196 21.9162 12.6523C22.5714 12.6828 22.927 12.7942 23.1639 12.8877C23.4775 13.0116 23.7011 13.1597 23.9362 13.3989C24.1714 13.6382 24.317 13.866 24.4391 14.185C24.531 14.4256 24.6407 14.7873 24.6705 15.4538C24.7027 16.1743 24.7097 16.3907 24.7097 18.2149C24.7097 20.039 24.7027 20.2554 24.6705 20.976C24.6405 21.6424 24.531 22.0041 24.4391 22.2448C24.3172 22.5637 24.1714 22.7909 23.9362 23.0299C23.701 23.2692 23.4777 23.4173 23.1639 23.5412C22.9273 23.6351 22.5714 23.7462 21.9162 23.7767C21.2078 23.8094 20.995 23.8166 19.2007 23.8166C17.4063 23.8166 17.1937 23.8094 16.4853 23.7767C15.83 23.7459 15.4744 23.6346 15.2374 23.541C14.9238 23.4171 14.6998 23.269 14.4646 23.0298C14.2294 22.7906 14.0838 22.5633 13.9617 22.2442C13.8697 22.0035 13.7601 21.6418 13.7303 20.9754C13.6981 20.2549 13.6917 20.0384 13.6917 18.2132C13.6917 16.3879 13.6981 16.1726 13.7303 15.452C13.7603 14.7856 13.8697 14.4239 13.9617 14.183C14.0835 13.864 14.2294 13.6362 14.4646 13.3969C14.6998 13.1577 14.9238 13.0096 15.2374 12.8854C15.4743 12.7915 15.83 12.6804 16.4853 12.6498C17.1052 12.6213 17.3454 12.6128 18.5979 12.6113V12.613ZM22.7879 13.7487C22.3427 13.7487 21.9814 14.1157 21.9814 14.5687C21.9814 15.0215 22.3427 15.3889 22.7879 15.3889C23.2331 15.3889 23.5943 15.0215 23.5943 14.5687C23.5943 14.1158 23.2331 13.7484 22.7879 13.7484V13.7487ZM15.7499 18.2172C15.7499 16.2787 17.295 14.7071 19.2008 14.707C21.1066 14.707 22.6514 16.2787 22.6514 18.2172C22.6514 20.1556 21.1068 21.7266 19.2009 21.7266C17.2951 21.7266 15.7499 20.1556 15.7499 18.2172Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M19.2007 15.9375C20.4378 15.9375 21.4408 16.9575 21.4408 18.2159C21.4408 19.4741 20.4378 20.4943 19.2007 20.4943C17.9635 20.4943 16.9607 19.4741 16.9607 18.2159C16.9607 16.9575 17.9635 15.9375 19.2007 15.9375V15.9375Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                      <div className="xsb_but_seturl_placeholder">
                                        <div className="text-block-19">
                                          Instagram
                                        </div>
                                      </div>
                                      <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                        <div>expand_more</div>
                                      </div>
                                    </div>
                                    <div className="xx_but_menu_icon xx_but_menu_icon--link">
                                      <div>insert_link</div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_set_line">
                                  <div className="x_flex x_flex--vcenter">
                                    <div className="xsb_sett_drag" />
                                    <div className="xsb_but_link_input">
                                      <div className="social_icon social_icon--sett w-embed">
                                        <svg
                                          width={39}
                                          height={36}
                                          viewBox="0 0 39 36"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M7.19995 18.3004C7.19995 11.1759 12.8412 5.40039 19.8 5.40039C26.7588 5.40039 32.4001 11.1759 32.4001 18.3004C32.4001 25.4249 26.7588 31.2004 19.8 31.2004C12.8412 31.2004 7.19995 25.4249 7.19995 18.3004ZM26.4133 19.1647L24.0196 21.6062H20.2596L18.2083 23.6983V21.6062H15.1316V11.4931H26.4133V19.1647ZM13.7636 10.0983L13.08 12.8882V25.4419H16.1571V27.1859H17.8659L19.5758 25.4419H22.3103L27.78 19.8631V10.0983H13.7636ZM20.2595 18.4684H18.892V14.283H20.2595V18.4684ZM24.0197 18.4684H22.6523V14.283H24.0197V18.4684Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                      <div className="xsb_but_seturl_placeholder">
                                        <div className="text-block-19">
                                          Twitch
                                        </div>
                                      </div>
                                      <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                        <div>expand_more</div>
                                      </div>
                                    </div>
                                    <div className="xx_but_menu_icon xx_but_menu_icon--link">
                                      <div>insert_link</div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_set_line">
                                  <div className="x_flex x_flex--vcenter">
                                    <div className="xsb_sett_drag" />
                                    <div className="xsb_but_link_input">
                                      <div className="social_icon social_icon--sett w-embed">
                                        <svg
                                          width={39}
                                          height={36}
                                          viewBox="0 0 39 36"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M19.7999 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.7999 31.2004C26.7587 31.2004 32.3999 25.4249 32.3999 18.3004C32.3999 11.1759 26.7587 5.40039 19.7999 5.40039ZM25.9923 14.0666C26.6201 13.9895 27.2186 13.817 27.7745 13.5618C27.3598 14.2052 26.8332 14.7697 26.2267 15.2222C26.2321 15.359 26.2347 15.4985 26.2347 15.638C26.2347 19.8777 23.1135 24.7653 17.4038 24.7653C15.6518 24.7653 14.0197 24.2339 12.646 23.3252C12.8884 23.3546 13.1362 23.3693 13.3866 23.3693C14.8402 23.3693 16.1793 22.8562 17.2413 21.9952C15.8827 21.9704 14.7372 21.0425 14.342 19.7685C14.5312 19.8061 14.7265 19.8254 14.9263 19.8254C15.2096 19.8254 15.484 19.7877 15.7442 19.7125C14.3234 19.4187 13.2534 18.1218 13.2534 16.5669V16.5275C13.6725 16.7661 14.152 16.912 14.6599 16.9276C13.827 16.3521 13.2791 15.37 13.2791 14.2576C13.2791 13.6701 13.4319 13.1185 13.6991 12.643C15.2309 14.5862 17.5174 15.862 20.097 15.996C20.0437 15.761 20.0171 15.5169 20.0171 15.2654C20.0171 13.4939 21.4068 12.0574 23.1197 12.0574C24.013 12.0574 24.8202 12.4466 25.3849 13.0698C26.0935 12.9266 26.7569 12.6595 27.3571 12.2924C27.1254 13.0414 26.6334 13.6701 25.9923 14.0666Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                      <div className="xsb_but_seturl_placeholder">
                                        <div className="text-block-19">
                                          Twitter
                                        </div>
                                      </div>
                                      <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                        <div>expand_more</div>
                                      </div>
                                    </div>
                                    <div className="xx_but_menu_icon xx_but_menu_icon--link">
                                      <div>insert_link</div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_set_line" />
                              </div>
                            </div>
                            <div
                              data-xsb-settings-module="onoff"
                              data-xsb-settings-module-onoff-activetarget="w_buy"
                              className="xx_set_sect_info0"
                            >
                              <div>You can use the following variables:</div>
                              <ul className="xx_set_sect_info_ul w-list-unstyled">
                                <li className="xx_set_sect_info_li">
                                  <div>
                                    {"{"}$project_name{"}"}
                                  </div>
                                </li>
                                <li className="xx_set_sect_info_li">
                                  <div>
                                    {"{"}$charge_amount_invoice{"}"}{" "}
                                  </div>
                                </li>
                                <li className="xx_set_sect_info_li">
                                  <div>
                                    {"{"}$currency_invoice{"}"}{" "}
                                  </div>
                                </li>
                                <li className="xx_set_sect_info_li">
                                  <div>
                                    {"{"}$date_charge{"}"}
                                  </div>
                                </li>
                                <li className="xx_set_sect_info_li">
                                  <div>
                                    {"{"}$company_name{"}"}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="x_right0">
                          <div className="xsb_mail">
                            <div id="login_m1" className="l_width100">
                              <div className="x_right0">
                                <div className="xsb_cont_tabs">
                                  <div>
                                    <div className="x_flex x_flex--center x_flex--vcenter">
                                      <div className="p_button p_button--appearance-flatten">
                                        <div>Check</div>
                                      </div>
                                      <div className="p_x_card_filter_div" />
                                      <div className="p_button p_button--appearance-flatten inactive">
                                        <div>refund</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xsbm_mailbg0">
                                  <div className="xsbm_mailbg_lr" />
                                  <div>
                                    <div className="x_paddings xsb_paddings--mail">
                                      <div className="xsbm_mail">
                                        <div className="xsbm_mail_w">
                                          <div className="xsbm_mail">
                                            <div className="xsbm_mailbody">
                                              <div className="xsbm_top xsbm_top">
                                                <div className="xccz">
                                                  <div className="x_contentimage">
                                                    <div className="x_contentimage_static">
                                                      <div className="x_temp_pic1 x_temp_pic--2" />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="xsbm_content">
                                                <div className="xbm_accentbg xbm_accentbg--text" />
                                                <div className="xsbm_cont xsbm_cont--left">
                                                  <div className="p_formgroup_md">
                                                    <div className="t_h2 t_bold">
                                                      <div>Thank you!</div>
                                                    </div>
                                                  </div>
                                                  <p
                                                    data-xsb-template-content="mail_trans_1"
                                                    className="xsbm_p-2"
                                                  >
                                                    <strong>
                                                      You have successfully
                                                      subscribed to a recurring{" "}
                                                      {"{"}$project_name{"}"}.
                                                    </strong>
                                                    <br />
                                                  </p>
                                                  <p
                                                    data-xsb-template-content="mail_trans_1"
                                                    className="xsbm_p-2"
                                                  >
                                                    You have been charged for
                                                    the amount of {"{"}
                                                    $charge_amount_invoice{"}"}{" "}
                                                    {"{"}$currency_invoice{"}"}{" "}
                                                    and your subscription will
                                                    automatically renew again on{" "}
                                                    {"{"}$date_charge{"}"}.
                                                    <br />
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="xsbm_content">
                                                <div className="xsbm_check">
                                                  <div className="xsbm_cont-3 xsbm_cont--purchase">
                                                    <div className="xsbm_purchase">
                                                      <div className="xsbm_ps_status">
                                                        <div>◉ Purchased</div>
                                                      </div>
                                                      <div className="xsbm_purchase_icon">
                                                        <div className="w-embed">
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={48}
                                                            height={48}
                                                            viewBox="0 0 48 47"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="nonzero"
                                                              d="M45 3h3v14h-2V5h-1v14h-1v24h-1v4h-5v-4h-1V19h-1V0h9v3zm-3 38V20h-3v21h3zM27 3V0h2v3h3a1 1 0 0 1 1 1v42a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2V0h2v3h4V0h2v3h4V0h2v3h4V0h2v3h4zm0 2h-4v4h-2V5h-4v4h-2V5h-4v4H9V5H5v4H3V5H2v40h29V5h-2v4h-2V5zm-9.743 34.066a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19zm0-2a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zM38 2v15h5V2h-5zM17 24h2v6.414l-3.293 3.293-1.414-1.414L17 29.586V24z"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </div>
                                                      <div className="xsbm_purchase_name">
                                                        <div>
                                                          Monthly Subscription
                                                        </div>
                                                      </div>
                                                      <div className="xsbm_purchase_note">
                                                        <div>
                                                          From: Nov, 12 2018
                                                          <br />
                                                          Expires: Nov, 12 2018
                                                        </div>
                                                      </div>
                                                      <div className="xsbm_purchase_note">
                                                        <div>
                                                          <a
                                                            href="#"
                                                            className="xsbm_purchase_note"
                                                          >
                                                            Manage your
                                                            subscriptions
                                                          </a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="xsbm_cont-3 xsbm_cont--opacity">
                                                    <div className="xsbm_check_h">
                                                      <div>
                                                        Transaction Details
                                                      </div>
                                                    </div>
                                                    <div className="xsbm_check_line-2">
                                                      <div className="xsbm_check_2col">
                                                        <div className="xsbm_check_col">
                                                          <div>
                                                            Monthly Subscription
                                                          </div>
                                                        </div>
                                                        <div className="xsbm_check_col_dots" />
                                                        <div className="xsbm_check_col xsbm_check_col--right">
                                                          <div className="text-block-20">
                                                            $4
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="xsbm_check_2col">
                                                        <div className="xsbm_check_col">
                                                          <div>
                                                            Transaction ID
                                                          </div>
                                                        </div>
                                                        <div className="xsbm_check_col_dots" />
                                                        <div className="xsbm_check_col xsbm_check_col--right">
                                                          <div>
                                                            1721-9932-1319
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="xsbm_check_2col">
                                                        <div className="xsbm_check_col">
                                                          <div>
                                                            Transaction Date
                                                          </div>
                                                        </div>
                                                        <div className="xsbm_check_col_dots" />
                                                        <div className="xsbm_check_col xsbm_check_col--right">
                                                          <div>
                                                            May, 26 2018
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="xsbm_check_line-2 xsbm_check_line--div xsbm_check_line--divsmall">
                                                      <div className="xsbm_check_2col">
                                                        <div className="xsbm_check_col">
                                                          <div>Subtotal</div>
                                                        </div>
                                                        <div className="xsbm_check_col_dots" />
                                                        <div className="xsbm_check_col xsbm_check_col--right">
                                                          <div>$15.99</div>
                                                        </div>
                                                      </div>
                                                      <div className="xsbm_check_2col">
                                                        <div className="xsbm_check_col">
                                                          <div>
                                                            Payment System Fee
                                                          </div>
                                                        </div>
                                                        <div className="xsbm_check_col_dots" />
                                                        <div className="xsbm_check_col xsbm_check_col--right">
                                                          <div>$4</div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="xsbm_check_line-2 xsbm_check_line--div">
                                                      <div className="xsbm_check_total">
                                                        <div className="xsbm_check_col">
                                                          <div>Total</div>
                                                        </div>
                                                        <div className="xsbm_check_col_dots" />
                                                        <div className="xsbm_check_col xsbm_check_col--right">
                                                          <div>$19.99</div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="xsbm_cont-3 xsbm_cont_protected xsbm_cont--opacity">
                                                    <div className="xsbm_cont_xsolla">
                                                      <p className="xsbm_p-2">
                                                        Xsolla is an authorized
                                                        video game software
                                                        distributor providing
                                                        clients with advanced
                                                        technical tools for
                                                        their games.
                                                      </p>
                                                      <p className="xsbm_p-2">
                                                        If you have any
                                                        questions please contact{" "}
                                                        <a href="#">
                                                          Xsolla Customer
                                                          Support
                                                        </a>
                                                        . Hotline: +1 (877) 797
                                                        65 52
                                                      </p>
                                                    </div>
                                                  </div>
                                                  <div className="xbm_bg_safe0">
                                                    <div className="xbm_accentbg xbm_accentbg--op" />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="xsbm_footer">
                                              <div className="xsbm_footer_comp-2">
                                                <p>
                                                  Copyright © 2018 Human Head
                                                  Studios, All rights reserved.
                                                  <br />
                                                  Thanks for signing up for
                                                  Rune: Ragnarok exclusive
                                                  updates and information.
                                                  <br />
                                                  <br />
                                                  Our mailing address is:
                                                  <br />
                                                  Human Head Studios 1741
                                                  Commercial Ave
                                                  <br />
                                                  Madison, Wi 53704
                                                </p>
                                                <div
                                                  data-xsb-template-media="companyLogo"
                                                  className="xsbm_footer_companylogo-2"
                                                />
                                                <div className="xsbm_footer_social">
                                                  <div className="x_sos_h_soc">
                                                    <div
                                                      data-xsb-template-onoff="social_facebook"
                                                      className="xsb_foooter_soc xsbm_soc_ico"
                                                    >
                                                      <div className="w-embed">
                                                        <svg
                                                          width={39}
                                                          height={36}
                                                          viewBox="0 0 39 36"
                                                          fill="none"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M19.8 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.8 31.2004C26.7588 31.2004 32.4001 25.4249 32.4001 18.3004C32.4001 11.1759 26.7588 5.40039 19.8 5.40039ZM20.6293 18.2155V25.0514H17.8358V18.2158H16.4401V15.8601H17.8358V14.4458C17.8358 12.524 18.6238 11.3812 20.8629 11.3812H22.7269V13.7372H21.5618C20.6902 13.7372 20.6325 14.0664 20.6325 14.6808L20.6293 15.8598H22.7401L22.4931 18.2155H20.6293Z"
                                                            fill="currentColor"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </div>
                                                    <div
                                                      data-xsb-template-onoff="social_facebook"
                                                      className="xsb_foooter_soc xsbm_soc_ico"
                                                    >
                                                      <div className="w-embed">
                                                        <svg
                                                          width={39}
                                                          height={36}
                                                          viewBox="0 0 39 36"
                                                          fill="none"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M19.2002 5.40039C12.2413 5.40039 6.6001 11.1759 6.6001 18.3004C6.6001 25.4249 12.2413 31.2004 19.2002 31.2004C26.159 31.2004 31.8002 25.4249 31.8002 18.3004C31.8002 11.1759 26.159 5.40039 19.2002 5.40039ZM16.4299 11.4615C17.1467 11.4281 17.3758 11.4199 19.2008 11.4199H19.1987C21.0244 11.4199 21.2526 11.4281 21.9694 11.4615C22.6848 11.495 23.1734 11.611 23.6018 11.7811C24.0442 11.9567 24.418 12.1918 24.7918 12.5745C25.1656 12.9569 25.3952 13.3408 25.5674 13.7933C25.7326 14.2307 25.846 14.7307 25.8796 15.4631C25.9118 16.197 25.9202 16.4315 25.9202 18.3C25.9202 20.1685 25.9118 20.4024 25.8796 21.1363C25.846 21.8685 25.7326 22.3685 25.5674 22.8061C25.3952 23.2585 25.1656 23.6424 24.7918 24.0248C24.4184 24.4075 24.0441 24.6431 23.6022 24.8189C23.1747 24.989 22.6858 25.1049 21.9704 25.1385C21.2535 25.1719 21.0252 25.1801 19.2 25.1801C17.3751 25.1801 17.1462 25.1719 16.4294 25.1385C15.7141 25.1049 15.2256 24.989 14.7981 24.8189C14.3563 24.6431 13.9814 24.4075 13.608 24.0248C13.2344 23.6424 13.0048 23.2585 12.833 22.806C12.6669 22.3685 12.5537 21.8686 12.5208 21.1362C12.4883 20.4023 12.4802 20.1685 12.4802 18.3C12.4802 16.4315 12.4886 16.1968 12.5206 15.463C12.5528 14.7308 12.6662 14.2307 12.8328 13.7931C13.005 13.3408 13.2346 12.9569 13.6085 12.5745C13.982 12.1919 14.3569 11.9569 14.7989 11.7811C15.2262 11.611 15.7145 11.495 16.4299 11.4615Z"
                                                            fill="currentColor"
                                                          />
                                                          <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M18.5979 12.613C18.7149 12.6129 18.8409 12.6129 18.9768 12.613L19.2007 12.613C20.995 12.613 21.2077 12.6196 21.9162 12.6523C22.5714 12.6828 22.927 12.7942 23.1639 12.8877C23.4775 13.0116 23.7011 13.1597 23.9362 13.3989C24.1714 13.6382 24.317 13.866 24.4391 14.185C24.531 14.4256 24.6407 14.7873 24.6705 15.4538C24.7027 16.1743 24.7097 16.3907 24.7097 18.2149C24.7097 20.039 24.7027 20.2554 24.6705 20.976C24.6405 21.6424 24.531 22.0041 24.4391 22.2448C24.3172 22.5637 24.1714 22.7909 23.9362 23.0299C23.701 23.2692 23.4777 23.4173 23.1639 23.5412C22.9273 23.6351 22.5714 23.7462 21.9162 23.7767C21.2078 23.8094 20.995 23.8166 19.2007 23.8166C17.4063 23.8166 17.1937 23.8094 16.4853 23.7767C15.83 23.7459 15.4744 23.6346 15.2374 23.541C14.9238 23.4171 14.6998 23.269 14.4646 23.0298C14.2294 22.7906 14.0838 22.5633 13.9617 22.2442C13.8697 22.0035 13.7601 21.6418 13.7303 20.9754C13.6981 20.2549 13.6917 20.0384 13.6917 18.2132C13.6917 16.3879 13.6981 16.1726 13.7303 15.452C13.7603 14.7856 13.8697 14.4239 13.9617 14.183C14.0835 13.864 14.2294 13.6362 14.4646 13.3969C14.6998 13.1577 14.9238 13.0096 15.2374 12.8854C15.4743 12.7915 15.83 12.6804 16.4853 12.6498C17.1052 12.6213 17.3454 12.6128 18.5979 12.6113V12.613ZM22.7879 13.7487C22.3427 13.7487 21.9814 14.1157 21.9814 14.5687C21.9814 15.0215 22.3427 15.3889 22.7879 15.3889C23.2331 15.3889 23.5943 15.0215 23.5943 14.5687C23.5943 14.1158 23.2331 13.7484 22.7879 13.7484V13.7487ZM15.7499 18.2172C15.7499 16.2787 17.295 14.7071 19.2008 14.707C21.1066 14.707 22.6514 16.2787 22.6514 18.2172C22.6514 20.1556 21.1068 21.7266 19.2009 21.7266C17.2951 21.7266 15.7499 20.1556 15.7499 18.2172Z"
                                                            fill="currentColor"
                                                          />
                                                          <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M19.2007 15.9375C20.4378 15.9375 21.4408 16.9575 21.4408 18.2159C21.4408 19.4741 20.4378 20.4943 19.2007 20.4943C17.9635 20.4943 16.9607 19.4741 16.9607 18.2159C16.9607 16.9575 17.9635 15.9375 19.2007 15.9375V15.9375Z"
                                                            fill="currentColor"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </div>
                                                    <div
                                                      data-xsb-template-onoff="social_facebook"
                                                      className="xsb_foooter_soc xsbm_soc_ico"
                                                    >
                                                      <div className="w-embed">
                                                        <svg
                                                          width={39}
                                                          height={36}
                                                          viewBox="0 0 39 36"
                                                          fill="none"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M7.19995 18.3004C7.19995 11.1759 12.8412 5.40039 19.8 5.40039C26.7588 5.40039 32.4001 11.1759 32.4001 18.3004C32.4001 25.4249 26.7588 31.2004 19.8 31.2004C12.8412 31.2004 7.19995 25.4249 7.19995 18.3004ZM26.4133 19.1647L24.0196 21.6062H20.2596L18.2083 23.6983V21.6062H15.1316V11.4931H26.4133V19.1647ZM13.7636 10.0983L13.08 12.8882V25.4419H16.1571V27.1859H17.8659L19.5758 25.4419H22.3103L27.78 19.8631V10.0983H13.7636ZM20.2595 18.4684H18.892V14.283H20.2595V18.4684ZM24.0197 18.4684H22.6523V14.283H24.0197V18.4684Z"
                                                            fill="currentColor"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </div>
                                                    <div
                                                      data-xsb-template-onoff="social_facebook"
                                                      className="xsb_foooter_soc xsbm_soc_ico"
                                                    >
                                                      <div className="w-embed">
                                                        <svg
                                                          width={39}
                                                          height={36}
                                                          viewBox="0 0 39 36"
                                                          fill="none"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M19.7999 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.7999 31.2004C26.7587 31.2004 32.3999 25.4249 32.3999 18.3004C32.3999 11.1759 26.7587 5.40039 19.7999 5.40039ZM25.9923 14.0666C26.6201 13.9895 27.2186 13.817 27.7745 13.5618C27.3598 14.2052 26.8332 14.7697 26.2267 15.2222C26.2321 15.359 26.2347 15.4985 26.2347 15.638C26.2347 19.8777 23.1135 24.7653 17.4038 24.7653C15.6518 24.7653 14.0197 24.2339 12.646 23.3252C12.8884 23.3546 13.1362 23.3693 13.3866 23.3693C14.8402 23.3693 16.1793 22.8562 17.2413 21.9952C15.8827 21.9704 14.7372 21.0425 14.342 19.7685C14.5312 19.8061 14.7265 19.8254 14.9263 19.8254C15.2096 19.8254 15.484 19.7877 15.7442 19.7125C14.3234 19.4187 13.2534 18.1218 13.2534 16.5669V16.5275C13.6725 16.7661 14.152 16.912 14.6599 16.9276C13.827 16.3521 13.2791 15.37 13.2791 14.2576C13.2791 13.6701 13.4319 13.1185 13.6991 12.643C15.2309 14.5862 17.5174 15.862 20.097 15.996C20.0437 15.761 20.0171 15.5169 20.0171 15.2654C20.0171 13.4939 21.4068 12.0574 23.1197 12.0574C24.013 12.0574 24.8202 12.4466 25.3849 13.0698C26.0935 12.9266 26.7569 12.6595 27.3571 12.2924C27.1254 13.0414 26.6334 13.6701 25.9923 14.0666Z"
                                                            fill="currentColor"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="xbm_accentbg xbm_accentbg--top">
                                                <div
                                                  data-xsb-template-onoff="w_social"
                                                  className="c_block"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="xsbm_mail_xsolla">
                                            <div>
                                              Xsolla is an authorized global
                                              distributor of Rune Ragnarock.{" "}
                                              <br />© Xsolla 2018, All rights
                                              reserved.
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="xsb_bgz xsb_bgz--black" />
                                  </div>
                                  <div className="xsbm_mailbg_lr" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
  )
}


export const SBlogin =({}) => {
  return (
<div className="p_x_module0">
                    <h1 className="p_x_h1_graphic">Login</h1>
                    <div id="login0" className="p_x_module_grid">
                      <div className="l_sb0">
                        <div className="x_left0">
                          <div className="x_left0_sticky">
                            <div className="xx_set_head xx_set_head--main">
                              <div>
                                <div data-xsb-settings-module-onoff="w_pack1">
                                  <div className="t_h2 t_bold">
                                    Login widget
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-xsb-settings-module="onoff"
                              data-xsb-settings-module-onoff-activetarget="w_buy"
                              className="xx_set_sect xx_set_sect--bg"
                            >
                              <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                <div className="l_width100">
                                  <div className="xsb_sett_toggle0">
                                    <div className="xsb_sett_toggle_b">
                                      <div className="xsb_sett_toggle_t" />
                                    </div>
                                    <div
                                      data-xsb-settings-module-onoff="hero_w_logo"
                                      className="xsb_sett_toggle_label"
                                    >
                                      <div>Logo image</div>
                                    </div>
                                  </div>
                                  <div className="xsb_module_but">
                                    <div className="xsb_global_settings_bg xsb_global_settings_bg--2">
                                      <div
                                        xsb_template_media_control="bg"
                                        className="xsb_media"
                                      >
                                        <div className="xsb_but_upload">
                                          <div className="w-embed">
                                            <svg
                                              width={24}
                                              height={24}
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M7.5 19C4.46243 19 2 16.5376 2 13.5C2 10.4624 4.46243 8 7.5 8C7.60002 8 7.69941 8.00267 7.79811 8.00794C8.8344 6.21016 10.7759 5 13 5C16.0561 5 18.5785 7.28485 18.9523 10.2395C20.7249 10.8436 22 12.5229 22 14.5C22 16.9853 19.9853 19 17.5 19H14V17.3852H17.9237C19.4108 17.3852 20.6163 16.1797 20.6163 14.6926C20.6163 13.5312 19.874 12.5112 18.793 12.1428C18.0138 11.8773 17.4541 11.1909 17.3508 10.3742C17.0806 8.23775 15.2526 6.61481 13.077 6.61481C11.5177 6.61481 10.106 7.44842 9.34063 8.77615C8.93545 9.47906 8.16968 9.89468 7.35951 9.85141C7.29113 9.84776 7.22239 9.84592 7.15332 9.84592C5.07141 9.84592 3.38369 11.5336 3.38369 13.6156C3.38369 15.6975 5.07141 17.3852 7.15332 17.3852H10V19H7.5ZM8 14L12 10L16 14H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V14H8Z"
                                                fill="currentColor"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                        <div className="xccz">
                                          <div className="x_contentimage">
                                            <div className="x_temp_pic1 x_temp_pic--2" />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-xsb-settings-module="onoff"
                              data-xsb-settings-module-onoff-activetarget="w_buy"
                              className="xx_set_sect xx_set_sect--bg"
                            >
                              <div className="xx_set_head">
                                <div className="xx_img_menu_left">
                                  <div data-xsb-settings-module-onoff="w_pack1">
                                    <div className="xsb_sett_head">
                                      Big social
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_img_menu_right">
                                  <div className="xx_img_menu_li">
                                    <div className="xx_but_menu_icon xx_but_menu_icon--secondary">
                                      <div>delete</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="xx_set_menu xx_set_menu--noborder" />
                              <div className="xsb_set_line xsb_set_line--fullsub">
                                <div className="xx_set_line" />
                                <div className="xx_set_line">
                                  <div className="xsb_but_link_input">
                                    <div className="social_icon social_icon--sett w-embed">
                                      <svg
                                        fill="none"
                                        height={24}
                                        viewBox="0 0 24 24"
                                        width={24}
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          clipRule="evenodd"
                                          d="m13.5044 13.3199h2.9356l.4411-3.36812h-3.3778v-2.15854c0-.97857.2667-1.64518 1.6856-1.64518h1.8111v-3.02218c-.3133-.0416-1.3889-.12588-2.6389-.12588-2.6111 0-4.39666 1.56746-4.39666 4.45829v2.49349h-2.96444v3.36812h2.96444v8.6801h3.53996z"
                                          fill="currentColor"
                                          fillRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                    <div className="xsb_but_seturl_placeholder">
                                      <div className="text-block-19">
                                        Facebook
                                      </div>
                                    </div>
                                    <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                      <div>expand_more</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-xsb-settings-module="onoff"
                              data-xsb-settings-module-onoff-activetarget="w_buy"
                              className="xx_set_sect xx_set_sect--bg"
                            >
                              <div className="xx_set_head">
                                <div className="xx_img_menu_left">
                                  <div data-xsb-settings-module-onoff="w_pack1">
                                    <div className="xsb_sett_head">
                                      Password
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_img_menu_right">
                                  <div className="xx_img_menu_li" />
                                </div>
                              </div>
                              <div className="xx_set_menu xx_set_menu--noborder" />
                              <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                <div className="xx_set_line">
                                  <div className="xx_set_line">
                                    <div className="xsb_sett_label">
                                      Security:
                                    </div>
                                    <div className="xsb_but_link_input">
                                      <div className="xsb_but_seturl_placeholder">
                                        <div className="text-block-19">
                                          Standard (min 8, case, numbers)
                                        </div>
                                      </div>
                                      <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                        <div>expand_more</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_set_line">
                                  <div className="xsb_sett_toggle0">
                                    <div className="xsb_sett_toggle_b">
                                      <div className="xsb_sett_toggle_t" />
                                    </div>
                                    <div
                                      data-xsb-settings-module-onoff="hero_w_logo"
                                      className="xsb_sett_toggle_label"
                                    >
                                      <div>
                                        Enter pasword twice on registration
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_set_line">
                                  <div className="xsb_sett_toggle0">
                                    <div className="xsb_sett_toggle_b">
                                      <div className="xsb_sett_toggle_t" />
                                    </div>
                                    <div
                                      data-xsb-settings-module-onoff="hero_w_logo"
                                      className="xsb_sett_toggle_label"
                                    >
                                      <div>"Eye"</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-xsb-settings-module="onoff"
                              data-xsb-settings-module-onoff-activetarget="w_buy"
                              className="xx_set_sect xx_set_sect--bg"
                            >
                              <div className="xx_set_head">
                                <div className="xx_img_menu_left">
                                  <div data-xsb-settings-module-onoff="w_pack1">
                                    <div className="xsb_sett_head">
                                      Footer social
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_img_menu_right">
                                  <div className="xx_img_menu_li">
                                    <div className="xx_but_menu_icon xx_but_menu_icon--secondary">
                                      <div>delete</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="xx_set_menu xx_set_menu--noborder" />
                              <div className="xsb_set_line xsb_set_line--fullsub">
                                <div className="xx_set_line" />
                                <div className="xx_set_line">
                                  <div className="x_flex x_flex--vcenter">
                                    <div className="xsb_sett_drag" />
                                    <div className="xsb_but_link_input">
                                      <div className="social_icon social_icon--sett w-embed">
                                        <svg
                                          fill="none"
                                          height={24}
                                          viewBox="0 0 24 24"
                                          width={24}
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            clipRule="evenodd"
                                            d="m13.5044 13.3199h2.9356l.4411-3.36812h-3.3778v-2.15854c0-.97857.2667-1.64518 1.6856-1.64518h1.8111v-3.02218c-.3133-.0416-1.3889-.12588-2.6389-.12588-2.6111 0-4.39666 1.56746-4.39666 4.45829v2.49349h-2.96444v3.36812h2.96444v8.6801h3.53996z"
                                            fill="currentColor"
                                            fillRule="evenodd"
                                          />
                                        </svg>
                                      </div>
                                      <div className="xsb_but_seturl_placeholder">
                                        <div>Facebook</div>
                                      </div>
                                      <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                        <div>expand_more</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_set_line">
                                  <div className="x_flex x_flex--vcenter">
                                    <div className="xsb_sett_drag" />
                                    <div className="xsb_but_link_input">
                                      <div className="social_icon social_icon--sett w-embed">
                                        <svg
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M9.18374 3.49242C6.93651 4.25353 5.07148 5.85373 3.9795 7.95768C3.61066 8.6722 3.34162 9.43383 3.17989 10.2213C2.77617 12.1952 3.05655 14.2474 3.97499 16.0412C4.57897 17.2106 5.4293 18.2356 6.46755 19.0458C7.45634 19.817 8.59236 20.3785 9.80603 20.6959C11.3364 21.0974 12.9649 21.0884 14.5054 20.7444C15.898 20.4297 17.216 19.7767 18.2686 18.8281C19.3717 17.8196 20.1761 16.5278 20.594 15.0937C21.0525 13.5497 21.1124 11.9007 20.8255 10.3138H12.1857V13.826H17.1923C17.0903 14.3896 16.8749 14.9268 16.5591 15.4048C16.2432 15.8829 15.8335 16.292 15.3547 16.6073C14.7412 17.0048 14.0523 17.2716 13.3309 17.3912C12.6057 17.5204 11.8633 17.5188 11.1387 17.3867C10.4054 17.24 9.70974 16.9453 9.09452 16.5205C8.11699 15.8463 7.3803 14.8783 6.99159 13.7572C6.60082 12.6305 6.5963 11.3774 6.99159 10.2552C7.26958 9.45583 7.7252 8.72975 8.32427 8.13137C9.07423 7.37748 10.0279 6.85817 11.0687 6.63694C11.9628 6.45135 12.8889 6.48776 13.7657 6.74296C14.5054 6.96063 15.1876 7.36329 15.7455 7.88436L17.4339 6.22977C17.7298 5.9354 18.0404 5.65004 18.3273 5.34439C17.467 4.56086 16.4624 3.95179 15.3694 3.55107C13.3727 2.83796 11.1937 2.8173 9.18374 3.49242V3.49242Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M9.18388 3.49259C11.1936 2.8181 13.3718 2.83677 15.3696 3.5456C16.4651 3.94148 17.468 4.56068 18.3274 5.34005C18.0406 5.64457 17.73 5.92992 17.4341 6.22543L15.7456 7.88002C15.182 7.35251 14.5041 6.96191 13.7647 6.73861C12.8888 6.48087 11.9625 6.44405 11.0688 6.63146C10.1357 6.83536 9.27064 7.2753 8.5567 7.90909C7.84276 8.54287 7.30387 9.34923 6.99173 10.2508C5.9877 9.48611 4.98593 8.72705 3.97852 7.96235C5.0691 5.85589 6.93496 4.2537 9.18388 3.49259V3.49259Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M3.18405 10.2172C3.34781 9.43329 3.61322 8.66859 3.98479 7.95239C4.98656 8.71709 5.98833 9.47728 6.99575 10.242C6.60046 11.3687 6.60046 12.6218 6.99575 13.744C5.99398 14.5087 4.99108 15.2734 3.98931 16.0325C3.06258 14.2431 2.77836 12.1905 3.18405 10.2172V10.2172Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M12.1853 10.3096H20.8252C21.1193 11.8993 21.04 13.5355 20.5937 15.0895C20.1754 16.5237 19.3706 17.8155 18.2671 18.8239L15.3499 16.6031C15.8285 16.2877 16.238 15.8785 16.5536 15.4005C16.8693 14.9224 17.0845 14.3853 17.1863 13.8218H12.1797C12.1853 12.651 12.1853 11.4803 12.1853 10.3096Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M3.97949 16.037C4.98239 15.2779 5.98416 14.5144 6.98593 13.7485C7.37669 14.8688 8.11341 15.8364 9.08999 16.5118C9.70212 16.9325 10.4035 17.2325 11.1342 17.378C11.8547 17.5224 12.6001 17.5032 13.3252 17.3825C14.047 17.2631 14.7364 16.9963 15.3502 16.5987L18.2686 18.8195C17.216 19.7725 15.898 20.421 14.5054 20.7346C12.9649 21.0786 11.3364 21.0887 9.80602 20.6872C8.59159 20.3718 7.45517 19.8102 6.46754 19.0371C5.43099 18.2282 4.58217 17.2047 3.97949 16.037V16.037Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                      <div className="xsb_but_seturl_placeholder">
                                        <div className="text-block-19">
                                          Google
                                        </div>
                                      </div>
                                      <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                        <div>expand_more</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_set_line">
                                  <div className="x_flex x_flex--vcenter">
                                    <div className="xsb_sett_drag" />
                                    <div className="xsb_but_link_input">
                                      <div className="social_icon social_icon--sett w-embed">
                                        <svg
                                          fill="none"
                                          height={24}
                                          viewBox="0 0 24 24"
                                          width={24}
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g
                                            clipRule="evenodd"
                                            fill="currentColor"
                                            fillRule="evenodd"
                                          >
                                            <path d="m11.9844 3c-4.73586 0-8.61571 3.64539-8.9844 8.2781l4.83212 1.9944c.40941-.2795.90403-.4429 1.43621-.4429.04764 0 .09509.0012.14214.004l2.14903-3.1094c0-.0148-.0003-.02921-.0003-.04401 0-1.87144 1.5251-3.39417 3.4-3.39417 1.8747 0 3.4001 1.52273 3.4001 3.39417 0 1.87161-1.5254 3.39441-3.4001 3.39441-.0259 0-.0514-.0006-.0771-.0012l-3.0648 2.183c.0016.0399.003.0803.003.1206 0 1.4049-1.1448 2.5477-2.55197 2.5477-1.23536 0-2.26809-.8803-2.50215-2.0458l-3.45581-1.4263c1.07009 3.7778 4.54686 6.5474 8.67403 6.5474 4.9792 0 9.0156-4.0296 9.0156-9 0-4.97057-4.0364-9-9.0156-9z" />
                                            <path d="m8.65042 16.6563-1.10745-.4567c.1963.4079.53593.7493.98667.937.97441.4053 2.09806-.0564 2.50436-1.0298.1965-.4712.1978-.9908.0029-1.4629-.1947-.4722-.5622-.8405-1.0343-1.037-.4685-.1946-.97044-.1873-1.41148-.0214l1.14402.4723c.71876.2992 1.05866 1.1231.75916 1.8406-.2993.7176-1.12508 1.057-1.84388.7579z" />
                                            <path d="m13.2607 9.6763c0-.93838.7621-1.69876 1.7019-1.69876.94 0 1.7019.76038 1.7019 1.69876 0 .9384-.7619 1.6988-1.7019 1.6988-.9398 0-1.7019-.7604-1.7019-1.6988zm3.9637.00395c0-1.24704-1.0163-2.26179-2.2655-2.26179s-2.2655 1.01475-2.2655 2.26179c0 1.24705 1.0163 2.26135 2.2655 2.26135s2.2655-1.0143 2.2655-2.26135z" />
                                          </g>
                                        </svg>
                                      </div>
                                      <div className="xsb_but_seturl_placeholder">
                                        <div className="text-block-19">
                                          Steam
                                        </div>
                                      </div>
                                      <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                        <div>expand_more</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="x_right0">
                          <div className="xsb_cont_tabs">
                            <div className="x_flex x_flex--center x_flex--vcenter">
                              <div className="p_button p_button--appearance-flatten">
                                <div>Login</div>
                              </div>
                              <div className="p_x_card_filter_div" />
                              <div className="p_button p_button--appearance-flatten inactive">
                                <div>sign up</div>
                              </div>
                            </div>
                          </div>
                          <div className="x_paddings">
                            <div className="x_flex x_flex--center">
                              <div className="login_block">
                                <div className="login_body login_body--shadow">
                                  <div className="login_body0">
                                    <div className="x_login_logo">
                                      <div className="xccz">
                                        <div className="x_contentimage">
                                          <div className="x_contentimage_static">
                                            <div className="x_temp_pic1 x_temp_pic--2" />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tab">
                                      <div className="tab_input active">
                                        <div>login</div>
                                      </div>
                                      <div className="tab_input">
                                        <div>sign up</div>
                                      </div>
                                    </div>
                                    <div className="login_section">
                                      <div className="button_primary social">
                                        <div className="button_icon" />
                                        <div className="text_button">
                                          LOGIN WITH facebook
                                        </div>
                                      </div>
                                    </div>
                                    <div className="login_section">
                                      <div className="divider" />
                                    </div>
                                    <div className="login_section">
                                      <div className="input_block">
                                        <div className="input focused">
                                          <div className="x_login_placeholder">
                                            Email
                                          </div>
                                        </div>
                                        <div className="error_message hide">
                                          This is some text inside of a div
                                          block.
                                        </div>
                                      </div>
                                      <div className="input_block">
                                        <div className="input">
                                          <div className="x_login_placeholder">
                                            Password
                                          </div>
                                          <div className="input_icon">
                                            <div className="x0_current_more">
                                              <div>remove_red_eye</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="button_primary _12">
                                        <div className="text_button _90">
                                          login
                                        </div>
                                      </div>
                                    </div>
                                    <div className="login_section">
                                      <div className="text_link_block">
                                        <a href="#" className="text_link">
                                          Forgot password?
                                        </a>
                                      </div>
                                    </div>
                                    <div className="login_section">
                                      <div className="social_block">
                                        <div className="social_icon w-embed">
                                          <svg
                                            fill="none"
                                            height={24}
                                            viewBox="0 0 24 24"
                                            width={24}
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g fill="currentColor">
                                              <path d="m9.79801 10.0405c-.55836 0-.99918.4792-.99918 1.0638s.45061 1.0637.99918 1.0637c.55839 0 .99919-.4791.99919-1.0637.0098-.5846-.4408-1.0638-.99919-1.0638zm3.57549 0c-.5583 0-.9992.4792-.9992 1.0638s.4507 1.0637.9992 1.0637c.5584 0 .9992-.4791.9992-1.0637s-.4408-1.0638-.9992-1.0638z" />
                                              <path d="m18.0086 2h-13.01717c-1.09772 0-1.99143.874-1.99143 1.957v12.844c0 1.083.89371 1.957 1.99143 1.957h11.01597l-.5148-1.7575 1.2434 1.1305 1.1754 1.064 2.0886 1.805v-17.043c0-1.083-.8937-1.957-1.9914-1.957zm-3.7497 12.407s-.3498-.4085-.6412-.7695c1.2726-.3515 1.7583-1.1305 1.7583-1.1305-.3983.2565-.7771.437-1.1171.5605-.4858.1995-.952.3325-1.4086.4085-.9326.171-1.7874.1235-2.516-.0095-.55373-.1045-1.02973-.2565-1.42801-.4085-.22343-.0855-.46629-.19-.70915-.323-.02914-.019-.05828-.0285-.08743-.0475-.01942-.0095-.02914-.019-.03885-.0285-.17486-.095-.272-.1615-.272-.1615s.46628.76 1.7 1.121c-.29143.361-.65086.7885-.65086.7885-2.14686-.0665-2.96286-1.444-2.96286-1.444 0-3.059 1.39886-5.5385 1.39886-5.5385 1.39886-1.026 2.7297-.9975 2.7297-.9975l.0972.114c-1.74861.494-2.5549 1.2445-2.5549 1.2445s.21371-.114.57314-.2755c1.03943-.4465 1.86515-.57 2.20516-.5985.0583-.0095.1068-.019.1651-.019.5926-.076 1.2629-.095 1.9623-.019.9229.1045 1.9137.3705 2.924.912 0 0-.7674-.7125-2.4188-1.2065l.136-.152s1.3308-.0285 2.7297.9975c0 0 1.3988 2.4795 1.3988 5.5385 0 0-.8257 1.3775-2.9725 1.444z" />
                                            </g>
                                          </svg>
                                        </div>
                                        <div className="social_icon w-embed">
                                          <svg
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M9.18374 3.49242C6.93651 4.25353 5.07148 5.85373 3.9795 7.95768C3.61066 8.6722 3.34162 9.43383 3.17989 10.2213C2.77617 12.1952 3.05655 14.2474 3.97499 16.0412C4.57897 17.2106 5.4293 18.2356 6.46755 19.0458C7.45634 19.817 8.59236 20.3785 9.80603 20.6959C11.3364 21.0974 12.9649 21.0884 14.5054 20.7444C15.898 20.4297 17.216 19.7767 18.2686 18.8281C19.3717 17.8196 20.1761 16.5278 20.594 15.0937C21.0525 13.5497 21.1124 11.9007 20.8255 10.3138H12.1857V13.826H17.1923C17.0903 14.3896 16.8749 14.9268 16.5591 15.4048C16.2432 15.8829 15.8335 16.292 15.3547 16.6073C14.7412 17.0048 14.0523 17.2716 13.3309 17.3912C12.6057 17.5204 11.8633 17.5188 11.1387 17.3867C10.4054 17.24 9.70974 16.9453 9.09452 16.5205C8.11699 15.8463 7.3803 14.8783 6.99159 13.7572C6.60082 12.6305 6.5963 11.3774 6.99159 10.2552C7.26958 9.45583 7.7252 8.72975 8.32427 8.13137C9.07423 7.37748 10.0279 6.85817 11.0687 6.63694C11.9628 6.45135 12.8889 6.48776 13.7657 6.74296C14.5054 6.96063 15.1876 7.36329 15.7455 7.88436L17.4339 6.22977C17.7298 5.9354 18.0404 5.65004 18.3273 5.34439C17.467 4.56086 16.4624 3.95179 15.3694 3.55107C13.3727 2.83796 11.1937 2.8173 9.18374 3.49242V3.49242Z"
                                              fill="currentColor"
                                            />
                                            <path
                                              d="M9.18388 3.49259C11.1936 2.8181 13.3718 2.83677 15.3696 3.5456C16.4651 3.94148 17.468 4.56068 18.3274 5.34005C18.0406 5.64457 17.73 5.92992 17.4341 6.22543L15.7456 7.88002C15.182 7.35251 14.5041 6.96191 13.7647 6.73861C12.8888 6.48087 11.9625 6.44405 11.0688 6.63146C10.1357 6.83536 9.27064 7.2753 8.5567 7.90909C7.84276 8.54287 7.30387 9.34923 6.99173 10.2508C5.9877 9.48611 4.98593 8.72705 3.97852 7.96235C5.0691 5.85589 6.93496 4.2537 9.18388 3.49259V3.49259Z"
                                              fill="currentColor"
                                            />
                                            <path
                                              d="M3.18405 10.2172C3.34781 9.43329 3.61322 8.66859 3.98479 7.95239C4.98656 8.71709 5.98833 9.47728 6.99575 10.242C6.60046 11.3687 6.60046 12.6218 6.99575 13.744C5.99398 14.5087 4.99108 15.2734 3.98931 16.0325C3.06258 14.2431 2.77836 12.1905 3.18405 10.2172V10.2172Z"
                                              fill="currentColor"
                                            />
                                            <path
                                              d="M12.1853 10.3096H20.8252C21.1193 11.8993 21.04 13.5355 20.5937 15.0895C20.1754 16.5237 19.3706 17.8155 18.2671 18.8239L15.3499 16.6031C15.8285 16.2877 16.238 15.8785 16.5536 15.4005C16.8693 14.9224 17.0845 14.3853 17.1863 13.8218H12.1797C12.1853 12.651 12.1853 11.4803 12.1853 10.3096Z"
                                              fill="currentColor"
                                            />
                                            <path
                                              d="M3.97949 16.037C4.98239 15.2779 5.98416 14.5144 6.98593 13.7485C7.37669 14.8688 8.11341 15.8364 9.08999 16.5118C9.70212 16.9325 10.4035 17.2325 11.1342 17.378C11.8547 17.5224 12.6001 17.5032 13.3252 17.3825C14.047 17.2631 14.7364 16.9963 15.3502 16.5987L18.2686 18.8195C17.216 19.7725 15.898 20.421 14.5054 20.7346C12.9649 21.0786 11.3364 21.0887 9.80602 20.6872C8.59159 20.3718 7.45517 19.8102 6.46754 19.0371C5.43099 18.2282 4.58217 17.2047 3.97949 16.037V16.037Z"
                                              fill="currentColor"
                                            />
                                          </svg>
                                        </div>
                                        <div className="social_icon w-embed">
                                          <svg
                                            fill="none"
                                            height={24}
                                            viewBox="0 0 24 24"
                                            width={24}
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g
                                              clipRule="evenodd"
                                              fill="currentColor"
                                              fillRule="evenodd"
                                            >
                                              <path d="m11.9844 3c-4.73586 0-8.61571 3.64539-8.9844 8.2781l4.83212 1.9944c.40941-.2795.90403-.4429 1.43621-.4429.04764 0 .09509.0012.14214.004l2.14903-3.1094c0-.0148-.0003-.02921-.0003-.04401 0-1.87144 1.5251-3.39417 3.4-3.39417 1.8747 0 3.4001 1.52273 3.4001 3.39417 0 1.87161-1.5254 3.39441-3.4001 3.39441-.0259 0-.0514-.0006-.0771-.0012l-3.0648 2.183c.0016.0399.003.0803.003.1206 0 1.4049-1.1448 2.5477-2.55197 2.5477-1.23536 0-2.26809-.8803-2.50215-2.0458l-3.45581-1.4263c1.07009 3.7778 4.54686 6.5474 8.67403 6.5474 4.9792 0 9.0156-4.0296 9.0156-9 0-4.97057-4.0364-9-9.0156-9z" />
                                              <path d="m8.65042 16.6563-1.10745-.4567c.1963.4079.53593.7493.98667.937.97441.4053 2.09806-.0564 2.50436-1.0298.1965-.4712.1978-.9908.0029-1.4629-.1947-.4722-.5622-.8405-1.0343-1.037-.4685-.1946-.97044-.1873-1.41148-.0214l1.14402.4723c.71876.2992 1.05866 1.1231.75916 1.8406-.2993.7176-1.12508 1.057-1.84388.7579z" />
                                              <path d="m13.2607 9.6763c0-.93838.7621-1.69876 1.7019-1.69876.94 0 1.7019.76038 1.7019 1.69876 0 .9384-.7619 1.6988-1.7019 1.6988-.9398 0-1.7019-.7604-1.7019-1.6988zm3.9637.00395c0-1.24704-1.0163-2.26179-2.2655-2.26179s-2.2655 1.01475-2.2655 2.26179c0 1.24705 1.0163 2.26135 2.2655 2.26135s2.2655-1.0143 2.2655-2.26135z" />
                                            </g>
                                          </svg>
                                        </div>
                                        <div className="social_icon w-embed">
                                          <svg
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M4 10C4.39556 10 4.78225 10.1173 5.11115 10.3371C5.44004 10.5568 5.69637 10.8692 5.84775 11.2346C5.99912 11.6001 6.03875 12.0022 5.96158 12.3902C5.88441 12.7781 5.69392 13.1345 5.41422 13.4142C5.13451 13.6939 4.77813 13.8844 4.39017 13.9616C4.00221 14.0387 3.60007 13.9991 3.23462 13.8477C2.86917 13.6964 2.55683 13.44 2.33707 13.1111C2.1173 12.7822 2 12.3956 2 12C2 11.4696 2.21071 10.9609 2.58578 10.5858C2.96086 10.2107 3.46957 10 4 10ZM12 10C12.3956 10 12.7822 10.1173 13.1111 10.3371C13.44 10.5568 13.6964 10.8692 13.8477 11.2346C13.9991 11.6001 14.0387 12.0022 13.9616 12.3902C13.8844 12.7781 13.6939 13.1345 13.4142 13.4142C13.1345 13.6939 12.7781 13.8844 12.3902 13.9616C12.0022 14.0387 11.6001 13.9991 11.2346 13.8477C10.8692 13.6964 10.5568 13.44 10.3371 13.1111C10.1173 12.7822 10 12.3956 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10ZM20 10C20.3956 10 20.7822 10.1173 21.1111 10.3371C21.44 10.5568 21.6964 10.8692 21.8477 11.2346C21.9991 11.6001 22.0387 12.0022 21.9616 12.3902C21.8844 12.7781 21.6939 13.1345 21.4142 13.4142C21.1345 13.6939 20.7781 13.8844 20.3902 13.9616C20.0022 14.0387 19.6001 13.9991 19.2346 13.8477C18.8692 13.6964 18.5568 13.44 18.3371 13.1111C18.1173 12.7822 18 12.3956 18 12C18 11.4696 18.2107 10.9609 18.5858 10.5858C18.9609 10.2107 19.4696 10 20 10Z"
                                              fill="currentColor"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="xccz">
                                    <div className="x_contentimage">
                                      <div className="x_contentimage_tint x_contentimage_tint--1" />
                                      <div className="x_temp_tint_1" />
                                      <div
                                        data-xsb-bg="pic"
                                        className="xsb_bg_static xsb_bg_static--xsolla3"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="xccz xccz--rel">
                            <div className="x_contentimage">
                              <div className="x_contentimage_tint">
                                <section
                                  id="xsbm_login_w1"
                                  className="x_temp_tint_1 x_temp_tint_1--dark"
                                />
                              </div>
                              <div className="x_contentimage_static">
                                <div className="x_temp_pic1" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div id="login_w" className="p_x_anchor" />
                      </div>
                      <div id="login_m" className="l_sb0">
                        <div className="x_left0">
                          <div className="x_left0_sticky">
                            <div className="xx_set_head xx_set_head--main">
                              <div>
                                <div data-xsb-settings-module-onoff="w_pack1">
                                  <div className="t_h2 t_bold">
                                    Email:{" "}
                                    <span className="x_login_set_sel">
                                      confirmation
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-xsb-settings-module="onoff"
                              data-xsb-settings-module-onoff-activetarget="w_buy"
                              className="xx_set_sect xx_set_sect--bg"
                            >
                              <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                <div className="l_width100">
                                  <div className="xsb_sett_toggle0">
                                    <div className="xsb_sett_toggle_b">
                                      <div className="xsb_sett_toggle_t" />
                                    </div>
                                    <div
                                      data-xsb-settings-module-onoff="hero_w_logo"
                                      className="xsb_sett_toggle_label"
                                    >
                                      <div>Custom Background</div>
                                    </div>
                                  </div>
                                  <div className="xsb_module_but">
                                    <div className="xsb_global_settings_bg xsb_global_settings_bg--2">
                                      <div
                                        xsb_template_media_control="bg"
                                        className="xsb_media"
                                      >
                                        <div className="xsb_but_upload">
                                          <div className="w-embed">
                                            <svg
                                              width={24}
                                              height={24}
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M7.5 19C4.46243 19 2 16.5376 2 13.5C2 10.4624 4.46243 8 7.5 8C7.60002 8 7.69941 8.00267 7.79811 8.00794C8.8344 6.21016 10.7759 5 13 5C16.0561 5 18.5785 7.28485 18.9523 10.2395C20.7249 10.8436 22 12.5229 22 14.5C22 16.9853 19.9853 19 17.5 19H14V17.3852H17.9237C19.4108 17.3852 20.6163 16.1797 20.6163 14.6926C20.6163 13.5312 19.874 12.5112 18.793 12.1428C18.0138 11.8773 17.4541 11.1909 17.3508 10.3742C17.0806 8.23775 15.2526 6.61481 13.077 6.61481C11.5177 6.61481 10.106 7.44842 9.34063 8.77615C8.93545 9.47906 8.16968 9.89468 7.35951 9.85141C7.29113 9.84776 7.22239 9.84592 7.15332 9.84592C5.07141 9.84592 3.38369 11.5336 3.38369 13.6156C3.38369 15.6975 5.07141 17.3852 7.15332 17.3852H10V19H7.5ZM8 14L12 10L16 14H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V14H8Z"
                                                fill="currentColor"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                        <div className="xccz">
                                          <div className="x_contentimage">
                                            <div className="x_contentimage_tint">
                                              <div className="x_temp_tint_1 x_temp_tint_1--0" />
                                            </div>
                                            <div className="x_contentimage_static">
                                              <div className="x_temp_pic1" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-xsb-settings-module="onoff"
                              data-xsb-settings-module-onoff-activetarget="w_buy"
                              className="xx_set_sect xx_set_sect--bg"
                            >
                              <div className="xx_set_head">
                                <div className="xx_img_menu_left">
                                  <div data-xsb-settings-module-onoff="w_pack1">
                                    <div className="xsb_sett_head">
                                      Footer social
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_img_menu_right">
                                  <div className="xx_img_menu_li">
                                    <div className="xx_but_menu_icon xx_but_menu_icon--secondary">
                                      <div>delete</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="xx_set_menu xx_set_menu--noborder" />
                              <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                <div className="xx_set_line" />
                                <div className="xx_set_line">
                                  <div className="x_flex x_flex--vcenter">
                                    <div className="xsb_sett_drag" />
                                    <div className="xsb_but_link_input">
                                      <div className="social_icon social_icon--sett w-embed">
                                        <svg
                                          width={39}
                                          height={36}
                                          viewBox="0 0 39 36"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M19.8 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.8 31.2004C26.7588 31.2004 32.4001 25.4249 32.4001 18.3004C32.4001 11.1759 26.7588 5.40039 19.8 5.40039ZM20.6293 18.2155V25.0514H17.8358V18.2158H16.4401V15.8601H17.8358V14.4458C17.8358 12.524 18.6238 11.3812 20.8629 11.3812H22.7269V13.7372H21.5618C20.6902 13.7372 20.6325 14.0664 20.6325 14.6808L20.6293 15.8598H22.7401L22.4931 18.2155H20.6293Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                      <div className="xsb_but_seturl_placeholder">
                                        <div>Facebook</div>
                                      </div>
                                      <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                        <div>expand_more</div>
                                      </div>
                                    </div>
                                    <div className="xx_but_menu_icon xx_but_menu_icon--link">
                                      <div>insert_link</div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_set_line">
                                  <div className="x_flex x_flex--vcenter">
                                    <div className="xsb_sett_drag" />
                                    <div className="xsb_but_link_input">
                                      <div className="social_icon social_icon--sett w-embed">
                                        <svg
                                          width={39}
                                          height={36}
                                          viewBox="0 0 39 36"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M19.2002 5.40039C12.2413 5.40039 6.6001 11.1759 6.6001 18.3004C6.6001 25.4249 12.2413 31.2004 19.2002 31.2004C26.159 31.2004 31.8002 25.4249 31.8002 18.3004C31.8002 11.1759 26.159 5.40039 19.2002 5.40039ZM16.4299 11.4615C17.1467 11.4281 17.3758 11.4199 19.2008 11.4199H19.1987C21.0244 11.4199 21.2526 11.4281 21.9694 11.4615C22.6848 11.495 23.1734 11.611 23.6018 11.7811C24.0442 11.9567 24.418 12.1918 24.7918 12.5745C25.1656 12.9569 25.3952 13.3408 25.5674 13.7933C25.7326 14.2307 25.846 14.7307 25.8796 15.4631C25.9118 16.197 25.9202 16.4315 25.9202 18.3C25.9202 20.1685 25.9118 20.4024 25.8796 21.1363C25.846 21.8685 25.7326 22.3685 25.5674 22.8061C25.3952 23.2585 25.1656 23.6424 24.7918 24.0248C24.4184 24.4075 24.0441 24.6431 23.6022 24.8189C23.1747 24.989 22.6858 25.1049 21.9704 25.1385C21.2535 25.1719 21.0252 25.1801 19.2 25.1801C17.3751 25.1801 17.1462 25.1719 16.4294 25.1385C15.7141 25.1049 15.2256 24.989 14.7981 24.8189C14.3563 24.6431 13.9814 24.4075 13.608 24.0248C13.2344 23.6424 13.0048 23.2585 12.833 22.806C12.6669 22.3685 12.5537 21.8686 12.5208 21.1362C12.4883 20.4023 12.4802 20.1685 12.4802 18.3C12.4802 16.4315 12.4886 16.1968 12.5206 15.463C12.5528 14.7308 12.6662 14.2307 12.8328 13.7931C13.005 13.3408 13.2346 12.9569 13.6085 12.5745C13.982 12.1919 14.3569 11.9569 14.7989 11.7811C15.2262 11.611 15.7145 11.495 16.4299 11.4615Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M18.5979 12.613C18.7149 12.6129 18.8409 12.6129 18.9768 12.613L19.2007 12.613C20.995 12.613 21.2077 12.6196 21.9162 12.6523C22.5714 12.6828 22.927 12.7942 23.1639 12.8877C23.4775 13.0116 23.7011 13.1597 23.9362 13.3989C24.1714 13.6382 24.317 13.866 24.4391 14.185C24.531 14.4256 24.6407 14.7873 24.6705 15.4538C24.7027 16.1743 24.7097 16.3907 24.7097 18.2149C24.7097 20.039 24.7027 20.2554 24.6705 20.976C24.6405 21.6424 24.531 22.0041 24.4391 22.2448C24.3172 22.5637 24.1714 22.7909 23.9362 23.0299C23.701 23.2692 23.4777 23.4173 23.1639 23.5412C22.9273 23.6351 22.5714 23.7462 21.9162 23.7767C21.2078 23.8094 20.995 23.8166 19.2007 23.8166C17.4063 23.8166 17.1937 23.8094 16.4853 23.7767C15.83 23.7459 15.4744 23.6346 15.2374 23.541C14.9238 23.4171 14.6998 23.269 14.4646 23.0298C14.2294 22.7906 14.0838 22.5633 13.9617 22.2442C13.8697 22.0035 13.7601 21.6418 13.7303 20.9754C13.6981 20.2549 13.6917 20.0384 13.6917 18.2132C13.6917 16.3879 13.6981 16.1726 13.7303 15.452C13.7603 14.7856 13.8697 14.4239 13.9617 14.183C14.0835 13.864 14.2294 13.6362 14.4646 13.3969C14.6998 13.1577 14.9238 13.0096 15.2374 12.8854C15.4743 12.7915 15.83 12.6804 16.4853 12.6498C17.1052 12.6213 17.3454 12.6128 18.5979 12.6113V12.613ZM22.7879 13.7487C22.3427 13.7487 21.9814 14.1157 21.9814 14.5687C21.9814 15.0215 22.3427 15.3889 22.7879 15.3889C23.2331 15.3889 23.5943 15.0215 23.5943 14.5687C23.5943 14.1158 23.2331 13.7484 22.7879 13.7484V13.7487ZM15.7499 18.2172C15.7499 16.2787 17.295 14.7071 19.2008 14.707C21.1066 14.707 22.6514 16.2787 22.6514 18.2172C22.6514 20.1556 21.1068 21.7266 19.2009 21.7266C17.2951 21.7266 15.7499 20.1556 15.7499 18.2172Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M19.2007 15.9375C20.4378 15.9375 21.4408 16.9575 21.4408 18.2159C21.4408 19.4741 20.4378 20.4943 19.2007 20.4943C17.9635 20.4943 16.9607 19.4741 16.9607 18.2159C16.9607 16.9575 17.9635 15.9375 19.2007 15.9375V15.9375Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                      <div className="xsb_but_seturl_placeholder">
                                        <div className="text-block-19">
                                          Instagram
                                        </div>
                                      </div>
                                      <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                        <div>expand_more</div>
                                      </div>
                                    </div>
                                    <div className="xx_but_menu_icon xx_but_menu_icon--link">
                                      <div>insert_link</div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_set_line">
                                  <div className="x_flex x_flex--vcenter">
                                    <div className="xsb_sett_drag" />
                                    <div className="xsb_but_link_input">
                                      <div className="social_icon social_icon--sett w-embed">
                                        <svg
                                          width={39}
                                          height={36}
                                          viewBox="0 0 39 36"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M7.19995 18.3004C7.19995 11.1759 12.8412 5.40039 19.8 5.40039C26.7588 5.40039 32.4001 11.1759 32.4001 18.3004C32.4001 25.4249 26.7588 31.2004 19.8 31.2004C12.8412 31.2004 7.19995 25.4249 7.19995 18.3004ZM26.4133 19.1647L24.0196 21.6062H20.2596L18.2083 23.6983V21.6062H15.1316V11.4931H26.4133V19.1647ZM13.7636 10.0983L13.08 12.8882V25.4419H16.1571V27.1859H17.8659L19.5758 25.4419H22.3103L27.78 19.8631V10.0983H13.7636ZM20.2595 18.4684H18.892V14.283H20.2595V18.4684ZM24.0197 18.4684H22.6523V14.283H24.0197V18.4684Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                      <div className="xsb_but_seturl_placeholder">
                                        <div className="text-block-19">
                                          Twitch
                                        </div>
                                      </div>
                                      <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                        <div>expand_more</div>
                                      </div>
                                    </div>
                                    <div className="xx_but_menu_icon xx_but_menu_icon--link">
                                      <div>insert_link</div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xx_set_line">
                                  <div className="x_flex x_flex--vcenter">
                                    <div className="xsb_sett_drag" />
                                    <div className="xsb_but_link_input">
                                      <div className="social_icon social_icon--sett w-embed">
                                        <svg
                                          width={39}
                                          height={36}
                                          viewBox="0 0 39 36"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M19.7999 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.7999 31.2004C26.7587 31.2004 32.3999 25.4249 32.3999 18.3004C32.3999 11.1759 26.7587 5.40039 19.7999 5.40039ZM25.9923 14.0666C26.6201 13.9895 27.2186 13.817 27.7745 13.5618C27.3598 14.2052 26.8332 14.7697 26.2267 15.2222C26.2321 15.359 26.2347 15.4985 26.2347 15.638C26.2347 19.8777 23.1135 24.7653 17.4038 24.7653C15.6518 24.7653 14.0197 24.2339 12.646 23.3252C12.8884 23.3546 13.1362 23.3693 13.3866 23.3693C14.8402 23.3693 16.1793 22.8562 17.2413 21.9952C15.8827 21.9704 14.7372 21.0425 14.342 19.7685C14.5312 19.8061 14.7265 19.8254 14.9263 19.8254C15.2096 19.8254 15.484 19.7877 15.7442 19.7125C14.3234 19.4187 13.2534 18.1218 13.2534 16.5669V16.5275C13.6725 16.7661 14.152 16.912 14.6599 16.9276C13.827 16.3521 13.2791 15.37 13.2791 14.2576C13.2791 13.6701 13.4319 13.1185 13.6991 12.643C15.2309 14.5862 17.5174 15.862 20.097 15.996C20.0437 15.761 20.0171 15.5169 20.0171 15.2654C20.0171 13.4939 21.4068 12.0574 23.1197 12.0574C24.013 12.0574 24.8202 12.4466 25.3849 13.0698C26.0935 12.9266 26.7569 12.6595 27.3571 12.2924C27.1254 13.0414 26.6334 13.6701 25.9923 14.0666Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                      <div className="xsb_but_seturl_placeholder">
                                        <div className="text-block-19">
                                          Twitter
                                        </div>
                                      </div>
                                      <div className="xx_but_menu_icon xx_but_sett_icon--inline">
                                        <div>expand_more</div>
                                      </div>
                                    </div>
                                    <div className="xx_but_menu_icon xx_but_menu_icon--link">
                                      <div>insert_link</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-xsb-settings-module="onoff"
                              data-xsb-settings-module-onoff-activetarget="w_buy"
                              className="xx_set_sect_info0"
                            >
                              <div>You can use the following variables:</div>
                              <ul className="xx_set_sect_info_ul w-list-unstyled">
                                <li className="xx_set_sect_info_li">
                                  <div className="l_flex">
                                    {"{"}$project_name{"}"}
                                  </div>
                                </li>
                                <li className="xx_set_sect_info_li">
                                  <div>
                                    {"{"}$charge_amount_invoice{"}"}{" "}
                                  </div>
                                </li>
                                <li className="xx_set_sect_info_li">
                                  <div>
                                    {"{"}$currency_invoice{"}"}{" "}
                                  </div>
                                </li>
                                <li className="xx_set_sect_info_li">
                                  <div>
                                    {"{"}$date_charge{"}"}
                                  </div>
                                </li>
                                <li className="xx_set_sect_info_li">
                                  <div>
                                    {"{"}$company_name{"}"}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="x_right0">
                          <div className="xsb_mail">
                            <div id="login_m1" className="l_width100">
                              <div className="x_right0">
                                <div className="xsb_cont_tabs">
                                  <div>
                                    <div className="x_flex x_flex--center x_flex--vcenter">
                                      <div className="p_button p_button--appearance-flatten">
                                        <div>Confirmation</div>
                                      </div>
                                      <div className="p_x_card_filter_div" />
                                      <div className="p_button p_button--appearance-flatten inactive">
                                        <div>Forgot password</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xsbm_mailbg0">
                                  <div className="xsbm_mailbg_lr" />
                                  <div>
                                    <div className="x_paddings xsb_paddings--mail">
                                      <div className="xsbm_mail">
                                        <div className="xsbm_mail_w">
                                          <div className="xsbm_mailbody">
                                            <div className="xsbm_top">
                                              <div className="xccz">
                                                <div className="x_contentimage">
                                                  <div className="x_contentimage_tint">
                                                    <div className="x_temp_tint_1 x_temp_tint_1--0" />
                                                  </div>
                                                  <div className="x_contentimage_static">
                                                    <div className="x_temp_pic1" />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="xsbm_content">
                                              <div className="xsbm_cont">
                                                <div className="p_formgroup_sm8">
                                                  <div className="t_h2 t_bold">
                                                    <div>Hello!</div>
                                                  </div>
                                                </div>
                                                <p
                                                  data-xsb-template-content="mail_trans_1"
                                                  className="xsbm_p"
                                                >
                                                  <strong>
                                                    Please confirm your new
                                                    account by clicking the
                                                    button below
                                                  </strong>
                                                  <br />
                                                </p>
                                                <div className="xsbm_p xsbm_p--center">
                                                  <div className="button_primary x_radius">
                                                    <div>Confirm account</div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="xbm_accentbg xbm_accentbg--text">
                                                <div className="xccz">
                                                  <div className="x_contentimage">
                                                    <div className="x_contentimage_tint x_contentimage_tint--1" />
                                                    <div className="x_temp_tint_1" />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="xsbm_content">
                                              <div className="xsbm_check">
                                                <div className="xbm_accentbg xbm_accentbg--check" />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="xsbm_footer">
                                            <div className="xsbm_footer_comp">
                                              <p>
                                                Copyright © 2018 Human Head
                                                Studios, All rights reserved.
                                                <br />
                                                Thanks for signing up for Rune:
                                                Ragnarok exclusive updates and
                                                information.
                                                <br />
                                                <br />
                                                Our mailing address is:
                                                <br />
                                                Human Head Studios 1741
                                                Commercial Ave
                                                <br />
                                                Madison, Wi 53704
                                              </p>
                                              <div
                                                data-xsb-template-media="companyLogo"
                                                className="xsbm_footer_companylogo"
                                              />
                                              <div className="xsbm_footer_social">
                                                <div className="x_sos_h_soc">
                                                  <div
                                                    data-xsb-template-onoff="social_facebook"
                                                    className="xsb_foooter_soc xsbm_soc_ico"
                                                  >
                                                    <div className="w-embed">
                                                      <svg
                                                        width={39}
                                                        height={36}
                                                        viewBox="0 0 39 36"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <path
                                                          fillRule="evenodd"
                                                          clipRule="evenodd"
                                                          d="M19.8 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.8 31.2004C26.7588 31.2004 32.4001 25.4249 32.4001 18.3004C32.4001 11.1759 26.7588 5.40039 19.8 5.40039ZM20.6293 18.2155V25.0514H17.8358V18.2158H16.4401V15.8601H17.8358V14.4458C17.8358 12.524 18.6238 11.3812 20.8629 11.3812H22.7269V13.7372H21.5618C20.6902 13.7372 20.6325 14.0664 20.6325 14.6808L20.6293 15.8598H22.7401L22.4931 18.2155H20.6293Z"
                                                          fill="currentColor"
                                                        />
                                                      </svg>
                                                    </div>
                                                  </div>
                                                  <div
                                                    data-xsb-template-onoff="social_facebook"
                                                    className="xsb_foooter_soc xsbm_soc_ico"
                                                  >
                                                    <div className="w-embed">
                                                      <svg
                                                        width={39}
                                                        height={36}
                                                        viewBox="0 0 39 36"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <path
                                                          fillRule="evenodd"
                                                          clipRule="evenodd"
                                                          d="M19.2002 5.40039C12.2413 5.40039 6.6001 11.1759 6.6001 18.3004C6.6001 25.4249 12.2413 31.2004 19.2002 31.2004C26.159 31.2004 31.8002 25.4249 31.8002 18.3004C31.8002 11.1759 26.159 5.40039 19.2002 5.40039ZM16.4299 11.4615C17.1467 11.4281 17.3758 11.4199 19.2008 11.4199H19.1987C21.0244 11.4199 21.2526 11.4281 21.9694 11.4615C22.6848 11.495 23.1734 11.611 23.6018 11.7811C24.0442 11.9567 24.418 12.1918 24.7918 12.5745C25.1656 12.9569 25.3952 13.3408 25.5674 13.7933C25.7326 14.2307 25.846 14.7307 25.8796 15.4631C25.9118 16.197 25.9202 16.4315 25.9202 18.3C25.9202 20.1685 25.9118 20.4024 25.8796 21.1363C25.846 21.8685 25.7326 22.3685 25.5674 22.8061C25.3952 23.2585 25.1656 23.6424 24.7918 24.0248C24.4184 24.4075 24.0441 24.6431 23.6022 24.8189C23.1747 24.989 22.6858 25.1049 21.9704 25.1385C21.2535 25.1719 21.0252 25.1801 19.2 25.1801C17.3751 25.1801 17.1462 25.1719 16.4294 25.1385C15.7141 25.1049 15.2256 24.989 14.7981 24.8189C14.3563 24.6431 13.9814 24.4075 13.608 24.0248C13.2344 23.6424 13.0048 23.2585 12.833 22.806C12.6669 22.3685 12.5537 21.8686 12.5208 21.1362C12.4883 20.4023 12.4802 20.1685 12.4802 18.3C12.4802 16.4315 12.4886 16.1968 12.5206 15.463C12.5528 14.7308 12.6662 14.2307 12.8328 13.7931C13.005 13.3408 13.2346 12.9569 13.6085 12.5745C13.982 12.1919 14.3569 11.9569 14.7989 11.7811C15.2262 11.611 15.7145 11.495 16.4299 11.4615Z"
                                                          fill="currentColor"
                                                        />
                                                        <path
                                                          fillRule="evenodd"
                                                          clipRule="evenodd"
                                                          d="M18.5979 12.613C18.7149 12.6129 18.8409 12.6129 18.9768 12.613L19.2007 12.613C20.995 12.613 21.2077 12.6196 21.9162 12.6523C22.5714 12.6828 22.927 12.7942 23.1639 12.8877C23.4775 13.0116 23.7011 13.1597 23.9362 13.3989C24.1714 13.6382 24.317 13.866 24.4391 14.185C24.531 14.4256 24.6407 14.7873 24.6705 15.4538C24.7027 16.1743 24.7097 16.3907 24.7097 18.2149C24.7097 20.039 24.7027 20.2554 24.6705 20.976C24.6405 21.6424 24.531 22.0041 24.4391 22.2448C24.3172 22.5637 24.1714 22.7909 23.9362 23.0299C23.701 23.2692 23.4777 23.4173 23.1639 23.5412C22.9273 23.6351 22.5714 23.7462 21.9162 23.7767C21.2078 23.8094 20.995 23.8166 19.2007 23.8166C17.4063 23.8166 17.1937 23.8094 16.4853 23.7767C15.83 23.7459 15.4744 23.6346 15.2374 23.541C14.9238 23.4171 14.6998 23.269 14.4646 23.0298C14.2294 22.7906 14.0838 22.5633 13.9617 22.2442C13.8697 22.0035 13.7601 21.6418 13.7303 20.9754C13.6981 20.2549 13.6917 20.0384 13.6917 18.2132C13.6917 16.3879 13.6981 16.1726 13.7303 15.452C13.7603 14.7856 13.8697 14.4239 13.9617 14.183C14.0835 13.864 14.2294 13.6362 14.4646 13.3969C14.6998 13.1577 14.9238 13.0096 15.2374 12.8854C15.4743 12.7915 15.83 12.6804 16.4853 12.6498C17.1052 12.6213 17.3454 12.6128 18.5979 12.6113V12.613ZM22.7879 13.7487C22.3427 13.7487 21.9814 14.1157 21.9814 14.5687C21.9814 15.0215 22.3427 15.3889 22.7879 15.3889C23.2331 15.3889 23.5943 15.0215 23.5943 14.5687C23.5943 14.1158 23.2331 13.7484 22.7879 13.7484V13.7487ZM15.7499 18.2172C15.7499 16.2787 17.295 14.7071 19.2008 14.707C21.1066 14.707 22.6514 16.2787 22.6514 18.2172C22.6514 20.1556 21.1068 21.7266 19.2009 21.7266C17.2951 21.7266 15.7499 20.1556 15.7499 18.2172Z"
                                                          fill="currentColor"
                                                        />
                                                        <path
                                                          fillRule="evenodd"
                                                          clipRule="evenodd"
                                                          d="M19.2007 15.9375C20.4378 15.9375 21.4408 16.9575 21.4408 18.2159C21.4408 19.4741 20.4378 20.4943 19.2007 20.4943C17.9635 20.4943 16.9607 19.4741 16.9607 18.2159C16.9607 16.9575 17.9635 15.9375 19.2007 15.9375V15.9375Z"
                                                          fill="currentColor"
                                                        />
                                                      </svg>
                                                    </div>
                                                  </div>
                                                  <div
                                                    data-xsb-template-onoff="social_facebook"
                                                    className="xsb_foooter_soc xsbm_soc_ico"
                                                  >
                                                    <div className="w-embed">
                                                      <svg
                                                        width={39}
                                                        height={36}
                                                        viewBox="0 0 39 36"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <path
                                                          fillRule="evenodd"
                                                          clipRule="evenodd"
                                                          d="M7.19995 18.3004C7.19995 11.1759 12.8412 5.40039 19.8 5.40039C26.7588 5.40039 32.4001 11.1759 32.4001 18.3004C32.4001 25.4249 26.7588 31.2004 19.8 31.2004C12.8412 31.2004 7.19995 25.4249 7.19995 18.3004ZM26.4133 19.1647L24.0196 21.6062H20.2596L18.2083 23.6983V21.6062H15.1316V11.4931H26.4133V19.1647ZM13.7636 10.0983L13.08 12.8882V25.4419H16.1571V27.1859H17.8659L19.5758 25.4419H22.3103L27.78 19.8631V10.0983H13.7636ZM20.2595 18.4684H18.892V14.283H20.2595V18.4684ZM24.0197 18.4684H22.6523V14.283H24.0197V18.4684Z"
                                                          fill="currentColor"
                                                        />
                                                      </svg>
                                                    </div>
                                                  </div>
                                                  <div
                                                    data-xsb-template-onoff="social_facebook"
                                                    className="xsb_foooter_soc xsbm_soc_ico"
                                                  >
                                                    <div className="w-embed">
                                                      <svg
                                                        width={39}
                                                        height={36}
                                                        viewBox="0 0 39 36"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <path
                                                          fillRule="evenodd"
                                                          clipRule="evenodd"
                                                          d="M19.7999 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.7999 31.2004C26.7587 31.2004 32.3999 25.4249 32.3999 18.3004C32.3999 11.1759 26.7587 5.40039 19.7999 5.40039ZM25.9923 14.0666C26.6201 13.9895 27.2186 13.817 27.7745 13.5618C27.3598 14.2052 26.8332 14.7697 26.2267 15.2222C26.2321 15.359 26.2347 15.4985 26.2347 15.638C26.2347 19.8777 23.1135 24.7653 17.4038 24.7653C15.6518 24.7653 14.0197 24.2339 12.646 23.3252C12.8884 23.3546 13.1362 23.3693 13.3866 23.3693C14.8402 23.3693 16.1793 22.8562 17.2413 21.9952C15.8827 21.9704 14.7372 21.0425 14.342 19.7685C14.5312 19.8061 14.7265 19.8254 14.9263 19.8254C15.2096 19.8254 15.484 19.7877 15.7442 19.7125C14.3234 19.4187 13.2534 18.1218 13.2534 16.5669V16.5275C13.6725 16.7661 14.152 16.912 14.6599 16.9276C13.827 16.3521 13.2791 15.37 13.2791 14.2576C13.2791 13.6701 13.4319 13.1185 13.6991 12.643C15.2309 14.5862 17.5174 15.862 20.097 15.996C20.0437 15.761 20.0171 15.5169 20.0171 15.2654C20.0171 13.4939 21.4068 12.0574 23.1197 12.0574C24.013 12.0574 24.8202 12.4466 25.3849 13.0698C26.0935 12.9266 26.7569 12.6595 27.3571 12.2924C27.1254 13.0414 26.6334 13.6701 25.9923 14.0666Z"
                                                          fill="currentColor"
                                                        />
                                                      </svg>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="xbm_accentbg xbm_accentbg--top">
                                              <div
                                                data-xsb-template-onoff="w_social"
                                                className="c_block"
                                              >
                                                <div className="c_foot_block _50" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="xsbm_mail_xsolla">
                                          <div>
                                            Xsolla is an authorized global
                                            distributor of Rune Ragnarock.{" "}
                                            <br />© Xsolla 2018, All rights
                                            reserved.
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="xsb_bgz xsb_bgz--black" />
                                  </div>
                                  <div className="xsbm_mailbg_lr" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div id="login_mail" className="p_x_anchor" />
                      </div>
                    </div>
                  </div>
                  )
                }




                export const SBlnch =({}) => {
                  return (

                  <div className="p_x_module0">
                    <h1 className="p_x_h1_graphic">Launcher</h1>
                    <div id="login0" className="p_x_module_grid">
                      <div className="l_sb0">
                        <div id="l_gamepage" className="p_x_anchor" />
                        <div className="x_left0">
                          <div className="x_left0_sticky">
                            <div className="xsb_sett_block">
                              <div className="xx_set_head xx_set_head--main">
                                <div>
                                  <div data-xsb-settings-module-onoff="w_pack1">
                                    <div className="t_h2 t_bold">Home page</div>
                                  </div>
                                </div>
                              </div>
                              <div
                                data-xsb-settings-module="onoff"
                                data-xsb-settings-module-onoff-activetarget="w_buy"
                                className="xx_set_sect xx_set_sect--bg"
                              >
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Only one can be selected</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b inactive">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Send to friend</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="x_right0">
                          <div className="x_flex x_flex--center">
                            <div
                              data-xsb-template-type="ps_card"
                              className="xsb_c"
                            >
                              <div className="p_formgroup_xlg p_formgroup_xlg--top">
                                <div className="xsbps_b xsbps_b--rel">
                                  <div className="xsbps_bd x_launcher_ws">
                                    <div className="xccz lh_bg">
                                      <div className="x_contentimage">
                                        <div className="x_contentimage_tint">
                                          <div className="x_temp_tint_1" />
                                        </div>
                                        <div
                                          data-xsb-bg="pic"
                                          className="xsb_bg_static xsb_bg_static--xsolla3"
                                        />
                                      </div>
                                    </div>
                                    <div className="xsbps_topmenu l_header">
                                      <div className="xsbps_topmenu_block lh_actions">
                                        <div className="l_text_caption secondary">
                                          Xsolla Inc.
                                        </div>
                                        <div className="l_block_window-actions">
                                          <a
                                            href="#"
                                            className="l_btn_window-close minimize w-button"
                                          >
                                            Button Text
                                          </a>
                                          <a
                                            href="#"
                                            className="l_btn_window-close expand w-button"
                                          >
                                            Button Text
                                          </a>
                                          <a
                                            href="#"
                                            className="l_btn_window-close w-button"
                                          >
                                            Button Text
                                          </a>
                                        </div>
                                      </div>
                                      <div className="xsbps_topmenu_block lh_nb">
                                        <div className="l_block_nb-tabs">
                                          <div className="l_btn_tab active">
                                            <div>Home</div>
                                          </div>
                                          <div className="l_btn_tab">
                                            <div>Games</div>
                                          </div>
                                          <div className="l_btn_tab">
                                            <div>News</div>
                                          </div>
                                        </div>
                                        <div className="l_block_window-actions">
                                          <div className="l_ico_status-dot" />
                                          <div>John Doe</div>
                                          <div className="l_ico_chevron" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="l_container_inner-layout scroll">
                                      <div className="xsbps_column left">
                                        <div className="p_formgroup_lg lh_formgroup">
                                          <div className="l_image_pub-logoxl">
                                            <div className="l_image_pub-logo" />
                                          </div>
                                          <div className="l_container_homepage-slider">
                                            <div className="l_container_homepage-slider-bg">
                                              <div className="l_btn_slider-switch">
                                                <div className="l_ico_chevron left" />
                                              </div>
                                              <div className="l_btn_slider-switch right">
                                                <div className="l_ico_chevron right" />
                                              </div>
                                              <div className="l_block_homepage-slider w-row">
                                                <div className="l_l-block_homepage-slider w-col w-col-7">
                                                  <div
                                                    data-poster-url="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-poster-00001.jpg"
                                                    data-video-urls="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.mp4,https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.webm"
                                                    data-autoplay="true"
                                                    data-loop="true"
                                                    data-wf-ignore="true"
                                                    className="background-video w-background-video w-background-video-atom"
                                                  >
                                                    <video
                                                      autoPlay
                                                      loop
                                                      style={{
                                                        backgroundImage:
                                                          'url("https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-poster-00001.jpg")'
                                                      }}
                                                      muted
                                                      playsInline
                                                      data-wf-ignore="true"
                                                      data-object-fit="cover"
                                                    >
                                                      <source
                                                        src="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.mp4"
                                                        data-wf-ignore="true"
                                                      />
                                                      <source
                                                        src="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.webm"
                                                        data-wf-ignore="true"
                                                      />
                                                    </video>
                                                  </div>
                                                </div>
                                                <div className="l_r-block_homepage-slider w-col w-col-5">
                                                  <div className="l_v-block">
                                                    <div className="l_text_caption secondary l_margin-b_10">
                                                      Featured game
                                                    </div>
                                                    <div className="l_text_h1 l_margin-b_10">
                                                      Xsollus
                                                    </div>
                                                    <div className="l_text_caption secondary">
                                                      Embark on a sweeping
                                                      adventure across the
                                                      Permlands as you draw your
                                                      sword against dangerous
                                                      monsters, seek vast
                                                      treasures, and brave
                                                      perilous danger.
                                                    </div>
                                                  </div>
                                                  <div className="l_h-block">
                                                    <a
                                                      href="#"
                                                      className="l_btn_primary l_margin-r_12 w-button"
                                                    >
                                                      $29.99
                                                    </a>
                                                    <a
                                                      href="#"
                                                      className="l_btn_secondary w-button"
                                                    >
                                                      Redeem key
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="p_formgroup_lg lh_formgroup">
                                          <div className="l_h-block l_margin-b_24">
                                            <div className="l_text_label">
                                              recent updates
                                            </div>
                                            <div className="l_ico_chevron right" />
                                          </div>
                                          <div className="xsbps_block">
                                            <div className="xsbps_block_grid l_news-h-list">
                                              <div className="l_image_news-card">
                                                <div className="l_image_news-card-bg">
                                                  <div className="l_image_news-image" />
                                                </div>
                                                <div className="l_text_caption secondary l_margin-b_10">
                                                  September 1, 2019
                                                </div>
                                                <div className="l_text_h2">
                                                  Xsolla and Keymailer
                                                  Partnership Takes Influencer
                                                  Programs to a New Level
                                                </div>
                                              </div>
                                              <div className="l_image_news-card">
                                                <div className="l_image_news-card-bg">
                                                  <div className="l_image_news-image" />
                                                </div>
                                                <div className="l_text_caption secondary l_margin-b_10">
                                                  September 1, 2019
                                                </div>
                                                <div className="l_text_h2">
                                                  Xsolla and Keymailer
                                                  Partnership Takes Influencer
                                                  Programs to a New Level
                                                </div>
                                              </div>
                                              <div className="l_image_news-card">
                                                <div className="l_image_news-card-bg">
                                                  <div className="l_image_news-image" />
                                                </div>
                                                <div className="l_text_caption secondary l_margin-b_10">
                                                  September 1, 2019
                                                </div>
                                                <div className="l_text_h2">
                                                  Xsolla and Keymailer
                                                  Partnership Takes Influencer
                                                  Programs to a New Level
                                                </div>
                                              </div>
                                              <div className="l_image_news-card">
                                                <div className="l_image_news-card-bg">
                                                  <div className="l_image_news-image" />
                                                </div>
                                                <div className="l_text_caption secondary l_margin-b_10">
                                                  September 1, 2019
                                                </div>
                                                <div className="l_text_h2">
                                                  Xsolla and Keymailer
                                                  Partnership Takes Influencer
                                                  Programs to a New Level
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="p_formgroup_lg lh_formgroup">
                                          <div className="l_text_label l_margin-b_24">
                                            NEW games
                                          </div>
                                          <div className="xsbps_block">
                                            <div className="xsbps_block_grid l_news-h-list">
                                              <div className="l_container_newgames-card">
                                                <div className="l_image_game-image">
                                                  <div className="l_block_title-bg">
                                                    <div className="l_text_h1">
                                                      Game title 01
                                                    </div>
                                                    <a
                                                      href="#"
                                                      className="l_btn_primary w-button"
                                                    >
                                                      $29.99
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="l_container_newgames-card">
                                                <div className="l_image_game-image">
                                                  <div className="l_block_title-bg">
                                                    <div className="l_text_h1">
                                                      Game title 02
                                                    </div>
                                                    <a
                                                      href="#"
                                                      className="l_btn_primary w-button"
                                                    >
                                                      $29.99
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="p_formgroup_lg lh_formgroup lh_formgroup-lastchild">
                                          <div className="l_text_label l_margin-b_24">
                                            All games
                                          </div>
                                          <div className="xsbps_block l_agame-row">
                                            <div className="xsbps_block_grid l_news-h-list">
                                              <div className="l_container_allgames-card-bg">
                                                <div className="l_container_allgames-card">
                                                  <div className="l_image_allgames-card">
                                                    <div className="l_image_game-image" />
                                                  </div>
                                                  <div className="l_block_allgames-description">
                                                    <div className="l_v-block">
                                                      <div className="l_text_h1 l_margin-b_10">
                                                        Xsollus
                                                      </div>
                                                      <div className="l_text_description">
                                                        Embark on a sweeping
                                                        adventure across the
                                                        Permlands as you draw
                                                        your sword against
                                                        &nbsp;dangerous
                                                        monsters, seek vast
                                                        treasures...
                                                      </div>
                                                    </div>
                                                    <a
                                                      href="#"
                                                      className="l_btn_primary w-button"
                                                    >
                                                      $29.99
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="l_container_allgames-card-bg">
                                                <div className="l_container_allgames-card">
                                                  <div className="l_image_allgames-card">
                                                    <div className="l_image_game-image" />
                                                  </div>
                                                  <div className="l_block_allgames-description">
                                                    <div className="l_v-block">
                                                      <div className="l_text_h1 l_margin-b_10">
                                                        Xsollus
                                                      </div>
                                                      <div className="l_text_description">
                                                        Embark on a sweeping
                                                        adventure across the
                                                        Permlands as you draw
                                                        your sword against
                                                        &nbsp;dangerous
                                                        monsters, seek vast
                                                        treasures...
                                                      </div>
                                                    </div>
                                                    <a
                                                      href="#"
                                                      className="l_btn_primary w-button"
                                                    >
                                                      $29.99
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="l_container_allgames-card-bg">
                                                <div className="l_container_allgames-card">
                                                  <div className="l_image_allgames-card">
                                                    <div className="l_image_game-image" />
                                                  </div>
                                                  <div className="l_block_allgames-description">
                                                    <div className="l_v-block">
                                                      <div className="l_text_h1 l_margin-b_10">
                                                        Xsollus
                                                      </div>
                                                      <div className="l_text_description">
                                                        Embark on a sweeping
                                                        adventure across the
                                                        Permlands as you draw
                                                        your sword against
                                                        &nbsp;dangerous
                                                        monsters, seek vast
                                                        treasures...
                                                      </div>
                                                    </div>
                                                    <a
                                                      href="#"
                                                      className="l_btn_primary w-button"
                                                    >
                                                      $29.99
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>





                            </div>
                          </div>
                          <div className="xccz xccz--rel">
                            <div className="x_contentimage">
                              <div className="x_contentimage_tint">
                                <section
                                  id="xsbm_login_w1"
                                  className="x_temp_tint_1 x_temp_tint_1--dark"
                                />
                              </div>
                              <div className="x_contentimage_static">
                                <div className="x_temp_pic1" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>





                    </div>
                  </div>
  )}





                export const SBlnch1 =({}) => {
                  return (

                  <div className="p_x_module0">
                    <h1 className="p_x_h1_graphic">Launcher</h1>
                    <div id="login0" className="p_x_module_grid">
                      <div className="l_sb0">
                        <div id="l_gamepage" className="p_x_anchor" />
                        <div className="x_left0">
                          <div className="x_left0_sticky">
                            <div className="xsb_sett_block">
                              <div className="xx_set_head xx_set_head--main">
                                <div>
                                  <div data-xsb-settings-module-onoff="w_pack1">
                                    <div className="t_h2 t_bold">Home page</div>
                                  </div>
                                </div>
                              </div>
                              <div
                                data-xsb-settings-module="onoff"
                                data-xsb-settings-module-onoff-activetarget="w_buy"
                                className="xx_set_sect xx_set_sect--bg"
                              >
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Only one can be selected</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b inactive">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Send to friend</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="x_right0">
                          <div className="x_flex x_flex--center">
                            <div
                              data-xsb-template-type="ps_card"
                              className="xsb_c"
                            >
                              <div className="p_formgroup_xlg p_formgroup_xlg--top">
                                <div className="xsbps_b xsbps_b--rel">
                                  <div className="xsbps_bd x_launcher_ws">
                                    <div className="xccz lh_bg">
                                      <div className="x_contentimage">
                                        <div className="x_contentimage_tint">
                                          <div className="x_temp_tint_1" />
                                        </div>
                                        <div
                                          data-xsb-bg="pic"
                                          className="xsb_bg_static xsb_bg_static--xsolla3"
                                        />
                                      </div>
                                    </div>
                                    <div className="xsbps_topmenu l_header">
                                      <div className="xsbps_topmenu_block lh_actions">
                                        <div className="l_text_caption secondary">
                                          Xsolla Inc.
                                        </div>
                                        <div className="l_block_window-actions">
                                          <a
                                            href="#"
                                            className="l_btn_window-close minimize w-button"
                                          >
                                            Button Text
                                          </a>
                                          <a
                                            href="#"
                                            className="l_btn_window-close expand w-button"
                                          >
                                            Button Text
                                          </a>
                                          <a
                                            href="#"
                                            className="l_btn_window-close w-button"
                                          >
                                            Button Text
                                          </a>
                                        </div>
                                      </div>
                                      <div className="xsbps_topmenu_block lh_nb">
                                        <div className="l_block_nb-tabs">
                                          <div className="l_btn_tab active">
                                            <div>Home</div>
                                          </div>
                                          <div className="l_btn_tab">
                                            <div>Games</div>
                                          </div>
                                          <div className="l_btn_tab">
                                            <div>News</div>
                                          </div>
                                        </div>
                                        <div className="l_block_window-actions">
                                          <div className="l_ico_status-dot" />
                                          <div>John Doe</div>
                                          <div className="l_ico_chevron" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="l_container_inner-layout scroll">
                                      <div className="xsbps_column left">
                                        <div className="p_formgroup_lg lh_formgroup">
                                          <div className="l_image_pub-logoxl">
                                            <div className="l_image_pub-logo" />
                                          </div>
                                          <div className="l_container_homepage-slider">
                                            <div className="l_container_homepage-slider-bg">
                                              <div className="l_btn_slider-switch">
                                                <div className="l_ico_chevron left" />
                                              </div>
                                              <div className="l_btn_slider-switch right">
                                                <div className="l_ico_chevron right" />
                                              </div>
                                              <div className="l_block_homepage-slider w-row">
                                                <div className="l_l-block_homepage-slider w-col w-col-7">
                                                  <div
                                                    data-poster-url="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-poster-00001.jpg"
                                                    data-video-urls="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.mp4,https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.webm"
                                                    data-autoplay="true"
                                                    data-loop="true"
                                                    data-wf-ignore="true"
                                                    className="background-video w-background-video w-background-video-atom"
                                                  >
                                                    <video
                                                      autoPlay
                                                      loop
                                                      style={{
                                                        backgroundImage:
                                                          'url("https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-poster-00001.jpg")'
                                                      }}
                                                      muted
                                                      playsInline
                                                      data-wf-ignore="true"
                                                      data-object-fit="cover"
                                                    >
                                                      <source
                                                        src="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.mp4"
                                                        data-wf-ignore="true"
                                                      />
                                                      <source
                                                        src="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.webm"
                                                        data-wf-ignore="true"
                                                      />
                                                    </video>
                                                  </div>
                                                </div>
                                                <div className="l_r-block_homepage-slider w-col w-col-5">
                                                  <div className="l_v-block">
                                                    <div className="l_text_caption secondary l_margin-b_10">
                                                      Featured game
                                                    </div>
                                                    <div className="l_text_h1 l_margin-b_10">
                                                      Xsollus
                                                    </div>
                                                    <div className="l_text_caption secondary">
                                                      Embark on a sweeping
                                                      adventure across the
                                                      Permlands as you draw your
                                                      sword against dangerous
                                                      monsters, seek vast
                                                      treasures, and brave
                                                      perilous danger.
                                                    </div>
                                                  </div>
                                                  <div className="l_h-block">
                                                    <a
                                                      href="#"
                                                      className="l_btn_primary l_margin-r_12 w-button"
                                                    >
                                                      $29.99
                                                    </a>
                                                    <a
                                                      href="#"
                                                      className="l_btn_secondary w-button"
                                                    >
                                                      Redeem key
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="p_formgroup_lg lh_formgroup">
                                          <div className="l_h-block l_margin-b_24">
                                            <div className="l_text_label">
                                              recent updates
                                            </div>
                                            <div className="l_ico_chevron right" />
                                          </div>
                                          <div className="xsbps_block">
                                            <div className="xsbps_block_grid l_news-h-list">
                                              <div className="l_image_news-card">
                                                <div className="l_image_news-card-bg">
                                                  <div className="l_image_news-image" />
                                                </div>
                                                <div className="l_text_caption secondary l_margin-b_10">
                                                  September 1, 2019
                                                </div>
                                                <div className="l_text_h2">
                                                  Xsolla and Keymailer
                                                  Partnership Takes Influencer
                                                  Programs to a New Level
                                                </div>
                                              </div>
                                              <div className="l_image_news-card">
                                                <div className="l_image_news-card-bg">
                                                  <div className="l_image_news-image" />
                                                </div>
                                                <div className="l_text_caption secondary l_margin-b_10">
                                                  September 1, 2019
                                                </div>
                                                <div className="l_text_h2">
                                                  Xsolla and Keymailer
                                                  Partnership Takes Influencer
                                                  Programs to a New Level
                                                </div>
                                              </div>
                                              <div className="l_image_news-card">
                                                <div className="l_image_news-card-bg">
                                                  <div className="l_image_news-image" />
                                                </div>
                                                <div className="l_text_caption secondary l_margin-b_10">
                                                  September 1, 2019
                                                </div>
                                                <div className="l_text_h2">
                                                  Xsolla and Keymailer
                                                  Partnership Takes Influencer
                                                  Programs to a New Level
                                                </div>
                                              </div>
                                              <div className="l_image_news-card">
                                                <div className="l_image_news-card-bg">
                                                  <div className="l_image_news-image" />
                                                </div>
                                                <div className="l_text_caption secondary l_margin-b_10">
                                                  September 1, 2019
                                                </div>
                                                <div className="l_text_h2">
                                                  Xsolla and Keymailer
                                                  Partnership Takes Influencer
                                                  Programs to a New Level
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="p_formgroup_lg lh_formgroup">
                                          <div className="l_text_label l_margin-b_24">
                                            NEW games
                                          </div>
                                          <div className="xsbps_block">
                                            <div className="xsbps_block_grid l_news-h-list">
                                              <div className="l_container_newgames-card">
                                                <div className="l_image_game-image">
                                                  <div className="l_block_title-bg">
                                                    <div className="l_text_h1">
                                                      Game title 01
                                                    </div>
                                                    <a
                                                      href="#"
                                                      className="l_btn_primary w-button"
                                                    >
                                                      $29.99
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="l_container_newgames-card">
                                                <div className="l_image_game-image">
                                                  <div className="l_block_title-bg">
                                                    <div className="l_text_h1">
                                                      Game title 02
                                                    </div>
                                                    <a
                                                      href="#"
                                                      className="l_btn_primary w-button"
                                                    >
                                                      $29.99
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="p_formgroup_lg lh_formgroup lh_formgroup-lastchild">
                                          <div className="l_text_label l_margin-b_24">
                                            All games
                                          </div>
                                          <div className="xsbps_block l_agame-row">
                                            <div className="xsbps_block_grid l_news-h-list">
                                              <div className="l_container_allgames-card-bg">
                                                <div className="l_container_allgames-card">
                                                  <div className="l_image_allgames-card">
                                                    <div className="l_image_game-image" />
                                                  </div>
                                                  <div className="l_block_allgames-description">
                                                    <div className="l_v-block">
                                                      <div className="l_text_h1 l_margin-b_10">
                                                        Xsollus
                                                      </div>
                                                      <div className="l_text_description">
                                                        Embark on a sweeping
                                                        adventure across the
                                                        Permlands as you draw
                                                        your sword against
                                                        &nbsp;dangerous
                                                        monsters, seek vast
                                                        treasures...
                                                      </div>
                                                    </div>
                                                    <a
                                                      href="#"
                                                      className="l_btn_primary w-button"
                                                    >
                                                      $29.99
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="l_container_allgames-card-bg">
                                                <div className="l_container_allgames-card">
                                                  <div className="l_image_allgames-card">
                                                    <div className="l_image_game-image" />
                                                  </div>
                                                  <div className="l_block_allgames-description">
                                                    <div className="l_v-block">
                                                      <div className="l_text_h1 l_margin-b_10">
                                                        Xsollus
                                                      </div>
                                                      <div className="l_text_description">
                                                        Embark on a sweeping
                                                        adventure across the
                                                        Permlands as you draw
                                                        your sword against
                                                        &nbsp;dangerous
                                                        monsters, seek vast
                                                        treasures...
                                                      </div>
                                                    </div>
                                                    <a
                                                      href="#"
                                                      className="l_btn_primary w-button"
                                                    >
                                                      $29.99
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="l_container_allgames-card-bg">
                                                <div className="l_container_allgames-card">
                                                  <div className="l_image_allgames-card">
                                                    <div className="l_image_game-image" />
                                                  </div>
                                                  <div className="l_block_allgames-description">
                                                    <div className="l_v-block">
                                                      <div className="l_text_h1 l_margin-b_10">
                                                        Xsollus
                                                      </div>
                                                      <div className="l_text_description">
                                                        Embark on a sweeping
                                                        adventure across the
                                                        Permlands as you draw
                                                        your sword against
                                                        &nbsp;dangerous
                                                        monsters, seek vast
                                                        treasures...
                                                      </div>
                                                    </div>
                                                    <a
                                                      href="#"
                                                      className="l_btn_primary w-button"
                                                    >
                                                      $29.99
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>


                              {/* <div className="p_formgroup_xlg p_formgroup_xlg--top">
                                <div className="xsbps_b xsbps_b--rel">
                                  <div className="xsbps_bd x_launcher_ws">
                                    <div className="xccz lh_bg">
                                      <div className="x_contentimage">
                                        <div className="x_contentimage_tint">
                                          <div className="x_temp_tint_1" />
                                        </div>
                                        <div
                                          data-xsb-bg="pic"
                                          className="xsb_bg_static xsb_bg_static--xsolla3"
                                        />
                                      </div>
                                    </div>
                                    <div className="xsbps_topmenu l_header">
                                      <div className="xsbps_topmenu_block lh_actions">
                                        <div className="l_text_caption secondary">
                                          Xsolla Inc.
                                        </div>
                                        <div className="l_block_window-actions">
                                          <a
                                            href="#"
                                            className="l_btn_window-close minimize w-button"
                                          >
                                            Button Text
                                          </a>
                                          <a
                                            href="#"
                                            className="l_btn_window-close expand w-button"
                                          >
                                            Button Text
                                          </a>
                                          <a
                                            href="#"
                                            className="l_btn_window-close w-button"
                                          >
                                            Button Text
                                          </a>
                                        </div>
                                      </div>
                                      <div className="xsbps_topmenu_block lh_nb">
                                        <div className="l_block_nb-tabs">
                                          <div className="l_btn_tab">
                                            <div>Home</div>
                                          </div>
                                          <div className="l_btn_tab active">
                                            <div>Games</div>
                                          </div>
                                          <div className="l_btn_tab">
                                            <div>News</div>
                                          </div>
                                        </div>
                                        <div className="l_block_window-actions">
                                          <div className="l_ico_status-dot" />
                                          <div>John Doe</div>
                                          <div className="l_ico_chevron" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="l_container_inner-layout">
                                      <div className="l_sidebar">
                                        <div className="l_sidebar_tab active">
                                          <div className="l_ico_sidebar-icon">
                                            <div className="l_image_game-logo" />
                                          </div>
                                          <div>Xsollus</div>
                                        </div>
                                        <div className="l_sidebar_tab">
                                          <div className="l_ico_sidebar-icon">
                                            <div className="l_image_game-logo _2" />
                                          </div>
                                          <div>Xsollus</div>
                                        </div>
                                        <div className="l_sidebar_tab">
                                          <div className="l_ico_sidebar-icon">
                                            <div className="l_image_game-logo _3" />
                                          </div>
                                          <div>Xsollus</div>
                                        </div>
                                        <div className="l_ico_pub-logo">
                                          <div className="l_image_pub-logo" />
                                        </div>
                                      </div>
                                      <div className="l_block_game">
                                        <div className="l_block_game-logo">
                                          <div className="l_image_game-logo-l">
                                            <div className="l_image_game-logo" />
                                          </div>
                                        </div>
                                        <div className="l_block_banner-group">
                                          <div className="l_block_banner">
                                            <div
                                              data-poster-url="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-poster-00001.jpg"
                                              data-video-urls="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.mp4,https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.webm"
                                              data-autoplay="true"
                                              data-loop="true"
                                              data-wf-ignore="true"
                                              className="background-video w-background-video w-background-video-atom"
                                            >
                                              <video
                                                autoPlay
                                                loop
                                                style={{
                                                  backgroundImage:
                                                    'url("https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-poster-00001.jpg")'
                                                }}
                                                muted
                                                playsInline
                                                data-wf-ignore="true"
                                                data-object-fit="cover"
                                              >
                                                <source
                                                  src="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.mp4"
                                                  data-wf-ignore="true"
                                                />
                                                <source
                                                  src="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.webm"
                                                  data-wf-ignore="true"
                                                />
                                              </video>
                                              <div className="l_block_title-bg">
                                                <div className="l_text_h1">
                                                  Xsollus trailer
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="l_block_banner small">
                                            <div className="l_image_news-image">
                                              <div className="l_block_title-bg">
                                                <div className="l_text_h1">
                                                  Patch Notes 1.0
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="l_block_game-btn-group">
                                          <a
                                            href="#"
                                            className="l_btn_secondary l_margin-r_12 l_margin-l_auto w-button"
                                          >
                                            Redeem key
                                          </a>
                                          <div className="l_btn_secondary">
                                            <div>Options</div>
                                            <div className="l_ico_chevron" />
                                          </div>
                                        </div>
                                        <div className="l_block_game-btn-group">
                                          <a
                                            href="#"
                                            className="l_btn_primary big w-button"
                                          >
                                            install
                                          </a>
                                        </div>
                                        <div className="l_footer">
                                          <div className="l_text_caption secondary l_margin-r_12">
                                            Xsolla Inc.
                                          </div>
                                          <div className="l_text_caption">
                                            Support
                                          </div>
                                          <div className="l_text_caption secondary l_margin-r_12 l_margin-l_auto l_margin-l_auto">
                                            Region
                                          </div>
                                          <div className="l_text_caption">
                                            North America
                                          </div>
                                          <div className="l_ico_chevron" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> */}



                              <div className="p_formgroup_xlg p_formgroup_xlg--top">
                                <div className="xsbps_b xsbps_b--rel">
                                  <div className="xsbps_bd x_launcher_ws">
                                    <div className="xccz lh_bg">
                                      <div className="x_contentimage">
                                        <div className="x_contentimage_tint">
                                          <div className="x_temp_tint_1" />
                                        </div>
                                        <div
                                          data-xsb-bg="pic"
                                          className="xsb_bg_static xsb_bg_static--xsolla3"
                                        />
                                      </div>
                                    </div>
                                    <div className="xsbps_topmenu l_header">
                                      <div className="xsbps_topmenu_block lh_actions">
                                        <div className="l_text_caption secondary">
                                          Xsolla Inc.
                                        </div>
                                        <div className="l_block_window-actions">
                                          <a
                                            href="#"
                                            className="l_btn_window-close minimize w-button"
                                          >
                                            Button Text
                                          </a>
                                          <a
                                            href="#"
                                            className="l_btn_window-close expand w-button"
                                          >
                                            Button Text
                                          </a>
                                          <a
                                            href="#"
                                            className="l_btn_window-close w-button"
                                          >
                                            Button Text
                                          </a>
                                        </div>
                                      </div>
                                      <div className="xsbps_topmenu_block lh_nb">
                                        <div className="l_block_nb-tabs">
                                          <div className="l_btn_tab">
                                            <div>Home</div>
                                          </div>
                                          <div className="l_btn_tab">
                                            <div>Games</div>
                                          </div>
                                          <div className="l_btn_tab active">
                                            <div>News</div>
                                          </div>
                                        </div>
                                        <div className="l_block_window-actions">
                                          <div className="l_ico_status-dot" />
                                          <div>John Doe</div>
                                          <div className="l_ico_chevron" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="l_container_inner-layout">
                                      <div className="l_sidebar">
                                        <div className="l_sidebar_tab active">
                                          <div>All news</div>
                                        </div>
                                        <div className="l_sidebar_tab">
                                          <div className="l_ico_sidebar-icon">
                                            <div className="l_image_game-logo" />
                                          </div>
                                          <div>Xsollus</div>
                                        </div>
                                        <div className="l_sidebar_tab">
                                          <div className="l_ico_sidebar-icon">
                                            <div className="l_image_game-logo _2" />
                                          </div>
                                          <div>Xsollus</div>
                                        </div>
                                        <div className="l_sidebar_tab">
                                          <div className="l_ico_sidebar-icon">
                                            <div className="l_image_game-logo _3" />
                                          </div>
                                          <div>Xsollus</div>
                                        </div>
                                        <div className="l_ico_pub-logo" />
                                        <div className="l_ico_pub-logo">
                                          <div className="l_image_pub-logo" />
                                        </div>
                                      </div>
                                      <div className="l_container_inner-layout scroll">
                                        <div className="l_block_news-column">
                                          <div
                                            data-animation="slide"
                                            data-duration={500}
                                            data-infinite={1}
                                            className="slider w-slider"
                                          >
                                            <div className="w-slider-mask">
                                              <div
                                                className="w-slide"
                                                style={{
                                                  transform: "translateX(0px)",
                                                  opacity: 1
                                                }}
                                              >
                                                <div className="div-block-50" />
                                              </div>
                                              <div
                                                className="w-slide"
                                                style={{
                                                  transform: "translateX(0px)",
                                                  opacity: 1
                                                }}
                                              />
                                            </div>
                                            <div className="left-arrow w-slider-arrow-left">
                                              <div className="w-icon-slider-left" />
                                            </div>
                                            <div className="right-arrow w-slider-arrow-right">
                                              <div className="w-icon-slider-right" />
                                            </div>
                                            <div className="w-slider-nav w-round">
                                              <div
                                                className="w-slider-dot w-active"
                                                data-wf-ignore
                                              />
                                              <div
                                                className="w-slider-dot"
                                                data-wf-ignore
                                              />
                                            </div>
                                          </div>
                                          <div className="l_h-block news">
                                            <div className="l_image_news-list">
                                              <div className="l_image_news-image" />
                                            </div>
                                            <div className="l_v-block news">
                                              <div className="l_text_caption secondary l_margin-b_10">
                                                September 1, 2019
                                              </div>
                                              <div className="l_text_h2 l_margin-b_10">
                                                Xsolla and Keymailer Partnership
                                                Takes Influencer Programs to a
                                                New Level
                                              </div>
                                              <div className="l_text_description secondary">
                                                Combining Affiliate Sales with
                                                Influencers
                                              </div>
                                            </div>
                                          </div>
                                          <div className="l_h-block news">
                                            <div className="l_image_news-list">
                                              <div className="l_image_news-image" />
                                            </div>
                                            <div className="l_v-block news">
                                              <div className="l_text_caption secondary l_margin-b_10">
                                                September 1, 2019
                                              </div>
                                              <div className="l_text_h2 l_margin-b_10">
                                                Xsolla and Keymailer Partnership
                                                Takes Influencer Programs to a
                                                New Level
                                              </div>
                                              <div className="l_text_description secondary">
                                                Combining Affiliate Sales with
                                                Influencers
                                              </div>
                                            </div>
                                          </div>
                                          <div className="l_h-block news">
                                            <div className="l_image_news-list">
                                              <div className="l_image_news-image" />
                                            </div>
                                            <div className="l_v-block news">
                                              <div className="l_text_caption secondary l_margin-b_10">
                                                September 1, 2019
                                              </div>
                                              <div className="l_text_h2 l_margin-b_10">
                                                Xsolla and Keymailer Partnership
                                                Takes Influencer Programs to a
                                                New Level
                                              </div>
                                              <div className="l_text_description secondary">
                                                Combining Affiliate Sales with
                                                Influencers
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>



                            </div>
                          </div>
                          <div className="xccz xccz--rel">
                            <div className="x_contentimage">
                              <div className="x_contentimage_tint">
                                <section
                                  id="xsbm_login_w1"
                                  className="x_temp_tint_1 x_temp_tint_1--dark"
                                />
                              </div>
                              <div className="x_contentimage_static">
                                <div className="x_temp_pic1" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="launcher_monogame" className="l_sb0">
                        <div id="l_gamepage" className="p_x_anchor" />
                        <div className="x_left0">
                          <div className="x_left0_sticky">
                            <div className="xsb_sett_block">
                              <div className="xx_set_head xx_set_head--main">
                                <div>
                                  <div data-xsb-settings-module-onoff="w_pack1">
                                    <div className="t_h2 t_bold">Home page</div>
                                  </div>
                                </div>
                              </div>
                              <div
                                data-xsb-settings-module="onoff"
                                data-xsb-settings-module-onoff-activetarget="w_buy"
                                className="xx_set_sect xx_set_sect--bg"
                              >
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Only one can be selected</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                                  <div className="l_width100">
                                    <div className="xsb_sett_toggle0">
                                      <div className="xsb_sett_toggle_b inactive">
                                        <div className="xsb_sett_toggle_t" />
                                      </div>
                                      <div
                                        data-xsb-settings-module-onoff="hero_w_logo"
                                        className="xsb_sett_toggle_label"
                                      >
                                        <div>Send to friend</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="x_right0">
                          <div className="x_flex x_flex--center">
                            <div
                              data-xsb-template-type="ps_card"
                              className="xsb_c"
                            >
                              <div className="p_formgroup_xlg p_formgroup_xlg--top">
                                <div className="xsbps_b xsbps_b--rel">
                                  <div className="xsbps_bd x_launcher_ws">
                                    <div className="xccz lh_bg">
                                      <div className="x_contentimage">
                                        <div className="x_contentimage_tint">
                                          <div className="x_temp_tint_1" />
                                        </div>
                                        <div
                                          data-xsb-bg="pic"
                                          className="xsb_bg_static xsb_bg_static--xsolla3"
                                        />
                                      </div>
                                    </div>
                                    <div className="xsbps_topmenu l_header">
                                      <div className="xsbps_topmenu_block lh_actions">
                                        <div className="l_text_caption secondary">
                                          Xsolla Inc.
                                        </div>
                                        <div className="l_block_window-actions">
                                          <a
                                            href="#"
                                            className="l_btn_window-close minimize w-button"
                                          >
                                            Button Text
                                          </a>
                                          <a
                                            href="#"
                                            className="l_btn_window-close expand w-button"
                                          >
                                            Button Text
                                          </a>
                                          <a
                                            href="#"
                                            className="l_btn_window-close w-button"
                                          >
                                            Button Text
                                          </a>
                                        </div>
                                      </div>
                                      <div className="xsbps_topmenu_block lh_nb">
                                        <div className="l_block_nb-tabs">
                                          <div className="l_btn_tab active">
                                            <div>Game</div>
                                          </div>
                                          <div className="l_btn_tab">
                                            <div>News</div>
                                          </div>
                                        </div>
                                        <div className="l_block_window-actions">
                                          <div className="l_ico_status-dot" />
                                          <div>John Doe</div>
                                          <div className="l_ico_chevron" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="l_container_inner-layout">
                                      <div className="l_block_game">
                                        <div className="l_block_game-logo">
                                          <div className="l_image_game-logo-l">
                                            <div className="l_image_game-logo" />
                                          </div>
                                        </div>
                                        <div className="l_block_banner-group">
                                          <div className="l_block_banner">
                                            <div
                                              data-poster-url="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-poster-00001.jpg"
                                              data-video-urls="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.mp4,https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.webm"
                                              data-autoplay="true"
                                              data-loop="true"
                                              data-wf-ignore="true"
                                              className="background-video w-background-video w-background-video-atom"
                                            >
                                              <video
                                                autoPlay
                                                loop
                                                style={{
                                                  backgroundImage:
                                                    'url("https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-poster-00001.jpg")'
                                                }}
                                                muted
                                                playsInline
                                                data-wf-ignore="true"
                                                data-object-fit="cover"
                                              >
                                                <source
                                                  src="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.mp4"
                                                  data-wf-ignore="true"
                                                />
                                                <source
                                                  src="https://assets.website-files.com/5d4c791b313d9a187b5e9338/5d552c284d608a811a2d23ac_Xsolla 4K-transcode.webm"
                                                  data-wf-ignore="true"
                                                />
                                              </video>
                                              <div className="l_block_title-bg">
                                                <div className="l_text_h1">
                                                  Xsollus trailer
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="l_block_banner small">
                                            <div className="l_image_news-image">
                                              <div className="l_block_title-bg">
                                                <div className="l_text_h1">
                                                  Patch Notes 1.0
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="l_block_game-btn-group">
                                          <a
                                            href="#"
                                            className="l_btn_secondary l_margin-r_12 l_margin-l_auto w-button"
                                          >
                                            Redeem key
                                          </a>
                                          <div className="l_btn_secondary">
                                            <div>Options</div>
                                            <div className="l_ico_chevron" />
                                          </div>
                                        </div>
                                        <div className="l_block_game-btn-group">
                                          <div className="l_ico_pub-logo">
                                            <div className="l_image_pub-logo" />
                                          </div>
                                          <a
                                            href="#"
                                            className="l_btn_primary big w-button"
                                          >
                                            install
                                          </a>
                                        </div>
                                        <div className="l_footer">
                                          <div className="l_text_caption secondary l_margin-r_12">
                                            Xsolla Inc.
                                          </div>
                                          <div className="l_text_caption">
                                            Support
                                          </div>
                                          <div className="l_text_caption secondary l_margin-r_12 l_margin-l_auto l_margin-l_auto">
                                            Region
                                          </div>
                                          <div className="l_text_caption">
                                            North America
                                          </div>
                                          <div className="l_ico_chevron" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="p_formgroup_xlg p_formgroup_xlg--top">
                                <div className="xsbps_b xsbps_b--rel">
                                  <div className="xsbps_bd x_launcher_ws">
                                    <div className="xccz lh_bg">
                                      <div className="x_contentimage">
                                        <div className="x_contentimage_tint">
                                          <div className="x_temp_tint_1" />
                                        </div>
                                        <div
                                          data-xsb-bg="pic"
                                          className="xsb_bg_static xsb_bg_static--xsolla3"
                                        />
                                      </div>
                                    </div>
                                    <div className="xsbps_topmenu l_header">
                                      <div className="xsbps_topmenu_block lh_actions">
                                        <div className="l_text_caption secondary">
                                          Xsolla Inc.
                                        </div>
                                        <div className="l_block_window-actions">
                                          <a
                                            href="#"
                                            className="l_btn_window-close minimize w-button"
                                          >
                                            Button Text
                                          </a>
                                          <a
                                            href="#"
                                            className="l_btn_window-close expand w-button"
                                          >
                                            Button Text
                                          </a>
                                          <a
                                            href="#"
                                            className="l_btn_window-close w-button"
                                          >
                                            Button Text
                                          </a>
                                        </div>
                                      </div>
                                      <div className="xsbps_topmenu_block lh_nb">
                                        <div className="l_block_nb-tabs">
                                          <div className="l_btn_tab">
                                            <div>Game</div>
                                          </div>
                                          <div className="l_btn_tab active">
                                            <div>News</div>
                                          </div>
                                        </div>
                                        <div className="l_block_window-actions">
                                          <div className="l_ico_status-dot" />
                                          <div>John Doe</div>
                                          <div className="l_ico_chevron" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="l_container_inner-layout">
                                      <div className="l_container_inner-layout scroll">
                                        <div className="l_block_news-column">
                                          <div
                                            data-animation="slide"
                                            data-duration={500}
                                            data-infinite={1}
                                            className="slider w-slider"
                                          >
                                            <div className="w-slider-mask">
                                              <div
                                                className="w-slide"
                                                style={{
                                                  transform: "translateX(0px)",
                                                  opacity: 1
                                                }}
                                              >
                                                <div className="div-block-50" />
                                              </div>
                                              <div
                                                className="w-slide"
                                                style={{
                                                  transform: "translateX(0px)",
                                                  opacity: 1
                                                }}
                                              />
                                            </div>
                                            <div className="left-arrow w-slider-arrow-left">
                                              <div className="w-icon-slider-left" />
                                            </div>
                                            <div className="right-arrow w-slider-arrow-right">
                                              <div className="w-icon-slider-right" />
                                            </div>
                                            <div className="w-slider-nav w-round">
                                              <div
                                                className="w-slider-dot w-active"
                                                data-wf-ignore
                                              />
                                              <div
                                                className="w-slider-dot"
                                                data-wf-ignore
                                              />
                                            </div>
                                          </div>
                                          <div className="l_h-block news">
                                            <div className="l_image_news-list">
                                              <div className="l_image_news-image" />
                                            </div>
                                            <div className="l_v-block news">
                                              <div className="l_text_caption secondary l_margin-b_10">
                                                September 1, 2019
                                              </div>
                                              <div className="l_text_h2 l_margin-b_10">
                                                Xsolla and Keymailer Partnership
                                                Takes Influencer Programs to a
                                                New Level
                                              </div>
                                              <div className="l_text_description secondary">
                                                Combining Affiliate Sales with
                                                Influencers
                                              </div>
                                            </div>
                                          </div>
                                          <div className="l_h-block news">
                                            <div className="l_image_news-list">
                                              <div className="l_image_news-image" />
                                            </div>
                                            <div className="l_v-block news">
                                              <div className="l_text_caption secondary l_margin-b_10">
                                                September 1, 2019
                                              </div>
                                              <div className="l_text_h2 l_margin-b_10">
                                                Xsolla and Keymailer Partnership
                                                Takes Influencer Programs to a
                                                New Level
                                              </div>
                                              <div className="l_text_description secondary">
                                                Combining Affiliate Sales with
                                                Influencers
                                              </div>
                                            </div>
                                          </div>
                                          <div className="l_h-block news">
                                            <div className="l_image_news-list">
                                              <div className="l_image_news-image" />
                                            </div>
                                            <div className="l_v-block news">
                                              <div className="l_text_caption secondary l_margin-b_10">
                                                September 1, 2019
                                              </div>
                                              <div className="l_text_h2 l_margin-b_10">
                                                Xsolla and Keymailer Partnership
                                                Takes Influencer Programs to a
                                                New Level
                                              </div>
                                              <div className="l_text_description secondary">
                                                Combining Affiliate Sales with
                                                Influencers
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="xccz xccz--rel">
                            <div className="x_contentimage">
                              <div className="x_contentimage_tint">
                                <section
                                  id="xsbm_login_w1"
                                  className="x_temp_tint_1 x_temp_tint_1--dark"
                                />
                              </div>
                              <div className="x_contentimage_static">
                                <div className="x_temp_pic1" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
  )
}

export const SBua =({}) => {
  return (
    <div className="p_x_module0">
    <h1 className="p_x_h1_graphic">User account</h1>
    <div id="ps0" className="p_x_module_grid">
      <div className="l_sb0">
        <div id="ps_methods" className="p_x_anchor" />
        <div className="x_left0">
          <div className="x_left0_sticky">
            <div className="xsb_sett_block">
              <div className="xx_set_head xx_set_head--main">
                <div>
                  <div data-xsb-settings-module-onoff="w_pack1">
                    <div className="t_h2 t_bold">
                      Platforms / email
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-xsb-settings-module="onoff"
                data-xsb-settings-module-onoff-activetarget="w_buy"
                className="xx_set_sect xx_set_sect--bg"
              >
                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                  <div className="l_width100">
                    <div className="xsb_sett_toggle0">
                      <div className="xsb_sett_toggle_b">
                        <div className="xsb_sett_toggle_t" />
                      </div>
                      <div
                        data-xsb-settings-module-onoff="hero_w_logo"
                        className="xsb_sett_toggle_label"
                      >
                        <div>Only one can be selected</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                  <div className="l_width100">
                    <div className="xsb_sett_toggle0">
                      <div className="xsb_sett_toggle_b inactive">
                        <div className="xsb_sett_toggle_t" />
                      </div>
                      <div
                        data-xsb-settings-module-onoff="hero_w_logo"
                        className="xsb_sett_toggle_label"
                      >
                        <div>Send to friend</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="x_right0">
          <div className="x_flex x_flex--center">
            <div
              data-xsb-template-type="ps_card"
              className="xsb_c"
            >
              <div className="p_formgroup_xlg p_formgroup_xlg--top">


                <div className="xsbps_b xsbps_b--rel">
                  <div className="xsbps_bd">
                    <div className="xccz">
                      <div className="x_contentimage">
                        <div className="x_contentimage_tint">
                          <div className="x_temp_tint_1" />
                        </div>
                        <div
                          data-xsb-bg="pic"
                          className="xsb_bg_static xsb_bg_static--xsolla3"
                        />
                      </div>
                    </div>
                    <div className="xsbps_topmenu">
                      <div className="xsbps_block" />
                      <div className="xsbps_topmenu_x0">
                        <div className="xsbps_topmenu_balance">
                          <div className="xsbps_topmenu_balance_add">
                            <div>+</div>
                          </div>
                          <div className="xsbps_topmenu_balance_text">
                            120
                          </div>
                        </div>
                        <div className="xsbps_topmenu_close" />
                      </div>
                    </div>
                    <div className="xsbps_inner">
                      <div className="xsbps_inner1">
                        <div className="xsbps_column left">
                          <div className="p_formgroup_lg">
                            <div className="p_formgroup_lg">
                              <div className="t_h2 t_bold">
                                <div>Orders</div>
                              </div>
                            </div>
                            <div className="xsbps_block" />
                          </div>
                          <div className="p_formgroup_lg">
                            <div className="xsbps_block">
                              <div className="l_flex l_flex--right">
                                <div className="button_primary x_radius button_primary--disabled">
                                  <div>Next</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="xccz">
                        <div className="x_contentimage">
                          <div className="x_contentimage_tint">
                            <div className="x_temp_tint_ps">
                              <div className="xbm_accentbg xbm_accentbg--top" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="xsbps_foo0">
                      <div className="xsbps_footer">
                        <div className="xsbps_footer_block links">
                          <div>
                            Xsolla is an authorized video game
                            software distributor providing
                            clients with advanced technical
                            tools for their games.
                          </div>
                          <div className="xsbps_footer_linkblock">
                            <a
                              href="#"
                              className="xsbps_footer_link_block first w-inline-block"
                            >
                              <div>Contact Us</div>
                            </a>
                            <a
                              href="#"
                              className="xsbps_footer_link_block w-inline-block"
                            >
                              <div>Privacy Policy</div>
                            </a>
                            <a
                              href="#"
                              className="xsbps_footer_link_block w-inline-block"
                            >
                              <div>User Agreement</div>
                            </a>
                          </div>
                        </div>
                        <div className="xsbps_footer_block lock">
                          <div>
                            Xsolla, 2018
                            <br />
                            Secure connection
                          </div>
                        </div>
                        <div className="xccz">
                          <div className="x_contentimage">
                            <div className="x_contentimage_tint">
                              <div className="x_temp_foo">
                                <div className="xbm_accentbg xbm_accentbg--top" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="temp_settings-2" />
            </div>
          </div>
          <div className="xccz xccz--rel">
            <div className="x_contentimage">
              <div className="x_contentimage_tint">
                <section
                  id="xsbm_login_w1"
                  className="x_temp_tint_1 x_temp_tint_1--dark"
                />
              </div>
              <div className="x_contentimage_static">
                <div className="x_temp_pic1" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  )
}